webpackJsonp([1],{

/***/ "0DNl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "302j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3PBY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Trk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4WAc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Hwp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CVf3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DX21":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EQtd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ex+Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GfHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gql0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HIiL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUT7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JeZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jm7l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ka38":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MmtX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/ToolbarNotification.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @description Display for system notifications for the logged in user
 *
 * @fires GET /managed/resourceName/ID?_fields=_notifications/* - Retrieve all notifications for a specific resource
 * @fires DELETE /internal/notification - Remove one specific notification based on the notifications ID
 * @fires POST /notification?_action=deleteNotificationsForTarget&target=Id - Removes all notifications for a resource (e.g. managed/user/userID)
 *
 **/
/* harmony default export */ var ToolbarNotification = ({
    name: 'Toolbar-Notification',
    data: function data() {
        return {
            notifications: [],
            timeoutId: null
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    filters: {
        cleanDate: function cleanDate(value) {
            return moment_default.a.utc(value).format('LLL') + ' UTC';
        }
    },
    methods: {
        resetPolling: function resetPolling() {
            /* istanbul ignore next */
            if (!lodash_default.a.isNull(this.timeoutId)) {
                clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
        },
        startPolling: function startPolling() {
            var _this = this;

            var pollingDelay = 3000;

            /* istanbul ignore next */
            this.timeoutId = lodash_default.a.delay(function () {
                _this.loadData();
            }, pollingDelay);
        },
        clearAll: function clearAll() {
            var _this2 = this;

            this.notifications = [];

            var internalUser = this.$root.userStore.state.internalUser,
                target = internalUser ? 'internal/user/openidm-admin' : this.$root.userStore.state.managedResource + '/' + this.$root.userStore.state.userId;

            /* istanbul ignore next */
            this.resetPolling();

            /* istanbul ignore next */
            this.getRequestService().post('/notification?_action=deleteNotificationsForTarget&target=' + target).then(function () {
                _this2.displayNotification('success', _this2.$t('pages.app.notifications.removedAll'));

                if (lodash_default.a.isNull(_this2.timeoutId)) {
                    _this2.startPolling();
                }
            }).catch(function () {
                _this2.displayNotification('error', _this2.$t('pages.app.notifications.failedToClear'));
            });
        },
        clearOne: function clearOne(index) {
            var _this3 = this;

            var notificationId = this.notifications[index]._id;

            /* istanbul ignore next */
            this.resetPolling();

            this.notifications.splice(index, 1);
            /* istanbul ignore next */
            this.getRequestService().delete('/internal/notification/' + notificationId).then(function () {
                _this3.displayNotification('success', _this3.$t('pages.app.notifications.removed'));

                if (lodash_default.a.isNull(_this3.timeoutId)) {
                    _this3.startPolling();
                }
            }).catch(function () {
                _this3.displayNotification('error', _this3.$t('pages.app.notifications.failedToRemove'));
            });
        },
        loadData: function loadData() {
            var _this4 = this;

            /* istanbul ignore next */
            if (!lodash_default.a.isNull(this.$root.userStore.state.userId)) {
                this.getRequestService().get('/' + this.$root.userStore.state.managedResource + '/' + this.$root.userStore.state.userId + '?_fields=_notifications/*').then(function (_ref) {
                    var data = _ref.data;

                    if (data._notifications) {
                        _this4.notifications = data._notifications;
                    } else {
                        _this4.notifications = [];
                    }

                    _this4.startPolling();
                }).catch(function () {});
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e467feb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ToolbarNotification.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{staticClass:"fr-notification-icon align-self-center mr-4",attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-bell mr-2"}),_vm._v(" "),(_vm.notifications.length > 0)?_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v(_vm._s(_vm.notifications.length))]):_vm._e()]),_vm._v(" "),_c('b-dropdown-header',{staticClass:"border-bottom py-3"},[_c('div',{staticClass:"fr-notification-header"},[_c('span',[_vm._v(_vm._s(_vm.$t('pages.app.notifications.title'))+" ("+_vm._s(_vm.notifications.length)+")")]),_vm._v(" "),(_vm.notifications.length > 0)?_c('a',{staticClass:"pull-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.clearAll()}}},[_vm._v(_vm._s(_vm.$t('pages.app.notifications.clearAll')))]):_vm._e()])]),_vm._v(" "),(_vm.notifications.length > 0)?[_c("transition-group",{tag:"div",staticClass:"scrollbox",attrs:{"name":"notification-list"}},_vm._l((_vm.notifications),function(notification,index){return _c('div',{key:notification._id,class:[{ 'border-bottom': (index + 1) < _vm.notifications.length }, 'dropdown-item', 'py-3', 'fr-notification-item']},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-body"},[_c('h6',{staticClass:"my-0"},[_vm._v(_vm._s(notification.message))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("cleanDate")(notification.createDate)))])]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-link my-auto",attrs:{"variant":"sm","type":"button"},on:{"click":function($event){$event.preventDefault();_vm.clearOne(index)}}},[_c('i',{staticClass:"fa fa-trash text-muted"})])],1)])}))]:[_c('div',{staticClass:"mt-4 mb-3 fr-no-notifications fr-notification-item"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-body align-self-center"},[_c('h6',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('pages.app.notifications.noNotifications')))])])])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var utils_ToolbarNotification = (esExports);
// CONCATENATED MODULE: ./src/components/utils/ToolbarNotification.vue
function injectStyle (ssrContext) {
  __webpack_require__("bXap")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ToolbarNotification,
  utils_ToolbarNotification,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_utils_ToolbarNotification = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
    name: 'App',
    components: {
        'fr-notification': components_utils_ToolbarNotification
    },
    data: function data() {
        return {
            toggled: false
        };
    },
    methods: {
        onToggle: function onToggle() {
            this.toggled = !this.toggled;
        },
        accessIcon: function accessIcon(icon) {
            var iconClass = 'fa fa-fw mr-3 ';

            if (icon.length) {
                iconClass = iconClass + icon;
            } else {
                iconClass = iconClass + 'fa-cube';
            }

            return iconClass;
        }
    },
    filters: {
        capitalize: function capitalize(value) {
            return lodash_default.a.capitalize(value);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748e2e95","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:[{'toggled': _vm.toggled && !this.$route.meta.hideToolbar}],attrs:{"id":"wrapper"}},[(!this.$route.meta.hideToolbar && this.$root.userStore.state.userId !== null)?_c('div',{attrs:{"id":"appSidebarWrapper"}},[_c('ul',{staticClass:"sidebar-nav"},[_c('li',{staticClass:"sidebar-brand"},[_c('router-link',{staticClass:"d-flex",attrs:{"active-class":"","to":{ name: 'Dashboard'}}},[_c('img',{staticClass:"align-self-center sidebar-brand-logo",staticStyle:{"width":"131px"},attrs:{"src":"static/images/horizontal-logo-white.svg","alt":_vm.$t('common.form.logo')}}),_vm._v(" "),_c('img',{staticClass:"align-self-center sidebar-brand-mark",staticStyle:{"height":"28px"},attrs:{"src":"static/images/vertical-logo-white.svg","alt":_vm.$t('common.form.logo')}})])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Dashboard'}}},[_c('i',{staticClass:"fa fa-fw mr-3 fa-tachometer"}),_c('span',{staticClass:"sidebar-item-text"},[_vm._v(_vm._s(_vm.$t('pages.app.dashboard')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'Profile'}}},[_c('i',{staticClass:"fa fa-fw mr-3 fa-street-view"}),_c('span',{staticClass:"sidebar-item-text"},[_vm._v(_vm._s(_vm.$t('pages.app.profile')))])])],1),_vm._v(" "),(_vm.$root.applicationStore.state.amDataEndpoints && this.$root.userStore.state.internalUser === false)?_c('li',[_c('router-link',{attrs:{"to":{ name: 'Sharing'}}},[_c('i',{staticClass:"fa fa-fw mr-3 fa-share"}),_c('span',{staticClass:"sidebar-item-text"},[_vm._v(_vm._s(_vm.$t('pages.app.sharing')))])])],1):_vm._e(),_vm._v(" "),_vm._l((this.$root.userStore.state.access),function(access,index){return [_c('li',{key:'accessResource' +index},[_c('router-link',{attrs:{"to":{ name: 'ListResource', meta: { title: 'User'}, params: { resourceType: access.privilegePath.split('/')[0],  resourceName: access.privilegePath.split('/')[1]}}}},[_c('i',{class:_vm.accessIcon(access.icon)}),_c('span',{staticClass:"sidebar-item-text"},[_vm._v(_vm._s(access.title))])])],1)]})],2)]):_vm._e(),_vm._v(" "),_c('div',{class:[{'fr-no-toolbar': this.$route.meta.hideToolbar}],attrs:{"id":"appContentWrapper"}},[(!this.$route.meta.hideToolbar && this.$root.userStore.state.userId !== null)?_c('b-navbar',{staticClass:"fr-main-navbar"},[_c('b-nav-form',[_c('b-button',{staticClass:"my-2 my-sm-0 p-0 fr-main-nav-toggle",attrs:{"variant":"link","type":"button"},on:{"click":_vm.onToggle}},[_c('i',{staticClass:"fa fa-bars fa-lg m-0"})])],1),_vm._v(" "),(this.$route.params.resourceName)?_c('b-navbar-brand',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm._f("capitalize")(this.$route.params.resourceName)))]):_vm._e(),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto flex-row"},[_c('fr-notification'),_vm._v(" "),_c('b-nav-item-dropdown',{staticClass:"fr-main-dropdown",attrs:{"right":""}},[_c('template',{slot:"button-content"},[_vm._v("\n                            "+_vm._s(_vm.$t('pages.app.user'))+" "),_c('b-img',{staticClass:"m-1",attrs:{"src":"static/images/profile-default.png","rounded":"circle","width":"24","height":"24","alt":"img"}})],1),_vm._v(" "),_c('b-dropdown-item',{attrs:{"active-class":"fr-no-active","exact-active-class":"fr-no-active","to":{ name: 'Profile'}}},[_vm._v(_vm._s(_vm.$t('pages.app.profile')))]),_vm._v(" "),(this.$root.userStore.state.internalUser)?_c('b-dropdown-item',{attrs:{"href":"/admin"}},[_vm._v(_vm._s(_vm.$t('pages.app.admin')))]):_vm._e(),_vm._v(" "),_c('b-dropdown-divider',{staticClass:"m-0"}),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.preventDefault();_vm.logoutUser()}}},[_vm._v(_vm._s(_vm.$t('pages.app.signOut')))])],2)],1)],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:this.$route.fullPath})],1)],1)]),_vm._v(" "),_c('notifications',{attrs:{"group":"IDMMessages","position":"bottom left","width":"320","duration":4000},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('div',{class:[{ 'alert-success': (props.item.type == 'success'), 'alert-warning': (props.item.type == 'warning'), 'alert-danger': (props.item.type == 'error'), 'alert-info': (props.item.type == 'info')}, 'alert', 'alert-dismissible', 'd-flex', 'p-3', 'pr-5', 'position-relative'],attrs:{"role":"alert"}},[_c('div',{class:[{ 'text-success': (props.item.type == 'success'), 'text-warning': (props.item.type == 'warning'), 'text-danger': (props.item.type == 'error'), 'text-info': (props.item.type == 'info')}, 'alert-icon', 'mr-3', 'align-self-top']},[_c('i',{class:[{ 'fa-check-circle-o': (props.item.type == 'success'), 'fa-exclamation-triangle': (props.item.type == 'warning'), 'fa-times-circle': (props.item.type == 'error'), 'fa-info-circle': (props.item.type == 'info')}, 'fa', 'fa-lg']})]),_vm._v(" "),_c('div',{staticClass:"fr-alert-content align-self-center"},[_c('p',{staticClass:"mb-0 text-left",domProps:{"innerHTML":_vm._s(props.item.text)}})]),_vm._v(" "),_c('a',{staticClass:"close",on:{"click":props.close}},[_c('i',{staticClass:"fa fa-times"})])])]}}])})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("STVR")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 162 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/vue-notification/dist/index.js
var dist = __webpack_require__("CLX7");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vue-spinner/dist/vue-spinner.min.js
var vue_spinner_min = __webpack_require__("YKmE");
var vue_spinner_min_default = /*#__PURE__*/__webpack_require__.n(vue_spinner_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/CenterCard.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Card container that will stay horizontally and vertically center on the screen (example can be found on the default login page)
 *
 **/
/* harmony default export */ var CenterCard = ({
    name: 'Center-Card',
    props: {
        'showLogo': {
            type: Boolean,
            default: false
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20c2fe30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/CenterCard.vue
var CenterCard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"px-0 h-100 d-flex",attrs:{"fluid":""}},[_c('div',{staticClass:"fr-m-auto fr-center-card align-self-center"},[_c('b-card',{staticClass:"border-xs-0 border-sm d-flex fr-stretch-card",attrs:{"no-body":"","header-tag":"header","footer-tag":"footer"}},[_c('b-card-header',{staticClass:"d-flex align-items-center flex-fill"},[_c('div',{staticClass:"d-flex flex-fill flex-column justify-content-center"},[(_vm.showLogo)?_c('b-img',{staticClass:"fr-logo mb-3 mt-2",attrs:{"src":"static/images/vertical-logo.svg","fluid":"","alt":_vm.$t('common.form.logo')}}):_vm._e(),_vm._v(" "),_vm._t("center-card-header")],2)]),_vm._v(" "),_vm._t("center-card-body"),_vm._v(" "),_vm._t("center-card-footer")],2)],1)])}
var CenterCard_staticRenderFns = []
var CenterCard_esExports = { render: CenterCard_render, staticRenderFns: CenterCard_staticRenderFns }
/* harmony default export */ var utils_CenterCard = (CenterCard_esExports);
// CONCATENATED MODULE: ./src/components/utils/CenterCard.vue
function CenterCard_injectStyle (ssrContext) {
  __webpack_require__("MmtX")
}
var CenterCard_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var CenterCard___vue_template_functional__ = false
/* styles */
var CenterCard___vue_styles__ = CenterCard_injectStyle
/* scopeId */
var CenterCard___vue_scopeId__ = "data-v-20c2fe30"
/* moduleIdentifier (server only) */
var CenterCard___vue_module_identifier__ = null
var CenterCard_Component = CenterCard_normalizeComponent(
  CenterCard,
  utils_CenterCard,
  CenterCard___vue_template_functional__,
  CenterCard___vue_styles__,
  CenterCard___vue_scopeId__,
  CenterCard___vue_module_identifier__
)

/* harmony default export */ var components_utils_CenterCard = (CenterCard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/ValidationError.vue
//
//
//
//
//
//

/**
 * @description Component for displaying error message for form fields
 *
 **/
/* harmony default export */ var ValidationError = ({
  name: 'Validation-Error',
  props: ['validatorErrors', 'fieldName']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab1f6f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ValidationError.vue
var ValidationError_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.validatorErrors.has(_vm.fieldName)),expression:"validatorErrors.has(fieldName)"}],staticClass:"fr-validation-requirements text-left"},[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.validatorErrors.first(_vm.fieldName)))])])}
var ValidationError_staticRenderFns = []
var ValidationError_esExports = { render: ValidationError_render, staticRenderFns: ValidationError_staticRenderFns }
/* harmony default export */ var utils_ValidationError = (ValidationError_esExports);
// CONCATENATED MODULE: ./src/components/utils/ValidationError.vue
function ValidationError_injectStyle (ssrContext) {
  __webpack_require__("HUT7")
}
var ValidationError_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ValidationError___vue_template_functional__ = false
/* styles */
var ValidationError___vue_styles__ = ValidationError_injectStyle
/* scopeId */
var ValidationError___vue_scopeId__ = "data-v-2ab1f6f4"
/* moduleIdentifier (server only) */
var ValidationError___vue_module_identifier__ = null
var ValidationError_Component = ValidationError_normalizeComponent(
  ValidationError,
  utils_ValidationError,
  ValidationError___vue_template_functional__,
  ValidationError___vue_styles__,
  ValidationError___vue_scopeId__,
  ValidationError___vue_module_identifier__
)

/* harmony default export */ var components_utils_ValidationError = (ValidationError_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/FloatingLabelInput.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @description Input with a floating label in the center, this will move when a user types into the input (example can be found on the default login page)
 *
 **/
/* harmony default export */ var FloatingLabelInput = ({
    name: 'Floating-Label-Input',
    components: {
        'fr-validation-error': components_utils_ValidationError
    },
    props: {
        label: String,
        type: String,
        autofocus: String,
        fieldName: String,
        validateRules: [String, Object],
        reveal: Boolean,
        showErrorState: { type: Boolean, default: true },
        defaultValue: { required: false }
    },
    inject: ['$validator'],
    data: function data() {
        return {
            inputValue: '',
            id: null,
            floatLabels: false,
            hideLabel: true,
            inputType: this.type,
            show: true
        };
    },
    beforeMount: function beforeMount() {
        this.id = 'floatingLabelInput' + this._uid;
    },
    mounted: function mounted() {
        var _this = this;

        /* istanbul ignore next */
        lodash_default.a.delay(lodash_default.a.bind(function () {
            if (navigator.userAgent.indexOf('Edge') >= 0) {
                if (document.getElementById('' + _this.id).value.length) {
                    _this.floatLabels = true;
                    _this.inputValue = document.getElementById('' + _this.id).value;
                }
            } else if (navigator.userAgent.indexOf('Chrome') >= 0) {
                if (document.querySelectorAll('#' + _this.id + ':-webkit-autofill').length > 0) {
                    _this.floatLabels = true;
                }
            }
            _this.hideLabel = false;
        }, this), 400);

        if (this.defaultValue) {
            this.inputValue = this.defaultValue;
        }

        // Browser consistent focus fix
        if (this.autofocus === 'true') {
            this.$refs.input.focus();
        }
    },

    methods: {
        revealText: function revealText() {
            if (this.inputType === 'password') {
                this.inputType = 'text';
                this.show = false;
            } else {
                this.inputType = 'password';
                this.show = true;
            }
        }
    },
    watch: {
        inputValue: function inputValue(newVal) {
            this.floatLabels = newVal.length > 0;
            this.$emit('input', newVal);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50a9a487","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/FloatingLabelInput.vue
var FloatingLabelInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('div',{ref:"floatingLabelGroup",class:[{'form-label-password': _vm.reveal}, 'form-label-group', 'mb-0']},[((_vm.inputType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"},{name:"validate",rawName:"v-validate",value:(_vm.validateRules),expression:"validateRules"}],ref:"input",class:[{'polyfillPlaceholder': _vm.floatLabels, 'is-invalid': _vm.errors.has(_vm.fieldName) && _vm.showErrorState }, 'form-control'],attrs:{"id":_vm.id,"autofocus":_vm.autofocus,"placeholder":_vm.label,"data-vv-as":_vm.label,"data-vv-validate-on":"submit","name":_vm.fieldName,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.inputValue)?_vm._i(_vm.inputValue,null)>-1:(_vm.inputValue)},on:{"change":function($event){var $$a=_vm.inputValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inputValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inputValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inputValue=$$c}}}}):((_vm.inputType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"},{name:"validate",rawName:"v-validate",value:(_vm.validateRules),expression:"validateRules"}],ref:"input",class:[{'polyfillPlaceholder': _vm.floatLabels, 'is-invalid': _vm.errors.has(_vm.fieldName) && _vm.showErrorState }, 'form-control'],attrs:{"id":_vm.id,"autofocus":_vm.autofocus,"placeholder":_vm.label,"data-vv-as":_vm.label,"data-vv-validate-on":"submit","name":_vm.fieldName,"type":"radio"},domProps:{"checked":_vm._q(_vm.inputValue,null)},on:{"change":function($event){_vm.inputValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"},{name:"validate",rawName:"v-validate",value:(_vm.validateRules),expression:"validateRules"}],ref:"input",class:[{'polyfillPlaceholder': _vm.floatLabels, 'is-invalid': _vm.errors.has(_vm.fieldName) && _vm.showErrorState }, 'form-control'],attrs:{"id":_vm.id,"autofocus":_vm.autofocus,"placeholder":_vm.label,"data-vv-as":_vm.label,"data-vv-validate-on":"submit","name":_vm.fieldName,"type":_vm.inputType},domProps:{"value":(_vm.inputValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value}}}),_vm._v(" "),(_vm.reveal)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.revealText}},[_c('i',{class:[{'fa-eye-slash': !_vm.show}, {'fa-eye': _vm.show}, 'fa']})])]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"hidden":_vm.hideLabel,"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_vm._t("validationError",[_c('fr-validation-error',{attrs:{"validatorErrors":_vm.errors,"fieldName":_vm.fieldName}})])],2)}
var FloatingLabelInput_staticRenderFns = []
var FloatingLabelInput_esExports = { render: FloatingLabelInput_render, staticRenderFns: FloatingLabelInput_staticRenderFns }
/* harmony default export */ var utils_FloatingLabelInput = (FloatingLabelInput_esExports);
// CONCATENATED MODULE: ./src/components/utils/FloatingLabelInput.vue
function FloatingLabelInput_injectStyle (ssrContext) {
  __webpack_require__("yI8e")
}
var FloatingLabelInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var FloatingLabelInput___vue_template_functional__ = false
/* styles */
var FloatingLabelInput___vue_styles__ = FloatingLabelInput_injectStyle
/* scopeId */
var FloatingLabelInput___vue_scopeId__ = "data-v-50a9a487"
/* moduleIdentifier (server only) */
var FloatingLabelInput___vue_module_identifier__ = null
var FloatingLabelInput_Component = FloatingLabelInput_normalizeComponent(
  FloatingLabelInput,
  utils_FloatingLabelInput,
  FloatingLabelInput___vue_template_functional__,
  FloatingLabelInput___vue_styles__,
  FloatingLabelInput___vue_scopeId__,
  FloatingLabelInput___vue_module_identifier__
)

/* harmony default export */ var components_utils_FloatingLabelInput = (FloatingLabelInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/mixins/SelfserviceAPIMixin.vue



/**
 * @description Mixin used for selfservice proceesses handles the general progression through the selfservice stages as well as calling the appropriate loading function
 * That is configured in each specific selfservice process controller.
 *
 * @fires GET selfservice/type (e.g. selfservice/registration) - Gets the initial requirements needed to kick off the selfservice flow.
 * @fires POST/selfservice/type?_action=submitRequirements (e.g. selfservice/registration?_action=submitRequirements) - Calls the selfservice endpoint with the current data for the stage, if the data
 * matches what is expected a new stage will be returned and loaded.
 *
 */
/* harmony default export */ var SelfserviceAPIMixin = ({
    name: 'Selfservice-API',
    methods: {
        loadData: function loadData() {
            var _this = this;

            /* istanbul ignore next */
            var selfServiceInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });
            /* istanbul ignore next */
            selfServiceInstance.get('/selfservice/' + this.apiType).then(function (selfServiceDetails) {
                _this.setChildComponent(selfServiceDetails.data.type, selfServiceDetails.data);
            }).catch(function (error) {
                /*
                    If we are in progressive profiling mode we need to route back to login.
                    This can happen if a user reloads the progressive profile page while
                    in fullStack mode. We need to hit the login route again to start the
                    process over.
                */
                if (lodash_default.a.has(_this.$router.currentRoute, 'params.profileProcess')) {
                    _this.$router.push('/login');
                } else {
                    /* istanbul ignore next */
                    _this.displayNotification('error', error.response.data.message);
                }
            });
        },
        advanceStage: function advanceStage(data, noSessionFalse) {
            var _this2 = this;

            /* istanbul ignore next */
            var headers = this.getAnonymousHeaders();
            /* istanbul ignore next */
            if (noSessionFalse && !this.$root.applicationStore.state.authHeaders) {
                headers = {
                    'X-OpenIDM-NoSession': false,
                    'X-OpenIDM-Password': null,
                    'X-OpenIDM-Username': null
                };
            }

            /* istanbul ignore next */
            var selfServiceInstance = this.getRequestService({
                headers: lodash_default.a.extend(headers, { 'X-Requested-With': 'XMLHttpRequest' })
            }),
                saveData = {
                input: {}
            };

            /* istanbul ignore next */
            if (this.selfServiceDetails && this.selfServiceDetails.token) {
                saveData.token = this.selfServiceDetails.token;
            }
            /* istanbul ignore next */
            if (data.token && data.code) {
                // We know this is from queryParams so set token with the new token value
                saveData.token = data.token;
            }
            /* istanbul ignore next */
            saveData.input = data;
            /* istanbul ignore next */
            if (this.showSelfService) {
                this.showSelfService = false;
            }

            /* istanbul ignore next */
            selfServiceInstance.post('/selfservice/' + this.apiType + '?_action=submitRequirements', saveData).then(function (selfServiceDetails) {
                _this2.setChildComponent(selfServiceDetails.data.type, selfServiceDetails.data);
            }).catch(function (error) {
                if (!lodash_default.a.isUndefined(_this2.apiErrorCallback)) {
                    _this2.apiErrorCallback(error);
                }
            });
        },
        parseQueryParams: function parseQueryParams(queryParams) {
            /*
                example =>
                queryParams = '&token=MY_TOKEN&code=MY_CODE'
                returns {
                    token: 'MY_TOKEN',
                    code: 'MY_CODE'
                }
            */
            if (!queryParams.match('returnParams')) {
                return JSON.parse('{\n                        ' + (decodeURI('"' + queryParams.slice(1).replace(/&/g, '","').replace(/=/g, '":"')) + '"') + '\n                    }');
            } else {
                return { returnParams: lodash_default.a.last(decodeURIComponent(queryParams).split('returnParams=')) };
            }
        }
    }
});
// CONCATENATED MODULE: ./src/components/selfservice/mixins/SelfserviceAPIMixin.vue
var SelfserviceAPIMixin_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var SelfserviceAPIMixin___vue_template_functional__ = false
/* styles */
var SelfserviceAPIMixin___vue_styles__ = null
/* scopeId */
var SelfserviceAPIMixin___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SelfserviceAPIMixin___vue_module_identifier__ = null
var SelfserviceAPIMixin_Component = SelfserviceAPIMixin_normalizeComponent(
  SelfserviceAPIMixin,
  __vue_template__,
  SelfserviceAPIMixin___vue_template_functional__,
  SelfserviceAPIMixin___vue_styles__,
  SelfserviceAPIMixin___vue_scopeId__,
  SelfserviceAPIMixin___vue_module_identifier__
)

/* harmony default export */ var mixins_SelfserviceAPIMixin = (SelfserviceAPIMixin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/SocialButtons.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Controlling component for initializing oauth process for login and registration.
 * This component controls the displaying of the buttons based on which providers are configured.
 *
 * @fires GET authentication - Returns a list of available configured providers.
 * @fires POST identityProviders?_action=getAuthRedirect - Generates the redirect URL used to go to the selected provider and begin the Oauth authentication process
 *
 **/
/* harmony default export */ var SocialButtons = ({
    name: 'Social-Buttons',
    props: {
        'signin': {
            type: Boolean,
            default: false
        },
        'filterProviders': {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        'filterProvidersObjects': {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            providers: [],
            socialButtonStyles: []
        };
    },
    mounted: function mounted() {
        /* istanbul ignore next */
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            /* istanbul ignore next */
            var socialInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });
            /* istanbul ignore next */
            socialInstance.get('/authentication').then(function (response) {
                _this.providers = lodash_default.a.filter(response.data.providers || [], function (provider, index) {
                    if (_this.filterProviders.length === 0 || lodash_default.a.includes(_this.filterProviders, provider.provider)) {
                        return true;
                    }
                });

                if (_this.providers.length) {
                    lodash_default.a.each(_this.providers, function (provider, index) {
                        /* If this is fullStack we need to tell the app to use oauth
                           headers on authenticated requests after being logged inspect
                           then immediately redirect to am's login. */
                        if (provider.provider === 'OPENAM' && _this.providers.length === 1) {
                            if (!window.location.search && _this.signin === true) {
                                sessionStorage.setItem('setAuthHeaders', true);
                                _this.goToIDP('OPENAM');
                            } else {
                                _this.providers.splice(index - 1, 1);
                            }
                        } else {
                            _this.$set(_this.socialButtonStyles, index, provider.uiConfig.buttonCustomStyle);
                        }
                    });
                } else if (_this.filterProvidersObjects.length) {
                    _this.providers = _this.filterProvidersObjects;
                }
            }).catch(function (error) {
                _this.displayNotification('error', error.response.data.message);
            });
        },
        hover: function hover(index, style) {
            this.$set(this.socialButtonStyles, index, style);
        },
        goToIDP: function goToIDP(provider) {
            var _this2 = this;

            /* istanbul ignore next */
            var socialInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });

            /* istanbul ignore next */
            socialInstance.post('/authentication?_action=logout').then(function () {
                /* istanbul ignore next */
                socialInstance.post('/identityProviders?_action=getAuthRedirect', {
                    'provider': provider,
                    'landingPage': window.location.protocol + '/' + window.location.host + '/#/login?_oauthReturn=true&provider=' + provider + '&gotoURL=%23'
                }).then(function (response) {
                    localStorage.setItem('dataStoreToken', response.data.token);
                    window.location.href = response.data.redirect;
                }).catch(function (error) {
                    /* istanbul ignore next */
                    _this2.displayNotification('error', error.response.data.message);
                });
            }).catch(function (error) {
                /* istanbul ignore next */
                _this2.displayNotification('error', error.response.data.message);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cbe19f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/SocialButtons.vue
var SocialButtons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.providers.length)?_c('div',[_vm._l((_vm.providers),function(provider,index){return (provider.uiConfig)?_c('button',{key:index,staticClass:"btn btn-lg btn-light btn-block fr-btn-social mb-3",style:(_vm.socialButtonStyles[index]),attrs:{"type":"button"},on:{"click":function($event){_vm.goToIDP(provider.provider)},"mouseover":function($event){_vm.hover(index, provider.uiConfig.buttonCustomStyleHover)},"mouseout":function($event){_vm.hover(index, provider.uiConfig.buttonCustomStyle)}}},[(provider.uiConfig.buttonImage)?_c('img',{attrs:{"src":'static/' + provider.uiConfig.buttonImage}}):_c('i',{class:['fa fa-lg', provider.uiConfig.iconClass]}),_vm._v(" "),(_vm.signin)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.$t("pages.selfservice.social.signIn"))+" "+_vm._s(provider.uiConfig.buttonDisplayName))]):_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.$t("pages.selfservice.social.signUp"))+" "+_vm._s(provider.uiConfig.buttonDisplayName))])]):_vm._e()}),_vm._v(" "),(this.filterProviders.length === 0)?_c('div',{staticClass:"fr-form-break text-muted mb-3"},[_c('div'),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t("pages.selfservice.social.or")))]),_vm._v(" "),_c('div')]):_vm._e()],2):_vm._e()}
var SocialButtons_staticRenderFns = []
var SocialButtons_esExports = { render: SocialButtons_render, staticRenderFns: SocialButtons_staticRenderFns }
/* harmony default export */ var utils_SocialButtons = (SocialButtons_esExports);
// CONCATENATED MODULE: ./src/components/utils/SocialButtons.vue
function SocialButtons_injectStyle (ssrContext) {
  __webpack_require__("Gql0")
}
var SocialButtons_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var SocialButtons___vue_template_functional__ = false
/* styles */
var SocialButtons___vue_styles__ = SocialButtons_injectStyle
/* scopeId */
var SocialButtons___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SocialButtons___vue_module_identifier__ = null
var SocialButtons_Component = SocialButtons_normalizeComponent(
  SocialButtons,
  utils_SocialButtons,
  SocialButtons___vue_template_functional__,
  SocialButtons___vue_styles__,
  SocialButtons___vue_scopeId__,
  SocialButtons___vue_module_identifier__
)

/* harmony default export */ var components_utils_SocialButtons = (SocialButtons_Component.exports);

// EXTERNAL MODULE: ./src/scss/main.scss
var main = __webpack_require__("hvFc");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/registration/AccountClaiming.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var AccountClaiming = ({
    components: {
        BounceLoader: vue_spinner_min["BounceLoader"],
        'fr-center-card': components_utils_CenterCard,
        'fr-floating-label-input': components_utils_FloatingLabelInput,
        'fr-social-buttons': components_utils_SocialButtons
    },
    data: function data() {
        return {
            apiType: 'socialUserClaim',
            loadingColor: main_default.a.baseColor,
            selfServiceDetails: {},
            password: '',
            passwordVerification: false,
            socialVerification: false,
            providers: [],
            providersObjects: [],
            mail: ''
        };
    },

    mixins: [mixins_SelfserviceAPIMixin],
    name: 'Account-Claiming',
    props: ['clientToken', 'originalToken', 'returnParams'],
    mounted: function mounted() {
        if (localStorage.getItem('accountClaimingToken')) {
            var accountClaimingToken = localStorage.getItem('accountClaimingToken');

            localStorage.removeItem('accountClaimingToken');

            this.claimAccount(accountClaimingToken);
        } else {
            /* istanbul ignore next */
            this.loadData();
        }
    },

    computed: {
        socialDescription: function socialDescription() {
            var _this = this;

            var numProviders = this.providers.length,
                providerList = '';

            lodash_default.a.each(this.providers, function (provider, index) {
                if (numProviders === 1) {
                    providerList += lodash_default.a.upperFirst(provider);
                } else if (index < numProviders - 2) {
                    providerList += lodash_default.a.upperFirst(provider) + ', ';
                } else if (index < numProviders - 1) {
                    providerList += lodash_default.a.upperFirst(provider) + ' ';
                } else {
                    providerList += ' ' + _this.$t('pages.selfservice.social.or') + ' ' + lodash_default.a.upperFirst(provider);
                }
            });

            return this.$t('pages.selfservice.accountClaiming.socialDesc', { providers: providerList });
        }
    },
    methods: {
        claimAccount: function claimAccount(accountClaimingToken) {
            var clientToken = this.clientToken;

            if (lodash_default.a.isString(accountClaimingToken)) {
                clientToken = accountClaimingToken;
            }
            /* istanbul ignore next */
            this.advanceStage({
                'clientToken': clientToken,
                'password': this.password
            });
        },
        apiErrorCallback: function apiErrorCallback(error) {
            /* istanbul ignore next */
            this.$router.push('/login');
            /* istanbul ignore next */
            this.displayNotification('error', error.response.data.message);
        },
        setChildComponent: function setChildComponent(type, details) {
            var _this2 = this;

            /* istanbul ignore next */
            this.selfServiceDetails = details;
            /* istanbul ignore next */
            if (type === 'parameters') {
                if (this.returnParams) {
                    this.advanceStage({
                        'returnParams': this.returnParams
                    });
                } else {
                    this.advanceStage({});
                }
            } else if (type === 'socialUserClaim' && details.tag === 'initial') {
                this.advanceStage({
                    'clientToken': this.clientToken
                });
            } else if (type === 'socialUserClaim' && details.tag === 'verifyProfile') {
                this.mail = lodash_default.a.has(details, 'requirements.mail') ? details.requirements.mail : '';

                if (details.requirements.error) {
                    this.displayNotification('error', details.requirements.error.message);
                } else if (details.requirements.required.indexOf('password') !== -1) {
                    // You can get into this usecase by
                    // having a manually registered account with matching email and a password set
                    this.passwordVerification = true;
                } else {
                    if (this.clientToken && this.originalToken) {
                        this.advanceStage({
                            'clientToken': this.originalToken
                        });
                    } else {
                        localStorage.setItem('accountClaimingToken', this.clientToken);
                        this.providers = lodash_default.a.map(details.requirements.definitions.providers.items.oneOf, 'provider');
                        this.providersObjects = details.requirements.definitions.providers.items.oneOf;
                        this.socialVerification = true;
                    }
                }
            } else if ((type === 'localAutoLogin' || type === 'openAMAutoLogin') && lodash_default.a.isUndefined(details.additions.claimedProfile)) {
                if (sessionStorage.getItem('amSocialToken')) {
                    var tempToken = sessionStorage.getItem('amSocialToken');

                    this.$router.push({ name: 'Registration', params: { clientToken: tempToken } });
                } else {
                    this.$router.push({ name: 'Registration', params: { clientToken: this.clientToken } });
                }
            } else if (details.tag === 'end' && details.status.success) {
                var socialLoginInstance = this.getRequestService({
                    headers: {
                        'X-OpenIDM-NoSession': 'false',
                        'X-OpenIDM-OAuth-Login': 'true',
                        'X-OpenIDM-DataStoreToken': sessionStorage.getItem('amSocialToken') || this.clientToken,
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                sessionStorage.removeItem('amSocialToken');

                socialLoginInstance.post('/authentication?_action=login').then(function (userDetails) {
                    // Check for progressive profiling.
                    _this2.progressiveProfileCheck(userDetails, function () {
                        if (lodash_default.a.has(details, 'additions.successUrl') && !lodash_default.a.isEmpty(details.additions.successUrl)) {
                            window.location = details.additions.successUrl;
                        } else {
                            _this2.$router.push('/');
                        }
                        _this2.displayNotification('success', _this2.$t('pages.selfservice.accountClaiming.linked'));
                    });
                }).catch(function (error) {
                    _this2.$router.push('/login');
                    _this2.displayNotification('error', error.response.data.message);
                });
            } else {
                this.$router.push('/login');
                this.displayNotification('error', this.$t('pages.selfservice.accountClaiming.error'));
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f1cd250","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/registration/AccountClaiming.vue
var AccountClaiming_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.passwordVerification && !_vm.socialVerification)?_c('b-container',{staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"m-auto fr-center-card"},[_c('bounce-loader',{attrs:{"color":_vm.loadingColor}})],1)])]):_c('fr-center-card',{attrs:{"showLogo":true}},[_c('div',{attrs:{"slot":"center-card-header"},slot:"center-card-header"},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.$t("pages.selfservice.accountClaiming.title")))]),_vm._v(" "),(_vm.passwordVerification)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('pages.selfservice.accountClaiming.passwordDesc', {account: _vm.mail}))}}):_vm._e(),_vm._v(" "),(_vm.socialVerification)?_c('span',[_vm._v(_vm._s(_vm.socialDescription))]):_vm._e()]),_vm._v(" "),_c('b-card-body',{attrs:{"slot":"center-card-body"},slot:"center-card-body"},[(_vm.passwordVerification)?_c('fr-floating-label-input',{attrs:{"label":_vm.$t('pages.login.password'),"reveal":true,"type":"password","fieldName":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}):_vm._e(),_vm._v(" "),(_vm.socialVerification)?_c('fr-social-buttons',{attrs:{"filterProviders":_vm.providers,"filterProvidersObjects":_vm.providersObjects,"signin":""}}):_vm._e(),_vm._v(" "),(_vm.passwordVerification)?_c('button',{staticClass:"btn btn-lg btn-primary btn-block mb-3",attrs:{"type":"button"},on:{"click":_vm.claimAccount}},[_vm._v(_vm._s(_vm.$t("pages.login.signIn")))]):_vm._e()],1),_vm._v(" "),_c('b-card-footer',{attrs:{"slot":"center-card-footer"},slot:"center-card-footer"},[_c('router-link',{attrs:{"action":"","to":"login"}},[_vm._v(_vm._s(_vm.$t("pages.selfservice.accountClaiming.return")))])],1)],1)}
var AccountClaiming_staticRenderFns = []
var AccountClaiming_esExports = { render: AccountClaiming_render, staticRenderFns: AccountClaiming_staticRenderFns }
/* harmony default export */ var registration_AccountClaiming = (AccountClaiming_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/registration/AccountClaiming.vue
function AccountClaiming_injectStyle (ssrContext) {
  __webpack_require__("wGgA")
}
var AccountClaiming_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var AccountClaiming___vue_template_functional__ = false
/* styles */
var AccountClaiming___vue_styles__ = AccountClaiming_injectStyle
/* scopeId */
var AccountClaiming___vue_scopeId__ = "data-v-3f1cd250"
/* moduleIdentifier (server only) */
var AccountClaiming___vue_module_identifier__ = null
var AccountClaiming_Component = AccountClaiming_normalizeComponent(
  AccountClaiming,
  registration_AccountClaiming,
  AccountClaiming___vue_template_functional__,
  AccountClaiming___vue_styles__,
  AccountClaiming___vue_scopeId__,
  AccountClaiming___vue_module_identifier__
)

/* harmony default export */ var selfservice_registration_AccountClaiming = (AccountClaiming_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/WelcomeWidget.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Widget that provides a welcome message for the managed resource, also provides a button to directly access editing the resources profile.
 *
 **/
/* harmony default export */ var WelcomeWidget = ({
    name: 'Welcome-Widget',
    props: ['userDetails', 'widgetDetails'],
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        openProfile: function openProfile() {
            this.$router.push({ name: 'Profile', params: { openProfile: !this.$root.userStore.state.internalUser } });
        }
    },
    computed: {
        fullName: function fullName() {
            var fullName = '';

            if (this.userDetails.givenName.length > 0 || this.userDetails.sn.length > 0) {
                fullName = lodash_default.a.startCase(this.userDetails.givenName + ' ' + this.userDetails.sn);
            } else {
                fullName = this.userDetails.userId;
            }

            return fullName;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a93642e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/WelcomeWidget.vue
var WelcomeWidget_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-jumbotron',{staticClass:"text-center"},[_c('template',{slot:"header"},[_c('b-img',{staticClass:"m-1 mb-3",attrs:{"src":"static/images/profile-default.png","rounded":"circle","width":"112","height":"112","alt":"img"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('pages.dashboard.widgets.welcome.greeting'))+", "+_vm._s(_vm.fullName))])],1),_vm._v(" "),_c('template',{slot:"lead"},[_c('div',[_vm._v("\n            "+_vm._s(_vm.$t('pages.dashboard.widgets.welcome.welcomeMessage'))+"\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"mt-2",attrs:{"variant":"primary"},on:{"click":function($event){_vm.openProfile()}}},[_vm._v("\n            "+_vm._s(_vm.$t('pages.dashboard.widgets.welcome.editProfile'))+"\n        ")])],1)],2)}
var WelcomeWidget_staticRenderFns = []
var WelcomeWidget_esExports = { render: WelcomeWidget_render, staticRenderFns: WelcomeWidget_staticRenderFns }
/* harmony default export */ var widgets_WelcomeWidget = (WelcomeWidget_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/WelcomeWidget.vue
function WelcomeWidget_injectStyle (ssrContext) {
  __webpack_require__("c2jU")
}
var WelcomeWidget_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var WelcomeWidget___vue_template_functional__ = false
/* styles */
var WelcomeWidget___vue_styles__ = WelcomeWidget_injectStyle
/* scopeId */
var WelcomeWidget___vue_scopeId__ = "data-v-1a93642e"
/* moduleIdentifier (server only) */
var WelcomeWidget___vue_module_identifier__ = null
var WelcomeWidget_Component = WelcomeWidget_normalizeComponent(
  WelcomeWidget,
  widgets_WelcomeWidget,
  WelcomeWidget___vue_template_functional__,
  WelcomeWidget___vue_styles__,
  WelcomeWidget___vue_scopeId__,
  WelcomeWidget___vue_module_identifier__
)

/* harmony default export */ var dashboard_widgets_WelcomeWidget = (WelcomeWidget_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/ListGroup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Container for holding ListItem.vue, together both components can be used to display a list of items with varying degrees of customization
 *
 **/
/* harmony default export */ var ListGroup = ({
    name: 'List-Group',
    props: {
        'title': {
            type: String
        },
        'subtitle': {
            type: String
        }
    },
    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca45726","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ListGroup.vue
var ListGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-3",attrs:{"no-body":""}},[_vm._t("list-group-header",[_c('b-card-body',{staticClass:"py-4"},[_c('h5',{class:[{ 'mb-4': _vm.subtitle, 'mb-0': !_vm.subtitle}, 'card-title']},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('h6',{staticClass:"card-subtitle mb-0 text-muted"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])]),_vm._v(" "),_c('b-list-group',{attrs:{"flush":""}},[_vm._t("default")],2)],2)}
var ListGroup_staticRenderFns = []
var ListGroup_esExports = { render: ListGroup_render, staticRenderFns: ListGroup_staticRenderFns }
/* harmony default export */ var utils_ListGroup = (ListGroup_esExports);
// CONCATENATED MODULE: ./src/components/utils/ListGroup.vue
function ListGroup_injectStyle (ssrContext) {
  __webpack_require__("0DNl")
}
var ListGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ListGroup___vue_template_functional__ = false
/* styles */
var ListGroup___vue_styles__ = ListGroup_injectStyle
/* scopeId */
var ListGroup___vue_scopeId__ = "data-v-4ca45726"
/* moduleIdentifier (server only) */
var ListGroup___vue_module_identifier__ = null
var ListGroup_Component = ListGroup_normalizeComponent(
  ListGroup,
  utils_ListGroup,
  ListGroup___vue_template_functional__,
  ListGroup___vue_styles__,
  ListGroup___vue_scopeId__,
  ListGroup___vue_module_identifier__
)

/* harmony default export */ var components_utils_ListGroup = (ListGroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/ListItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Used in conjunction with ListGroup.vue, this is the individual item in each list display.
 *
 **/
/* harmony default export */ var ListItem = ({
    name: 'List-Item',
    props: {
        'collapsible': {
            type: Boolean,
            default: false
        },
        'panelShown': {
            type: Boolean,
            default: false
        },
        'hoverItem': {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            id: null
        };
    },
    beforeMount: function beforeMount() {
        this.id = 'listItem' + this._uid;
    },

    computed: {
        toggleId: function toggleId() {
            if (this.collapsible) {
                return this.id;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bf5f8bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ListItem.vue
var ListItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.collapsible)?_c('div',{staticClass:"collapsible"},[_c('b-list-group-item',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.toggleId),expression:"toggleId"}],class:[{'list-item-cursor': _vm.collapsible===false}],attrs:{"href":"#"}},[_c('div',{staticClass:"media"},[_vm._t("list-item-header")],2)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":_vm.id,"visible":_vm.panelShown},on:{"hide":function($event){_vm.$emit('hide')},"show":function($event){_vm.$emit('show')},"hidden":function($event){_vm.$emit('hidden')},"shown":function($event){_vm.$emit('shown')}}},[_c('b-card-body',{staticClass:"pt-3"},[_vm._t("list-item-collapse-body")],2)],1)],1):_c('div',{class:[{'fr-hover-item': _vm.hoverItem}],on:{"click":function($event){_vm.$emit('row-click')}}},[_c('b-list-group-item',{staticClass:"noncollapse"},[_c('div',{staticClass:"media"},[_vm._t("list-item-header")],2)]),_vm._v(" "),(_vm.panelShown)?_c('b-card-body',{staticClass:"pt-3"},[_vm._t("list-item-collapse-body")],2):_vm._e()],1)}
var ListItem_staticRenderFns = []
var ListItem_esExports = { render: ListItem_render, staticRenderFns: ListItem_staticRenderFns }
/* harmony default export */ var utils_ListItem = (ListItem_esExports);
// CONCATENATED MODULE: ./src/components/utils/ListItem.vue
function ListItem_injectStyle (ssrContext) {
  __webpack_require__("CVf3")
}
var ListItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ListItem___vue_template_functional__ = false
/* styles */
var ListItem___vue_styles__ = ListItem_injectStyle
/* scopeId */
var ListItem___vue_scopeId__ = "data-v-5bf5f8bc"
/* moduleIdentifier (server only) */
var ListItem___vue_module_identifier__ = null
var ListItem_Component = ListItem_normalizeComponent(
  ListItem,
  utils_ListItem,
  ListItem___vue_template_functional__,
  ListItem___vue_styles__,
  ListItem___vue_scopeId__,
  ListItem___vue_module_identifier__
)

/* harmony default export */ var components_utils_ListItem = (ListItem_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/workflow/GenericTask.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Widget that provides generic fallback for a workflow task
 *
 **/
/* harmony default export */ var GenericTask = ({
    name: 'Generic-Task',
    props: ['variables', 'taskFields', 'processFields'],
    data: function data() {
        var _this = this;

        var tempFormFields = [],
            tempFormValues = {},
            tempVariables = lodash_default.a.omit(lodash_default.a.clone(this.variables), ['approverId', 'initiatorId', 'openidmObjectId']);

        // Generate list of possible editable/none editable properties with values
        lodash_default.a.each(this.taskFields.formPropertyHandlers, function (field, key) {
            var tempField = {
                key: field._id,
                name: field.name,
                value: _this.variables[field._id],
                type: field.type.name,
                readOnly: !field.writable
            };

            // Handel dropdown use case
            if (field.type.name === 'enum') {
                tempField.options = field.type.values;

                // If no variable value set default value to first option
                if (lodash_default.a.isUndefined(tempField.value) && field.type.values) {
                    tempField.value = keys_default()(field.type.values)[0];
                    tempFormValues[field._id] = tempField.value;
                }
            }

            // In the case of no enum set trackable input values to be bond by Vue
            if (lodash_default.a.isUndefined(tempFormValues[field._id])) {
                tempFormValues[field._id] = _this.variables[field._id];
            }

            tempFormFields.push(tempField);

            delete tempVariables[field._id];
        });

        return {
            formFields: tempFormFields,
            readOnlyFields: tempVariables,
            formValues: tempFormValues
        };
    },

    filters: {
        capitalize: function capitalize(val) {
            return lodash_default.a.capitalize(val);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ee9fb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/workflow/GenericTask.vue
var GenericTask_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_vm._l((_vm.readOnlyFields),function(field,key){return [_c('b-form-group',{key:key,attrs:{"label":_vm._f("capitalize")(key),"label-for":"field","horizontal":""}},[_c('b-form-input',{attrs:{"horizontal":"","type":"text","readonly":true,"plaintext":true,"value":field}})],1)]}),_vm._v(" "),_vm._l((_vm.formFields),function(field,index){return [((field.type === 'string' || field.type === 'number'))?_c('b-form-group',{key:field.name +index,attrs:{"label":field.name,"label-for":"field.key","horizontal":""}},[_c('b-form-input',{attrs:{"horizontal":"","type":"text","plaintext":field.readOnly,"name":field.key,"value":_vm.formValues[field.key]},model:{value:(_vm.formValues[field.key]),callback:function ($$v) {_vm.$set(_vm.formValues, field.key, $$v)},expression:"formValues[field.key]"}})],1):(field.type === 'boolean')?_c('b-form-group',{key:field.name +index},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-form-label col-sm-3",attrs:{"for":field.name}},[_vm._v(_vm._s(field.name))]),_vm._v(" "),_c('div',{staticClass:"mr-auto"},[_c('toggle-button',{staticClass:"mt-2 p-0 fr-toggle-primary",attrs:{"height":28,"width":56,"disabled":field.readOnly,"sync":true,"cssColors":true,"labels":{checked: _vm.$t('common.form.yes'), unchecked: _vm.$t('common.form.no')}},model:{value:(_vm.formValues[field.key]),callback:function ($$v) {_vm.$set(_vm.formValues, field.key, $$v)},expression:"formValues[field.key]"}})],1)])]):(field.type === 'enum')?_c('b-form-group',{key:field.name +index},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-form-label col-sm-3",attrs:{"for":field.name}},[_vm._v(_vm._s(field.name))]),_vm._v(" "),_c('div',{staticClass:"mr-auto"},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":field.options},model:{value:(_vm.formValues[field.key]),callback:function ($$v) {_vm.$set(_vm.formValues, field.key, $$v)},expression:"formValues[field.key]"}})],1)])]):_vm._e()]})],2)],1),_vm._v(" "),_c('div',{staticClass:"float-right mt-4"},[_c('b-btn',{attrs:{"type":"button","variant":"primary"},on:{"click":function($event){_vm.$emit('submit', _vm.formValues)}}},[_vm._v(_vm._s(_vm.$t('common.form.save')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":"primary"},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))])],1)],1)}
var GenericTask_staticRenderFns = []
var GenericTask_esExports = { render: GenericTask_render, staticRenderFns: GenericTask_staticRenderFns }
/* harmony default export */ var workflow_GenericTask = (GenericTask_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/workflow/GenericTask.vue
var GenericTask_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var GenericTask___vue_template_functional__ = false
/* styles */
var GenericTask___vue_styles__ = null
/* scopeId */
var GenericTask___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GenericTask___vue_module_identifier__ = null
var GenericTask_Component = GenericTask_normalizeComponent(
  GenericTask,
  workflow_GenericTask,
  GenericTask___vue_template_functional__,
  GenericTask___vue_styles__,
  GenericTask___vue_scopeId__,
  GenericTask___vue_module_identifier__
)

/* harmony default export */ var widgets_workflow_GenericTask = (GenericTask_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/workflow/Task.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Dashboard widget that displays the specific details of a task
 * @description Dashboard widget that displays the specific details of a task
 *
 **/
/* harmony default export */ var Task = ({
    name: 'Task',
    props: ['taskInstance'],
    data: function data() {
        return {
            showGenericTask: false,
            loadingColor: main_default.a.baseColor
        };
    },

    components: {
        'clip-loader': vue_spinner_min["ClipLoader"],
        GenericTask: widgets_workflow_GenericTask
    },
    computed: {
        process: function process() {
            return this.taskInstance.process;
        },
        processDefinition: function processDefinition() {
            if (this.process.processDefinition === null) {
                this.$emit('loadProcess', this.process);
            }
            return this.process.processDefinition;
        },
        formProperties: function formProperties() {
            return this.processDefinition ? this.processDefinition.formProperties : [];
        },
        task: function task() {
            return this.taskInstance.task;
        },
        taskDetails: function taskDetails() {
            var _this = this;

            return this.formProperties.reduce(function (acc, property) {
                return acc.concat({ _id: property._id, name: property.name, value: _this.task.variables[property._id] });
            }, []);
        },
        variables: function variables() {
            return lodash_default.a.get(this, 'task.variables');
        },
        taskForm: function taskForm() {
            var formGenerationTemplate = this.task.taskDefinition.formGenerationTemplate,
                initializeForm = formGenerationTemplate ? Function('return ' + formGenerationTemplate) : null; // eslint-disable-line

            if (!lodash_default.a.isNull(initializeForm)) {
                return initializeForm();
            } else {
                this.showGenericTask = true;
                return null;
            }
        }
    },
    methods: {
        submit: function submit(formData) {
            this.$emit('completeTask', { id: this.task._id, formData: formData });
        },
        cancel: function cancel() {
            this.$emit('cancel', this.task._id);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-445ef306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/workflow/Task.vue
var Task_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in","duration":"250"}},[(_vm.processDefinition !== null && _vm.showGenericTask === false)?_c(_vm.taskForm,{tag:"component",attrs:{"processDefinition":_vm.processDefinition,"taskDefinition":_vm.task,"variables":_vm.variables},on:{"submit":_vm.submit,"cancel":_vm.cancel}}):(_vm.showGenericTask === true && _vm.processDefinition !== null)?_c('GenericTask',{attrs:{"variables":_vm.taskInstance.task.variables,"task-fields":_vm.taskInstance.task.taskDefinition.formProperties,"process-fields":_vm.taskInstance.task.formProperties},on:{"submit":_vm.submit,"cancel":_vm.cancel}}):_c('clip-loader',{staticClass:"m-auto",attrs:{"color":_vm.loadingColor}})],1)}
var Task_staticRenderFns = []
var Task_esExports = { render: Task_render, staticRenderFns: Task_staticRenderFns }
/* harmony default export */ var workflow_Task = (Task_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/workflow/Task.vue
var Task_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Task___vue_template_functional__ = false
/* styles */
var Task___vue_styles__ = null
/* scopeId */
var Task___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Task___vue_module_identifier__ = null
var Task_Component = Task_normalizeComponent(
  Task,
  workflow_Task,
  Task___vue_template_functional__,
  Task___vue_styles__,
  Task___vue_scopeId__,
  Task___vue_module_identifier__
)

/* harmony default export */ var widgets_workflow_Task = (Task_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/workflow/MyTasks.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Dashboard widget that lists tasks currently assigned to the logged in user
 *
 **/
/* harmony default export */ var MyTasks = ({
    name: 'My-Tasks',
    props: {
        tasks: Object
    },
    data: function data() {
        return { panelShown: {}, onHidden: null };
    },

    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem,
        'fr-task': widgets_workflow_Task
    },
    methods: {
        setShown: function setShown(id) {
            this.$set(this.panelShown, id, true);
        },
        setHidden: function setHidden(id) {
            this.$set(this.panelShown, id, false);

            if (lodash_default.a.isFunction(this.onHidden)) {
                this.onHidden();
                this.onHidden = null;
            }
        },
        cancel: function cancel(id) {
            lodash_default.a.first(this.$refs['cancel-' + id]).click();
        },
        requeue: function requeue(id) {
            var task = this.tasks[id].task,
                action = 'updateAssignment',
                payload = { id: id, task: task, assignee: null };

            this.update(id, action, payload);
        },
        completeTask: function completeTask(payload) {
            this.update(payload.id, 'completeTask', payload);
        },
        update: function update(id, action, payload) {
            var _this = this;

            var update = function update() {
                _this.$emit(action, payload);
            };

            if (this.panelShown[id]) {
                this.onHidden = update;
                this.cancel(id);
            } else {
                update();
            }
        },

        isEmpty: lodash_default.a.isEmpty,
        first: lodash_default.a.first
    },
    watch: {
        tasks: {
            /**
            * This function sets the state of panelShown. Anytime new tasks are added to the tasks prop,
            * the prop key is added to the panelShown object with an initial state of `false`.
            */
            handler: function handler(val, oldVal) {
                var _this2 = this;

                var newVals = lodash_default.a.difference(lodash_default.a.keys(val), lodash_default.a.keys(oldVal));

                if (lodash_default.a.isUndefined(this.panelShown)) {
                    this.panelShown = {};
                }

                newVals.forEach(function (val) {
                    _this2.$set(_this2.panelShown, val, false);
                });
            },

            deep: true
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6417540c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/workflow/MyTasks.vue
var MyTasks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fr-list-group',{attrs:{"title":this.$t('pages.workflow.myTasks')}},[(!_vm.isEmpty(_vm.tasks))?[_c('transition-group',{attrs:{"name":"fade","mode":"out-in"}},_vm._l((_vm.tasks),function(task,id){return _c('fr-list-item',{key:id,ref:("collapse-" + id),refInFor:true,attrs:{"collapsible":true},on:{"shown":function($event){_vm.setShown(id)},"hidden":function($event){_vm.setHidden(id)}}},[_c('div',{staticClass:"d-inline-flex w-100 media",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"media-body align-self-center"},[_c('h6',[_vm._v(_vm._s(task.name))])]),_vm._v(" "),(!_vm.isEmpty(task.task.candidates.candidateGroups))?_c('div',{staticClass:"btn btn-sm btn-link float-right",on:{"click":function($event){$event.stopPropagation();_vm.requeue(id)}}},[_vm._v(_vm._s(_vm.$t('pages.workflow.requeue')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex ml-3 align-self-center"},[_c('div',{ref:("cancel-" + id),refInFor:true,staticClass:"btn btn-sm btn-link float-right btn-cancel"},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-link float-right btn-edit"},[_vm._v(_vm._s(_vm.$t('common.form.edit')))])])]),_vm._v(" "),_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-collapse-body"},slot:"list-item-collapse-body"},[_c('fr-task',{ref:id,refInFor:true,attrs:{"taskInstance":task},on:{"loadProcess":function (process) { return _vm.$emit('loadProcess', process); },"cancel":_vm.cancel,"completeTask":_vm.completeTask}})],1)])}))]:_c('fr-list-item',[_c('div',{staticClass:"text-muted text-center w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_vm._v("\n                "+_vm._s(_vm.$t('pages.workflow.noAssignedTasks'))+"\n            ")])])],2)],1)}
var MyTasks_staticRenderFns = []
var MyTasks_esExports = { render: MyTasks_render, staticRenderFns: MyTasks_staticRenderFns }
/* harmony default export */ var workflow_MyTasks = (MyTasks_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/workflow/MyTasks.vue
function MyTasks_injectStyle (ssrContext) {
  __webpack_require__("gU86")
}
var MyTasks_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var MyTasks___vue_template_functional__ = false
/* styles */
var MyTasks___vue_styles__ = MyTasks_injectStyle
/* scopeId */
var MyTasks___vue_scopeId__ = "data-v-6417540c"
/* moduleIdentifier (server only) */
var MyTasks___vue_module_identifier__ = null
var MyTasks_Component = MyTasks_normalizeComponent(
  MyTasks,
  workflow_MyTasks,
  MyTasks___vue_template_functional__,
  MyTasks___vue_styles__,
  MyTasks___vue_scopeId__,
  MyTasks___vue_module_identifier__
)

/* harmony default export */ var widgets_workflow_MyTasks = (MyTasks_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/workflow/AssignTask.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Dashboard widget that allows a user to assign a task
 *
 **/
/* harmony default export */ var AssignTask = ({
    name: 'Assign-Task',
    props: ['taskDefinition'],
    data: function data() {
        return {
            workflowService: null,
            selected: this.$root.userStore.state.userName
        };
    },

    computed: {
        process: function process() {
            return this.taskDefinition.process;
        },
        processDefinition: function processDefinition() {
            if (this.process.processDefinition === null) {
                this.$emit('loadProcess', this.process);
            }
            return this.process.processDefinition;
        },
        formProperties: function formProperties() {
            return !lodash_default.a.isNull(this.processDefinition) ? this.processDefinition.formProperties : [];
        },
        task: function task() {
            return this.taskDefinition.task;
        },
        id: function id() {
            return this.task._id;
        },
        taskDetails: function taskDetails() {
            var _this = this;

            return this.formProperties.reduce(function (acc, property) {
                return acc.concat({ _id: property._id, name: property.name, value: _this.task.variables[property._id] });
            }, []);
        },
        assigneeOptions: function assigneeOptions() {
            var _this2 = this;

            var loggedUserName = this.$root.userStore.state.userName;
            if (!lodash_default.a.isEmpty(this.task.usersToAssign)) {
                return this.task.usersToAssign.map(function (_ref) {
                    var username = _ref.username,
                        displayableName = _ref.displayableName;

                    var value = username,
                        text = username === loggedUserName ? _this2.$t('pages.workflow.me') : displayableName;
                    return { value: value, text: text };
                });
            } else {
                return [{ value: loggedUserName, text: this.$t('pages.workflow.me') }];
            }
        }
    },
    methods: {
        assignTask: function assignTask() {
            this.$emit('assignTask', { id: this.id, assignee: this.selected });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f636e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/workflow/AssignTask.vue
var AssignTask_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-body',{staticClass:"pt-3"},[_c('b-row',[_c('b-col',{attrs:{"lg":"8","offset-lg":"1"}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label"},[_vm._v(_vm._s(_vm.$t('pages.workflow.assignTo')))]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"d-flex"},[_c('b-form-select',{staticClass:"mb-3 mr-2",attrs:{"options":_vm.assigneeOptions},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),_c('b-button',{staticClass:"mb-3 d-flex align-self-end",attrs:{"type":"button","variant":"primary"},on:{"click":_vm.assignTask}},[_vm._v(_vm._s(_vm.$t('pages.workflow.assign')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label"},[_vm._v("Details")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('b-card',[_c('dl',{staticClass:"row m-0"},[_vm._l((_vm.taskDetails),function(detail){return [_c('dt',{staticClass:"col-6"},[_vm._v(_vm._s(detail.name))]),_vm._v(" "),_c('dd',{staticClass:"col-6"},[_vm._v(_vm._s(detail.value)+" ")])]})],2)])],1)])])],1)],1)}
var AssignTask_staticRenderFns = []
var AssignTask_esExports = { render: AssignTask_render, staticRenderFns: AssignTask_staticRenderFns }
/* harmony default export */ var workflow_AssignTask = (AssignTask_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/workflow/AssignTask.vue
var AssignTask_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var AssignTask___vue_template_functional__ = false
/* styles */
var AssignTask___vue_styles__ = null
/* scopeId */
var AssignTask___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AssignTask___vue_module_identifier__ = null
var AssignTask_Component = AssignTask_normalizeComponent(
  AssignTask,
  workflow_AssignTask,
  AssignTask___vue_template_functional__,
  AssignTask___vue_styles__,
  AssignTask___vue_scopeId__,
  AssignTask___vue_module_identifier__
)

/* harmony default export */ var widgets_workflow_AssignTask = (AssignTask_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/workflow/GroupTasks.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Dashboard widget that lists available group tasks that can be assigned
 *
 **/
/* harmony default export */ var GroupTasks = ({
    name: 'Group-Tasks',
    props: {
        tasks: Object
    },
    data: function data() {
        return { panelShown: {}, onHidden: null };
    },

    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem,
        'fr-assign-task': widgets_workflow_AssignTask
    },
    methods: {
        isEmpty: lodash_default.a.isEmpty,
        first: lodash_default.a.first,
        setShown: function setShown(id) {
            this.$set(this.panelShown, id, true);
        },
        setHidden: function setHidden(id) {
            this.$set(this.panelShown, id, false);

            if (lodash_default.a.isFunction(this.onHidden)) {
                this.onHidden();
                this.onHidden = null;
            }
        },
        cancel: function cancel(id) {
            lodash_default.a.first(this.$refs['cancel-' + id]).click();
        },
        assignTask: function assignTask(_ref) {
            var _this = this;

            var id = _ref.id,
                assignee = _ref.assignee;

            var task = this.tasks[id].task;

            this.onHidden = function () {
                _this.$emit('updateAssignment', { assignee: assignee, id: id, task: task });
            };

            this.cancel(id);
        }
    },
    watch: {
        tasks: {
            /**
            * This function sets the state of panelShown. Anytime new tasks are added to the tasks prop,
            * the prop key is added to the panelShown object with an initial state of `false`.
            */
            handler: function handler(val, oldVal) {
                var _this2 = this;

                var newVals = lodash_default.a.difference(lodash_default.a.keys(val), lodash_default.a.keys(oldVal));

                if (lodash_default.a.isUndefined(this.panelShown)) {
                    this.panelShown = {};
                }

                newVals.forEach(function (val) {
                    _this2.$set(_this2.panelShown, val, false);
                });
            },

            deep: true
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b18047","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/workflow/GroupTasks.vue
var GroupTasks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fr-list-group',{attrs:{"title":this.$t('pages.workflow.unassignedTasks')}},[(!_vm.isEmpty(_vm.tasks))?[_c('transition-group',{attrs:{"name":"fade","mode":"out-in"}},_vm._l((_vm.tasks),function(taskDefinition,id){return _c('fr-list-item',{key:id,ref:("collapse-" + id),refInFor:true,attrs:{"collapsible":true},on:{"shown":function($event){_vm.setShown(id)},"hidden":function($event){_vm.setHidden(id)}}},[_c('div',{staticClass:"d-inline-flex w-100 media",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"media-body align-self-center"},[_c('h6',{staticClass:"mb-1 mt-2"},[_vm._v(_vm._s(taskDefinition.name))]),_vm._v(" "),_c('small',{staticClass:"text-muted d-block mb-2"},[_vm._v(_vm._s(_vm.$t('pages.workflow.notAssigned')))])]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-3 align-self-center"},[_c('div',{ref:("cancel-" + id),refInFor:true,staticClass:"btn btn-sm btn-link float-right btn-cancel"},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-link float-right btn-edit"},[_vm._v(_vm._s(_vm.$t('pages.workflow.assign')))])])]),_vm._v(" "),_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-collapse-body"},slot:"list-item-collapse-body"},[_c('fr-assign-task',{attrs:{"taskDefinition":taskDefinition},on:{"loadProcess":function (process) { return _vm.$emit('loadProcess', process); },"assignTask":_vm.assignTask}})],1)])}))]:_c('fr-list-item',[_c('div',{staticClass:"text-muted text-center w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_vm._v("\n                "+_vm._s(_vm.$t('pages.workflow.noGroupTasks'))+"\n            ")])])],2)],1)}
var GroupTasks_staticRenderFns = []
var GroupTasks_esExports = { render: GroupTasks_render, staticRenderFns: GroupTasks_staticRenderFns }
/* harmony default export */ var workflow_GroupTasks = (GroupTasks_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/workflow/GroupTasks.vue
function GroupTasks_injectStyle (ssrContext) {
  __webpack_require__("EQtd")
}
var GroupTasks_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var GroupTasks___vue_template_functional__ = false
/* styles */
var GroupTasks___vue_styles__ = GroupTasks_injectStyle
/* scopeId */
var GroupTasks___vue_scopeId__ = "data-v-77b18047"
/* moduleIdentifier (server only) */
var GroupTasks___vue_module_identifier__ = null
var GroupTasks_Component = GroupTasks_normalizeComponent(
  GroupTasks,
  workflow_GroupTasks,
  GroupTasks___vue_template_functional__,
  GroupTasks___vue_styles__,
  GroupTasks___vue_scopeId__,
  GroupTasks___vue_module_identifier__
)

/* harmony default export */ var widgets_workflow_GroupTasks = (GroupTasks_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/workflow/GenericProcess.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Widget that provides generic fallback for a workflow process
 *
 **/
/* harmony default export */ var GenericProcess = ({
    name: 'Generic-Process',
    props: ['workflowDetails', 'id'],
    data: function data() {
        var tempFormFields = [],
            tempFormValues = {
            _processDefinitionId: this.id
        };

        // Establish type and default values
        lodash_default.a.each(this.workflowDetails, function (detail) {
            var detailKey = lodash_default.a.lowerCase(detail.name);

            tempFormFields.push({
                name: detail.name,
                key: detailKey,
                type: detail.type.name,
                value: detail.type.value
            });

            if (detail.type.name === 'boolean') {
                tempFormValues[detailKey] = false;
            } else if (detail.type.name === 'number') {
                tempFormValues[detailKey] = 0;
            } else if (detail.type.name === 'string') {
                tempFormValues[detailKey] = '';
            }
        });

        return {
            formFields: tempFormFields,
            formValues: tempFormValues
        };
    },

    methods: {
        resetForm: function resetForm() {
            var _this = this;

            lodash_default.a.each(this.formValues, function (value, key) {
                if (lodash_default.a.isNumber(value)) {
                    _this.formValues[key] = 0;
                } else if (lodash_default.a.isBoolean(value)) {
                    _this.formValues[key] = false;
                } else {
                    _this.formValues[key] = '';
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10423410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/workflow/GenericProcess.vue
var GenericProcess_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_vm._l((_vm.formFields),function(field,index){return [((field.type === 'string' || field.type === 'number'))?_c('b-form-group',{key:field.name +index,attrs:{"label":field.name,"label-for":"field.key","horizontal":""}},[_c('b-form-input',{attrs:{"horizontal":"","type":"text","name":field.key},model:{value:(_vm.formValues[field.key]),callback:function ($$v) {_vm.$set(_vm.formValues, field.key, $$v)},expression:"formValues[field.key]"}})],1):_vm._e(),_vm._v(" "),(field.type === 'boolean')?_c('b-form-group',{key:field.name +index},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-form-label col-sm-3",attrs:{"for":field.name}},[_vm._v(_vm._s(field.name))]),_vm._v(" "),_c('div',{staticClass:"mr-auto"},[_c('toggle-button',{staticClass:"mt-2 p-0 fr-toggle-primary",attrs:{"height":28,"width":56,"sync":true,"cssColors":true,"labels":{checked: _vm.$t('common.form.yes'), unchecked: _vm.$t('common.form.no')}},model:{value:(_vm.formValues[field.key]),callback:function ($$v) {_vm.$set(_vm.formValues, field.key, $$v)},expression:"formValues[field.key]"}})],1)])]):_vm._e()]})],2)],1),_vm._v(" "),_c('div',{staticClass:"float-right mt-4"},[_c('b-btn',{attrs:{"type":"button","variant":"primary"},on:{"click":function($event){_vm.$emit('submit', _vm.formValues)}}},[_vm._v(_vm._s(_vm.$t('common.form.save')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":"primary"},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))])],1)],1)}
var GenericProcess_staticRenderFns = []
var GenericProcess_esExports = { render: GenericProcess_render, staticRenderFns: GenericProcess_staticRenderFns }
/* harmony default export */ var workflow_GenericProcess = (GenericProcess_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/workflow/GenericProcess.vue
var GenericProcess_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var GenericProcess___vue_template_functional__ = false
/* styles */
var GenericProcess___vue_styles__ = null
/* scopeId */
var GenericProcess___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GenericProcess___vue_module_identifier__ = null
var GenericProcess_Component = GenericProcess_normalizeComponent(
  GenericProcess,
  workflow_GenericProcess,
  GenericProcess___vue_template_functional__,
  GenericProcess___vue_styles__,
  GenericProcess___vue_scopeId__,
  GenericProcess___vue_module_identifier__
)

/* harmony default export */ var widgets_workflow_GenericProcess = (GenericProcess_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/workflow/Process.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description Dashboard widget that displays the details of a specific process
 *
 **/
/* harmony default export */ var Process = ({
    name: 'Workflow-Process',
    components: {
        'clip-loader': vue_spinner_min["ClipLoader"],
        GenericProcess: widgets_workflow_GenericProcess
    },
    props: {
        processDefinition: {
            types: [Object, null],
            required: true
        },
        task: Object
    },
    data: function data() {
        return {
            genericWorkflow: false,
            loadingColor: main_default.a.baseColor
        };
    },

    computed: {
        startForm: function startForm() {
            var initializeForm = void 0;

            // Fallback to generic component when no provided JS
            if (this.processDefinition.formGenerationTemplate) {
                initializeForm = Function('return ' + this.processDefinition.formGenerationTemplate); // eslint-disable-line

                return initializeForm();
            } else {
                this.genericWorkflow = true;

                return null;
            }
        }
    },
    methods: {
        cancel: function cancel() {
            this.reset();
            this.$emit('cancel', this.processDefinition._id);
        },
        reset: function reset(id) {
            this.$refs.startFormComponent.resetForm();
        },
        submit: function submit(payload) {
            this.$emit('startProcess', payload);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa9eca7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/workflow/Process.vue
var Process_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in","duration":"250"}},[(_vm.processDefinition !== null && _vm.genericWorkflow === false)?_c(_vm.startForm,{ref:"startFormComponent",tag:"component",attrs:{"processDefinition":_vm.processDefinition,"isTask":_vm.task},on:{"submit":_vm.submit,"cancel":_vm.cancel}}):(_vm.processDefinition !== null && _vm.genericWorkflow === true)?_c('GenericProcess',{ref:"startFormComponent",attrs:{"id":_vm.processDefinition._id,"workflow-details":_vm.processDefinition.formProperties},on:{"submit":_vm.submit,"cancel":_vm.cancel}}):_c('clip-loader',{staticClass:"m-auto",attrs:{"color":_vm.loadingColor}})],1)}
var Process_staticRenderFns = []
var Process_esExports = { render: Process_render, staticRenderFns: Process_staticRenderFns }
/* harmony default export */ var workflow_Process = (Process_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/workflow/Process.vue
var Process_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Process___vue_template_functional__ = false
/* styles */
var Process___vue_styles__ = null
/* scopeId */
var Process___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Process___vue_module_identifier__ = null
var Process_Component = Process_normalizeComponent(
  Process,
  workflow_Process,
  Process___vue_template_functional__,
  Process___vue_styles__,
  Process___vue_scopeId__,
  Process___vue_module_identifier__
)

/* harmony default export */ var widgets_workflow_Process = (Process_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/workflow/Processes.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/**
 * @description Dashboard widget that displays a list of available processes that can be started
 *
 **/
/* harmony default export */ var Processes = ({
    name: 'Processes',
    props: {
        'processes': {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            loadingColor: main_default.a.baseColor
        };
    },

    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem,
        'fr-process': widgets_workflow_Process,
        BounceLoader: vue_spinner_min["BounceLoader"]
    },
    methods: {
        isEmpty: lodash_default.a.isEmpty,
        reset: function reset(id) {
            var process = lodash_default.a.first(this.$refs[id]);

            if (process) {
                process.reset();
            }
        },
        cancel: function cancel(id) {
            var cancelBtn = lodash_default.a.first(this.$refs['cancel-' + id]);

            if (cancelBtn) {
                this.reset(id);
                cancelBtn.click();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-551caad6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/workflow/Processes.vue
var Processes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fr-list-group',{attrs:{"title":this.$t('pages.workflow.startProcess')}},[(!_vm.isEmpty(_vm.processes))?_vm._l((_vm.processes),function(process,id){return _c('fr-list-item',{key:id,attrs:{"collapsible":true},on:{"hide":function($event){_vm.reset(id)},"show":function($event){_vm.$emit('loadProcess', process)}}},[_c('div',{staticClass:"d-inline-flex w-100 media",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"media-body align-self-center"},[_c('h6',[_vm._v(_vm._s(process.name))])]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-3 align-self-center"},[_c('div',{ref:("cancel-" + id),refInFor:true,staticClass:"btn btn-sm btn-link float-right btn-cancel"},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-link float-right btn-edit"},[_vm._v(_vm._s(_vm.$t('pages.workflow.start')))])])]),_vm._v(" "),_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-collapse-body"},slot:"list-item-collapse-body"},[_c('fr-process',{ref:id,refInFor:true,attrs:{"processDefinition":process.processDefinition},on:{"cancel":_vm.cancel,"startProcess":function (payload) { return _vm.$emit('startProcess', payload); }}})],1)])}):_c('fr-list-item',[_c('div',{staticClass:"text-muted text-center w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_vm._v("\n                "+_vm._s(_vm.$t('pages.workflow.noProcess'))+"\n            ")])])],2)],1)}
var Processes_staticRenderFns = []
var Processes_esExports = { render: Processes_render, staticRenderFns: Processes_staticRenderFns }
/* harmony default export */ var workflow_Processes = (Processes_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/workflow/Processes.vue
function Processes_injectStyle (ssrContext) {
  __webpack_require__("iIcj")
}
var Processes_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Processes___vue_template_functional__ = false
/* styles */
var Processes___vue_styles__ = Processes_injectStyle
/* scopeId */
var Processes___vue_scopeId__ = "data-v-551caad6"
/* moduleIdentifier (server only) */
var Processes___vue_module_identifier__ = null
var Processes_Component = Processes_normalizeComponent(
  Processes,
  workflow_Processes,
  Processes___vue_template_functional__,
  Processes___vue_styles__,
  Processes___vue_scopeId__,
  Processes___vue_module_identifier__
)

/* harmony default export */ var widgets_workflow_Processes = (Processes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/widgets/WorkflowControlWidget.vue

//
//
//
//
//
//
//
//







/**
 * @description Controlling file for loading the three different parts of workflow (available tasks, available processes, and tasks assigned to you).
 *
 * @fires POST /workflow/taskinstance/ID?_action=complete - Call used to save a task, the expected data is based on the configured workflow
 * @fires PUT  /workflow/taskinstance/ID - Assigns a user to an already created task, expected input is a assignee ID
 * @fires GET /endpoint/gettasksview - Get task view information (based on workflow configuration)
 * @fires POST  /workflow/processinstance/?_action=create - Create or start a new task (based on how workflow is configured)
 * @fires GET  /endpoint/getprocessesforuser- Returns all the current task instances assigned to the user currently logged in
 * @fires GET /workflow/processdefinition/ID - Gets the details for the process definition (based on workflow configuration)
 *
 **/
/* harmony default export */ var WorkflowControlWidget = ({
    name: 'Workflow-Control-Widget',
    components: {
        MyTasks: widgets_workflow_MyTasks,
        GroupTasks: widgets_workflow_GroupTasks,
        Processes: widgets_workflow_Processes
    },
    props: ['userDetails', 'widgetDetails'],
    data: function data() {
        return {
            workflowService: null,
            assignedTasks: {},
            availableTasks: {},
            processes: {}
        };
    },
    created: function created() {
        this.workflowService = this.getRequestService();
        this.loadData();
    },

    methods: {
        completeTask: function completeTask(_ref) {
            var _this = this;

            var id = _ref.id,
                formData = _ref.formData;

            /* istanbul ignore next */
            return this.workflowService.post('/workflow/taskinstance/' + id + '?_action=complete', formData, {
                headers: { 'Accept': 'application/json, text/javascript, */*; q=0.01' }
            }).then(function (response) {
                _this.displayNotification('success', _this.$t('pages.workflow.taskSuccessfullyCompleted'));
                _this.$delete(_this.assignedTasks, id);
            }).then(this.loadData).catch(function (error) {
                if (error.response.data.code === 403) {
                    _this.displayNotification('error', _this.$t('pages.workflow.taskNoLongerAvailable', { taskName: _this.assignedTasks[id].name }));
                    _this.$delete(_this.assignedTasks, id);
                    _this.loadTasks();
                } else {
                    _this.displayNotification('error', error.response.data.message);
                }
            });
        },
        updateAssignment: function updateAssignment(_ref2) {
            var _this2 = this;

            var id = _ref2.id,
                task = _ref2.task,
                assignee = _ref2.assignee;

            /* istanbul ignore next */
            return this.workflowService.put('/workflow/taskinstance/' + task._id, { assignee: assignee }, { headers: { 'If-Match': '"*"' } }).then(function (response) {
                _this2.displayNotification('success', _this2.$t('pages.workflow.assignmentSuccess', { taskName: task.name, assignee: assignee }));
                // Use $delete to remove the task from the list to get the proper transition
                _this2.$delete(_this2.assignedTasks, id);
                _this2.$delete(_this2.availableTasks, id);
            }).then(this.loadData).catch(function (error) {
                if (error.response.data.code === 403) {
                    _this2.displayNotification('error', _this2.$t('pages.workflow.taskNoLongerAvailable', { taskName: _this2.availableTasks[id].name }));
                    _this2.$delete(_this2.availableTasks, id);
                    _this2.loadTasks();
                } else {
                    _this2.displayNotification('error', error.response.data.message);
                }
            });
        },
        startProcess: function startProcess(payload) {
            var _this3 = this;

            /* istanbul ignore next */
            return this.workflowService.post('/workflow/processinstance/?_action=create', payload).then(function (response) {
                _this3.displayNotification('success', _this3.$t('pages.workflow.processStartSuccessMessage'));
                _this3.$refs.processes.cancel(payload._processDefinitionId);
            }).then(this.loadData).catch(function (error) {
                _this3.displayNotification('error', error.response.data.message);
            });
        },
        loadProcessDefinition: function loadProcessDefinition(process) {
            var _this4 = this;

            /* istanbul ignore next */
            process.fetchProcessDefinition().then(function (_ref3) {
                var data = _ref3.data;

                _this4.$set(process, 'processDefinition', data);
            }).catch(function (error) {
                _this4.displayNotification('error', error.reponse.data.message);
            });
        },
        loadProcesses: function loadProcesses() {
            var _this5 = this;

            /* istanbul ignore next */
            return this.workflowService.get('/endpoint/getprocessesforuser')
            // Grab the array of processes off the response object.
            .then(function (processes) {
                return processes.data.processes;
            })
            // Get the process definition for each process object
            .then(function (processes) {
                return axios_default.a.all(processes.map(function (process) {
                    var fetchProcessDefinition = function fetchProcessDefinition() {
                        return _this5.workflowService.get('/workflow/processdefinition/' + process._id);
                    },
                        processDefinition = null;
                    return lodash_default.a.merge(process, { fetchProcessDefinition: fetchProcessDefinition, processDefinition: processDefinition });
                }));
            })
            // Use the built in `$set` function to reactively get the process definitions into component state
            .then(function (processDefinitions) {
                processDefinitions.forEach(function (definition) {
                    _this5.$set(_this5.processes, definition._id, definition);
                });
            });
        },
        getTaskParams: function getTaskParams(userId, groupName) {
            var params = {
                _queryId: 'gettasksview',
                userId: userId
            };

            if (groupName === 'assignedTasks') {
                params.viewType = 'assignee';
            }

            return params;
        },
        getTaskGroup: function getTaskGroup(groupName) {
            return this[groupName];
        },
        toTasks: function toTasks(taskGroup, _ref4) {
            var _this6 = this;

            var data = _ref4.data;

            // Filter out any empty results
            var _$reject = lodash_default.a.reject(data.result, lodash_default.a.isEmpty),
                _$reject2 = slicedToArray_default()(_$reject, 1),
                tasks = _$reject2[0];

            // Process each result


            lodash_default.a.each(tasks, function (taskObj, id) {
                var name = taskObj.name,
                    task = lodash_default.a.first(taskObj.tasks),
                    process = _this6.processes[task.processDefinitionId],
                    fetchProcessDefinition = function fetchProcessDefinition() {
                    return _this6.workflowService.get('/workflow/processdefinition/' + task.processDefinitionId);
                };

                if (lodash_default.a.isUndefined(process)) {
                    process = { fetchProcessDefinition: fetchProcessDefinition };
                }

                // Use $set to maintain reactivity
                _this6.$set(taskGroup, id, { name: name, task: task, process: process });
            });
        },
        loadTasks: function loadTasks() {
            var _this7 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { groupName: 'availableTasks' };

            /* istanbul ignore next */
            return this.workflowService.get('/endpoint/gettasksview', {
                params: this.getTaskParams(this.userDetails.userId, options.groupName)
            }).then(function (response) {
                _this7.toTasks(_this7.getTaskGroup(options.groupName), response);
            });
        },
        loadData: function loadData() {
            var _this8 = this;

            /* istanbul ignore next */
            this.loadProcesses() // Need to load processes first so process definitions are available to tasks when loaded
            .then(function () {
                return axios_default.a.all([_this8.loadTasks({ groupName: 'assignedTasks' }), _this8.loadTasks({ groupName: 'availableTasks' })]);
            }).catch(function (error) {
                _this8.displayNotification('error', error.response.data.message);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3196de6a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/WorkflowControlWidget.vue
var WorkflowControlWidget_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Processes',{ref:"processes",attrs:{"processes":_vm.processes},on:{"startProcess":_vm.startProcess,"loadProcess":_vm.loadProcessDefinition}}),_vm._v(" "),_c('MyTasks',{attrs:{"tasks":_vm.assignedTasks},on:{"updateAssignment":_vm.updateAssignment,"completeTask":_vm.completeTask,"loadProcess":_vm.loadProcessDefinition}}),_vm._v(" "),_c('GroupTasks',{attrs:{"tasks":_vm.availableTasks},on:{"updateAssignment":_vm.updateAssignment,"loadProcess":_vm.loadProcessDefinition}})],1)}
var WorkflowControlWidget_staticRenderFns = []
var WorkflowControlWidget_esExports = { render: WorkflowControlWidget_render, staticRenderFns: WorkflowControlWidget_staticRenderFns }
/* harmony default export */ var widgets_WorkflowControlWidget = (WorkflowControlWidget_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/widgets/WorkflowControlWidget.vue
function WorkflowControlWidget_injectStyle (ssrContext) {
  __webpack_require__("WVcr")
}
var WorkflowControlWidget_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var WorkflowControlWidget___vue_template_functional__ = false
/* styles */
var WorkflowControlWidget___vue_styles__ = WorkflowControlWidget_injectStyle
/* scopeId */
var WorkflowControlWidget___vue_scopeId__ = "data-v-3196de6a"
/* moduleIdentifier (server only) */
var WorkflowControlWidget___vue_module_identifier__ = null
var WorkflowControlWidget_Component = WorkflowControlWidget_normalizeComponent(
  WorkflowControlWidget,
  widgets_WorkflowControlWidget,
  WorkflowControlWidget___vue_template_functional__,
  WorkflowControlWidget___vue_styles__,
  WorkflowControlWidget___vue_scopeId__,
  WorkflowControlWidget___vue_module_identifier__
)

/* harmony default export */ var dashboard_widgets_WorkflowControlWidget = (WorkflowControlWidget_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @description Controlling component for the dashboard, loads widgets set and configured in the ui-dashboard config file.
 *
 * @fires GET config/ui/dashboard - Read of the config file ui-dashboard.json
 */
/* harmony default export */ var dashboard = ({
    name: 'Dashboard',
    components: {
        Welcome: dashboard_widgets_WelcomeWidget,
        Workflow: dashboard_widgets_WorkflowControlWidget
    },
    data: function data() {
        return {
            widgets: [],
            userDetails: this.$root.userStore.getUserState()
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            /* istanbul ignore next */
            this.getRequestService().get('config/ui/dashboard').then(function (_ref) {
                var data = _ref.data;

                _this.widgets = data.dashboard.widgets;

                if (_this.$root.applicationStore.state.workflow) {
                    _this.widgets.push({
                        type: 'Workflow',
                        size: 'large'
                    });
                }
            }).catch(function (error) {
                _this.displayNotification('error', error.response.data.message);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2358b23a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/index.vue
var dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[(_vm.widgets.length)?_c('b-row',_vm._l((_vm.widgets),function(widget,index){return _c('div',{key:widget.type + index,class:{'col-sm-4': widget.size === 'small', 'col-sm-6': widget.size === 'medium', 'col-sm-12': widget.size === 'large', 'mt-4': true}},[_c(widget.type,{tag:"component",attrs:{"userDetails":_vm.userDetails,"details":widget.details}})],1)})):_c('b-jumbotron',{staticClass:"mt-4 text-center"},[_c('div',{staticClass:"d-flex justify-content-center mt-3"},[_c('i',{staticClass:"fa fa-binoculars align-self-center flex-fow-1 mr-4 mb-3",staticStyle:{"font-size":"52px"}}),_vm._v(" "),_c('div',{staticClass:"flex-fow-1"},[_c('h2',[_vm._v(_vm._s(_vm.$t('pages.dashboard.noWidget')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('pages.dashboard.noWidgetSubText'))}})])])])],1)}
var dashboard_staticRenderFns = []
var dashboard_esExports = { render: dashboard_render, staticRenderFns: dashboard_staticRenderFns }
/* harmony default export */ var components_dashboard = (dashboard_esExports);
// CONCATENATED MODULE: ./src/components/dashboard/index.vue
var dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var dashboard___vue_template_functional__ = false
/* styles */
var dashboard___vue_styles__ = null
/* scopeId */
var dashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dashboard___vue_module_identifier__ = null
var dashboard_Component = dashboard_normalizeComponent(
  dashboard,
  components_dashboard,
  dashboard___vue_template_functional__,
  dashboard___vue_styles__,
  dashboard___vue_scopeId__,
  dashboard___vue_module_identifier__
)

/* harmony default export */ var src_components_dashboard = (dashboard_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/PolicyPanel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Part of the password policy component to display the list of policy items required
 *
 **/
/* harmony default export */ var PolicyPanel = ({
    name: 'PolicyPanel',
    props: ['policies', 'policyFailures'],
    data: function data() {
        return {};
    },

    computed: {
        isValid: function isValid() {
            return lodash_default.a.isArray(this.policyFailures) && lodash_default.a.isEmpty(this.policyFailures);
        },
        isLoading: function isLoading() {
            return this.policyFailures === 'loading' || this.policyFailures === false;
        }
    },
    methods: {
        translate: function translate(policy) {
            var path = 'common.policyValidationMessages.' + policy.name;

            return this.$t(path, policy.params);
        },

        includes: lodash_default.a.includes
    },
    watch: {
        policyFailures: function policyFailures(value) {
            this.policyFailures = value;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65da22d7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/PolicyPanel.vue
var PolicyPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card border-0 mt-3"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","duration":150}},[(!_vm.isLoading)?[(!_vm.isValid)?_c('ul',{staticClass:"text-left pl-3"},_vm._l((_vm.policies),function(policy){return _c('li',{key:policy.policyId,class:[{'fr-valid': !_vm.includes(_vm.policyFailures, policy.name)}, 'text-primary fr-policy-list-item']},[_c('small',{staticClass:"text-body"},[_vm._v(_vm._s(_vm.translate(policy)))])])})):_c('div',{staticClass:"alert alert-success mt-1",attrs:{"role":"alert"}},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "+_vm._s(_vm.$t('common.policyValidationMessages.successMessages.password'))+"\n            ")])]:_vm._e()],2)],1)}
var PolicyPanel_staticRenderFns = []
var PolicyPanel_esExports = { render: PolicyPanel_render, staticRenderFns: PolicyPanel_staticRenderFns }
/* harmony default export */ var utils_PolicyPanel = (PolicyPanel_esExports);
// CONCATENATED MODULE: ./src/components/utils/PolicyPanel.vue
function PolicyPanel_injectStyle (ssrContext) {
  __webpack_require__("gMW2")
}
var PolicyPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var PolicyPanel___vue_template_functional__ = false
/* styles */
var PolicyPanel___vue_styles__ = PolicyPanel_injectStyle
/* scopeId */
var PolicyPanel___vue_scopeId__ = "data-v-65da22d7"
/* moduleIdentifier (server only) */
var PolicyPanel___vue_module_identifier__ = null
var PolicyPanel_Component = PolicyPanel_normalizeComponent(
  PolicyPanel,
  utils_PolicyPanel,
  PolicyPanel___vue_template_functional__,
  PolicyPanel___vue_styles__,
  PolicyPanel___vue_scopeId__,
  PolicyPanel___vue_module_identifier__
)

/* harmony default export */ var components_utils_PolicyPanel = (PolicyPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/PolicyPasswordInput.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description The main display for the password policy component. Connects a text field to check policy on input to see if password correctly matches configured policy (makes use of policy.json)
 *
 * @fires POST /policy/selfservice/registration/?_action=validateObject - Submits an object in its current state to policy for validation against the configured policy
 *
 **/
/* harmony default export */ var PolicyPasswordInput = ({
    name: 'PolicyPasswordInput',
    inject: ['$validator'],
    components: {
        'fr-floating-label-input': components_utils_FloatingLabelInput,
        'fr-policy-panel': components_utils_PolicyPanel
    },
    props: {
        policyApi: { required: true, type: String },
        value: String,
        label: String,
        exclude: {
            required: false,
            type: Array,
            default: function _default() {
                return [{
                    name: 'REQUIRED',
                    predicate: function predicate(policyRequirements) {
                        return lodash_default.a.includes(policyRequirements, 'REQUIRED') && lodash_default.a.includes(policyRequirements, 'MIN_LENGTH');
                    }
                }, 'VALID_TYPE', 'CANNOT_CONTAIN_OTHERS'];
            }
        }
    },
    data: function data() {
        return {
            policies: [],
            password: this.value
        };
    },

    computed: {
        policyFailures: function policyFailures() {
            var failures = this.errors.firstByRule('password', 'policy');

            if (lodash_default.a.isUndefined(this.fields.password)) {
                return 'loading';
            } else if (lodash_default.a.isNull(failures) && this.fields.password.valid) {
                return [];
            } else {
                return failures;
            }
        },
        customInput: function customInput() {
            return !lodash_default.a.isUndefined(this.$slots['custom-input']);
        }
    },
    methods: {
        /**
         * Predicates whether item matches 'password'. Policy Definition and Policy Failure objects
         * have different shapes, so this function can be used as a predicate for both.
         * @param {String} propName - The name of the property grab
         * @param {Object} policyRequirementItem - object to predicate on
         * @return {Boolean}
         */
        isPasswordPolicyItem: lodash_default.a.curry(function (propName, policyRequirementItem) {
            return !lodash_default.a.isEmpty(policyRequirementItem[propName].match('password'));
        }),
        /**
         * convert policy definition into a simple structure to work with
         * @param {Object} policyDefinition
         * @param {String[]} policyDefinition.policyRequirements - singleton array with policy name
         * @param {Object} policyDefinition.params - objet containing params for policy (e.g. `{ params: { numNum: 1 } }
         * @return {Object} - {name<String>, params<Object>}
         */
        toSimplePolicyObject: function toSimplePolicyObject(policyDefinition) {
            var policyRequirements = policyDefinition.policyRequirements,
                params = policyDefinition.params,
                name = lodash_default.a.first(policyRequirements);

            if (!lodash_default.a.isUndefined(name)) {
                return { name: name, params: params };
            } else {
                return {};
            }
        },

        /**
         * Change an array of Failed Policy objects to an array of policy names
         * @param {Object} failedPolicySet - policy service response object
         * @param {Object[]} failedPolicySet.failedPolicyRequirements - the list to map
         * @return {String[]}
         */
        toPolicyNames: function toPolicyNames(failedPolicySet) {
            var failedPolicyRequirements = failedPolicySet.failedPolicyRequirements || [],
                policyNames = failedPolicyRequirements.filter(this.isPasswordPolicyItem('property')).map(function (failedPolicyDefinition) {
                return lodash_default.a.at(failedPolicyDefinition, ['policyRequirements[0].policyRequirement']);
            });

            return lodash_default.a.flatten(policyNames);
        },

        /**
         * Remove from the policy service return set of policies those that are defined in the `exclude` prop
         * @param {Object} policyRequirementSet - policy service response object
         * @return {Object} - edited version of the policyRequirementSet
         */
        makeExclusions: function makeExclusions(policyRequirementSet) {
            var policyRequirements = void 0,
                policies = void 0;

            if (policyRequirementSet && policyRequirementSet.policyRequirements) {
                policyRequirements = policyRequirementSet.policyRequirements;
            } else {
                policyRequirements = [];
            }

            if (policyRequirementSet && policyRequirementSet.policies) {
                policies = policyRequirementSet.policies;
            } else {
                policies = [];
            }

            var rejectPolicy = function rejectPolicy(requirement) {
                return lodash_default.a.reject(policies, function (policy) {
                    return lodash_default.a.first(policy.policyRequirements) === requirement;
                });
            };

            this.exclude.forEach(function (exclusion) {
                if (lodash_default.a.isObject(exclusion)) {
                    if (exclusion.predicate(policyRequirements)) {
                        policies = rejectPolicy(exclusion.name);
                    }
                } else if (lodash_default.a.isString(exclusion)) {
                    if (lodash_default.a.includes(policyRequirements, exclusion)) {
                        policies = rejectPolicy(exclusion);
                    }
                }
            });

            return assign_default()({}, policyRequirementSet, { policyRequirements: policyRequirements, policies: policies });
        },
        formatPayload: function formatPayload(password) {
            if (this.policyApi.match('registration')) {
                return { user: { password: password } };
            } else {
                return { password: password };
            }
        },
        getAction: function getAction() {
            return this.policyApi.match('selfservice') ? 'validateObject' : 'validateProperty';
        }
    },
    created: function created() {
        var _this2 = this;

        // Initialize the policy service to be used in validation calls and the preliminary get call.
        var headers = this.getAnonymousHeaders(),
            policyService = this.getRequestService({ headers: headers }),
            formatPayload = this.formatPayload.bind(this),

        // Create validation service call and bind to component scope.
        requestPolicyValidation = function (password) {
            var _this = this;

            var data = formatPayload(password);

            /* istanbul ignore next */
            return policyService.post('/policy/' + this.policyApi + '/?_action=' + this.getAction(), data).then(function (_ref) {
                var data = _ref.data;
                return _this.toPolicyNames(data);
            }).catch(function () {
                /* istanbul ignore next */
                _this.displayNotification('error', _this.$t('common.policyValidationMessages.policyServiceError'));
            });
        }.bind(this);

        // Extend the validator with the custom validation rule.
        this.$validator.extend('policy', {
            validate: function validate(value, args) {
                // Make policy service call.
                /* istanbul ignore next */
                return requestPolicyValidation(value).then(function (policyFailures) {
                    return {
                        valid: lodash_default.a.isEmpty(policyFailures),
                        data: policyFailures
                    };
                });
            },
            getMessage: function getMessage(field, params, data) {
                return data;
            }
        });

        // Get the initial policy list from the policy service.
        /* istanbul ignore next */
        policyService.get('/policy/' + this.policyApi).then(function (_ref2) {
            var data = _ref2.data;
            return lodash_default.a.head(data.properties.filter(_this2.isPasswordPolicyItem('name')));
        }).then(function (policyRequirementSet) {
            return _this2.makeExclusions(policyRequirementSet);
        }).then(function (_ref3) {
            var policies = _ref3.policies;

            _this2.policies = policies.map(_this2.toSimplePolicyObject).filter(function (p) {
                return !lodash_default.a.isEmpty(p);
            });
        }).catch(function () {
            /* istanbul ignore next */
            _this2.displayNotification('error', _this2.$t('common.policyValidationMessages.policyServiceError.' + _this2.policyApi));
            _this2.$router.push('/login');
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae38537c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/PolicyPasswordInput.vue
var PolicyPasswordInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"mb-0"},[(!_vm.customInput)?_vm._t("input-with-validation-panel",[_c('fr-floating-label-input',{directives:[{name:"validate",rawName:"v-validate.initial",value:('required|policy'),expression:"'required|policy'",modifiers:{"initial":true}}],attrs:{"name":"password","fieldName":"password","type":"password","label":_vm.label || _vm.$t('common.placeholders.password'),"reveal":true,"showErrorState":false},on:{"input":function($event){_vm.$emit('input', $event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},[_c('fr-policy-panel',{attrs:{"slot":"validationError","policies":_vm.policies,"policyFailures":_vm.policyFailures},slot:"validationError"})],1)]):[_vm._t("custom-input"),_vm._v(" "),_c('fr-policy-panel',{attrs:{"policies":_vm.policies,"policyFailures":_vm.policyFailures}})]],2)}
var PolicyPasswordInput_staticRenderFns = []
var PolicyPasswordInput_esExports = { render: PolicyPasswordInput_render, staticRenderFns: PolicyPasswordInput_staticRenderFns }
/* harmony default export */ var utils_PolicyPasswordInput = (PolicyPasswordInput_esExports);
// CONCATENATED MODULE: ./src/components/utils/PolicyPasswordInput.vue
var PolicyPasswordInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var PolicyPasswordInput___vue_template_functional__ = false
/* styles */
var PolicyPasswordInput___vue_styles__ = null
/* scopeId */
var PolicyPasswordInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PolicyPasswordInput___vue_module_identifier__ = null
var PolicyPasswordInput_Component = PolicyPasswordInput_normalizeComponent(
  PolicyPasswordInput,
  utils_PolicyPasswordInput,
  PolicyPasswordInput___vue_template_functional__,
  PolicyPasswordInput___vue_styles__,
  PolicyPasswordInput___vue_scopeId__,
  PolicyPasswordInput___vue_module_identifier__
)

/* harmony default export */ var components_utils_PolicyPasswordInput = (PolicyPasswordInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/mixins/ResourceMixin.vue



/**
 * @description Resource management mixin used for generating an update patch and  handling policy errors
 *
 **/
/* harmony default export */ var ResourceMixin = ({
    name: 'Resource-Mixin',
    methods: {
        generateUpdatePatch: function generateUpdatePatch(o, n) {
            var originalFrom = lodash_default.a.cloneDeep(o),
                newForm = lodash_default.a.cloneDeep(n),
                changes = void 0;

            if (lodash_default.a.isArray(newForm)) {
                changes = lodash_default.a.filter(newForm, function (field, index) {
                    if (field.value !== originalFrom[index].value) {
                        return true;
                    }
                    return false;
                });
            } else {
                changes = [];

                lodash_default.a.each(newForm, function (value, key) {
                    if (originalFrom[key] !== newForm[key]) {
                        changes.push({
                            value: newForm[key],
                            name: key
                        });
                    }
                });
            }

            return lodash_default.a.map(changes, function (formField) {
                if (formField.value === '' || formField.value === null) {
                    return { operation: 'remove', field: '/' + formField.name };
                } else {
                    return { operation: 'add', field: '/' + formField.name, value: formField.value };
                }
            });
        },
        findPolicyError: function findPolicyError(errorResponse, properties) {
            var _this = this;

            var error = [];

            if (lodash_default.a.has(errorResponse, 'data.detail.failedPolicyRequirements')) {
                lodash_default.a.each(errorResponse.data.detail.failedPolicyRequirements, function (policy) {
                    if (policy.policyRequirements.length > 0) {
                        var displayTitle = '',
                            foundProperty = lodash_default.a.find(properties, function (prop) {
                            return prop.key === policy.property;
                        }),
                            params = policy.policyRequirements[0].params || {};

                        if (foundProperty) {
                            if (foundProperty.title) {
                                displayTitle = foundProperty.title;
                            } else {
                                displayTitle = foundProperty.key;
                            }

                            params.property = displayTitle;
                        }

                        error.push({
                            exists: displayTitle.length > 0,
                            field: policy.property,
                            msg: _this.$t('common.policyValidationMessages.' + policy.policyRequirements[0].policyRequirement, params)
                        });
                    }
                });
            }

            return error;
        }
    }
});
// CONCATENATED MODULE: ./src/components/utils/mixins/ResourceMixin.vue
var ResourceMixin_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var ResourceMixin___vue_template__ = null
/* template functional */
  var ResourceMixin___vue_template_functional__ = false
/* styles */
var ResourceMixin___vue_styles__ = null
/* scopeId */
var ResourceMixin___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ResourceMixin___vue_module_identifier__ = null
var ResourceMixin_Component = ResourceMixin_normalizeComponent(
  ResourceMixin,
  ResourceMixin___vue_template__,
  ResourceMixin___vue_template_functional__,
  ResourceMixin___vue_styles__,
  ResourceMixin___vue_scopeId__,
  ResourceMixin___vue_module_identifier__
)

/* harmony default export */ var mixins_ResourceMixin = (ResourceMixin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/access/EditResource.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/**
 * @description Full page that provides view/edit of a specific resource for delegated admin. Auto generates fields based on backend return.
 * Currently generates string, number, boolean and password (not based on type, but on field name being passsword).
 *
 * @fires GET schema/type/name/ (e.g. schema/managed/user) - Schema for a resource
 * @fires GET privilege/type/name/id (e.g. privilege/managed/user/_id) - Privileges for a specific record of a resource
 * @fires GET type/name/id (e.g. managed/user/_id) - Resource details, in this context privileges will restrict the data return
 * @fires DELETE type/name/id (e.g. managed/user/_id) - Deletes resource record
 * @fires PATCH type/name/id (e.g. managed/user/_id) - Submits a patch object of changes for the provided resource record
 */
/* harmony default export */ var EditResource = ({
    name: 'Edit-Resource',
    components: {
        'fr-validation-error': components_utils_ValidationError,
        'fr-password-policy-input': components_utils_PolicyPasswordInput
    },
    mixins: [mixins_ResourceMixin],
    data: function data() {
        return {
            name: this.$route.params.resourceName,
            resource: this.$route.params.resourceType,
            id: this.$route.params.resourceId,
            displayProperties: [],
            canDelete: false,
            canChangePassword: false,
            passwordInputType: 'password',
            showPassword: true,
            disableSaveButton: false,
            icon: '',
            displayNameField: '',
            displaySecondaryTitleField: '',
            formFields: {},
            oldFormFields: {}
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    $_veeValidate: {
        validator: 'new'
    },
    methods: {
        loadData: function loadData() {
            var _this = this;

            var idmInstance = this.getRequestService();

            /* istanbul ignore next */
            axios_default.a.all([idmInstance.get('schema/' + this.resource + '/' + this.name), idmInstance.get('privilege/' + this.resource + '/' + this.name + '/' + this.id), idmInstance.get(this.resource + '/' + this.name + '/' + this.id)]).then(axios_default.a.spread(function (schema, privilege, resourceDetails) {
                _this.generateDisplay(schema.data, privilege.data, resourceDetails.data);
            })).catch(function (error) {
                _this.displayNotification('error', error.response.data.message);
            });
        },
        generateDisplay: function generateDisplay(schema, privilege, resourceDetails) {
            var _this2 = this;

            this.oldFormFields = lodash_default.a.pick(resourceDetails, privilege.VIEW.properties);

            if (privilege.DELETE.allowed) {
                this.canDelete = true;
            }

            if (schema.icon) {
                this.icon = schema.icon;
            } else {
                this.icon = '';
            }

            // Add reactive form for changes
            lodash_default.a.each(this.oldFormFields, function (value, key) {
                _this2.$set(_this2.formFields, key, value);
            });

            if (privilege.VIEW.allowed) {
                // if there are no update properties disable the save button
                if (privilege.UPDATE.properties.length === 0) {
                    this.disableSaveButton = true;
                }
                lodash_default.a.each(this.mergePrivilegeProperties(privilege, schema), function (createPriv) {
                    var tempProp = schema.properties[createPriv.attribute];

                    if (lodash_default.a.indexOf(schema.required, createPriv.attribute) !== -1) {
                        tempProp.required = true;
                    }

                    if (createPriv.attribute === 'password' && !createPriv.readOnly) {
                        _this2.canChangePassword = true;
                    }

                    tempProp.key = createPriv.attribute;

                    // Try and do some primary detection for a display name
                    if ((lodash_default.a.toLower(createPriv.attribute) === 'username' || lodash_default.a.toLower(createPriv.attribute) === 'name') && _this2.displayNameField.length === 0) {
                        _this2.displayNameField = createPriv.attribute;
                    }

                    // Try and do some primary detection for a secondary title
                    if ((lodash_default.a.toLower(createPriv.attribute) === 'title' || lodash_default.a.toLower(createPriv.attribute) === 'email' || lodash_default.a.toLower(createPriv.attribute) === 'type' || lodash_default.a.toLower(createPriv.attribute) === 'mail') && _this2.displaySecondaryTitleField.length === 0) {
                        _this2.displaySecondaryTitleField = createPriv.attribute;
                    }

                    // Add fields that may not be set yet from reading the resource
                    if (lodash_default.a.isUndefined(_this2.formFields[createPriv.attribute])) {
                        if (tempProp.type === 'boolean') {
                            _this2.$set(_this2.formFields, createPriv.attribute, false);
                            _this2.oldFormFields[createPriv.attribute] = false;
                        } else {
                            _this2.$set(_this2.formFields, createPriv.attribute, '');
                            _this2.oldFormFields[createPriv.attribute] = '';
                        }
                    }

                    if (createPriv.readOnly) {
                        tempProp.isReadOnly = true;
                    }

                    _this2.displayProperties.push(tempProp);
                });
            }
        },
        deleteResource: function deleteResource() {
            var _this3 = this;

            var idmInstance = this.getRequestService();

            this.$refs.deleteModal.hide();

            /* istanbul ignore next */
            idmInstance.delete(this.resource + '/' + this.name + '/' + this.id).then(function () {
                _this3.displayNotification('success', _this3.$t('pages.access.deleteResource'));

                _this3.$router.push({
                    name: 'ListResource',
                    params: {
                        resourceType: _this3.resource,
                        resourceName: _this3.name
                    }
                });
            }).catch(function (error) {
                _this3.displayNotification('error', error.response.data.message);
            });
        },

        // Hide/show for special password field
        revealNew: function revealNew() {
            if (this.passwordInputType === 'password') {
                this.passwordInputType = 'text';
                this.showPassword = false;
            } else {
                this.passwordInputType = 'password';
                this.showPassword = true;
            }
        },
        saveResource: function saveResource() {
            var _this4 = this;

            var idmInstance = this.getRequestService();

            this.errors.clear('mainEdit');

            /* istanbul ignore next */
            this.$validator.validate('mainEdit.*').then(function (valid) {
                if (valid) {
                    var saveData = _this4.generateUpdatePatch(lodash_default.a.clone(_this4.oldFormFields), lodash_default.a.clone(_this4.formFields));

                    idmInstance.patch(_this4.resource + '/' + _this4.name + '/' + _this4.id, saveData).then(function () {
                        _this4.displayNotification('success', _this4.$t('pages.access.successEdited', { resource: lodash_default.a.capitalize(_this4.name) }));
                    }, function (error) {
                        var generatedErrors = _this4.findPolicyError(error.response, _this4.displayProperties);

                        _this4.errors.clear();

                        if (generatedErrors.length > 0) {
                            lodash_default.a.each(generatedErrors, function (generatedError) {
                                if (generatedError.exists) {
                                    generatedError.scope = 'mainEdit';
                                    _this4.errors.add(generatedError);
                                }
                            });
                        } else {
                            _this4.displayNotification('error', _this4.$t('pages.access.invalidEdit'));
                        }
                    });
                } else {
                    _this4.displayNotification('error', _this4.$t('pages.access.invalidEdit'));
                }
            });
        },
        savePassword: function savePassword() {
            var _this5 = this;

            var idmInstance = this.getRequestService();

            /* istanbul ignore next */
            this.$validator.validate('*').then(function (valid) {
                if (valid) {
                    var saveData = [{ operation: 'add', field: '/password', value: _this5.formFields['password'] }];

                    _this5.$refs.resetModal.hide();
                    _this5.formFields['password'] = '';

                    idmInstance.patch(_this5.resource + '/' + _this5.name + '/' + _this5.id, saveData).then(function () {
                        _this5.displayNotification('success', _this5.$t('pages.access.successSavePassword'));
                    }, function () {
                        _this5.displayNotification('error', _this5.$t('pages.access.failedSavePassword'));
                    });
                } else {
                    _this5.displayNotification('error', _this5.$t('pages.access.invalidEdit'));
                }
            });
        },
        mergePrivilegeProperties: function mergePrivilegeProperties(privilege, schema) {
            var properties = [];

            lodash_default.a.each(schema.order, function (schemaPropName) {
                var canView = lodash_default.a.indexOf(privilege.VIEW.properties, schemaPropName) > -1,
                    canUpdate = lodash_default.a.indexOf(privilege.UPDATE.properties, schemaPropName) > -1,
                    property = { attribute: schemaPropName };

                if (canUpdate) {
                    properties.push(property);
                } else if (canView) {
                    property.readOnly = true;
                    properties.push(property);
                }
            });

            return properties;
        }
    },
    computed: {
        secondaryTitle: function secondaryTitle() {
            var tempDisplayName = this.resource + ' - ' + this.name;

            if (this.displaySecondaryTitleField.length > 0) {
                tempDisplayName = this.formFields[this.displaySecondaryTitleField];
            }

            return tempDisplayName;
        },
        displayName: function displayName() {
            var tempDisplayName = this.id;

            if (this.displayNameField.length > 0) {
                tempDisplayName = this.formFields[this.displayNameField];
            }

            return tempDisplayName;
        },
        setIcon: function setIcon() {
            if (this.icon.length === 0) {
                this.icon = 'fa-cube';
            }

            return 'fa fa-3x ' + this.icon;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98515774","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/access/EditResource.vue
var EditResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('div',{staticClass:"d-sm-flex my-4"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"rounded-circle fr-resource-circle text-light bg-primary mr-4"},[_c('i',{class:_vm.setIcon})]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h1',[_vm._v(_vm._s(_vm.displayName))]),_vm._v(" "),_c('h6',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.secondaryTitle))])])]),_vm._v(" "),(_vm.canChangePassword || _vm.canDelete)?_c('div',{staticClass:"ml-auto my-4 my-sm-0 align-self-center align-self-end"},[_c('b-dropdown',{staticClass:"m-md-2",attrs:{"id":"resourceActions","text":"Actions","right":"","variant":"primary"}},[(_vm.canChangePassword)?_c('b-dropdown-item',{directives:[{name:"b-modal",rawName:"v-b-modal.resetModal",modifiers:{"resetModal":true}}]},[_vm._v(_vm._s(_vm.$t('pages.access.resetPassword')))]):_vm._e(),_vm._v(" "),(_vm.canDelete)?_c('b-dropdown-item',{directives:[{name:"b-modal",rawName:"v-b-modal.deleteModal",modifiers:{"deleteModal":true}}]},[_vm._v(_vm._s(_vm.$t("common.form.delete"))+" "+_vm._s(this.name))]):_vm._e()],1)],1):_vm._e()])])],1),_vm._v(" "),_c('b-tabs',{attrs:{"flex-column":"","flex-sm-row":""}},[_c('b-tab',{attrs:{"title":this.$t('pages.access.details'),"active":""}},[_c('b-card',[(_vm.displayProperties.length > 0)?[_vm._l((_vm.displayProperties),function(field,index){return [(!field.isReadOnly)?[((field.type === 'string' || field.type === 'number') && field.encryption === undefined)?_c('b-form-group',{key:'editResource' +index,attrs:{"label":field.title,"label-for":"field.key","horizontal":""}},[(field.type === 'string')?_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:(field.required ? 'required' : ''),expression:"field.required ? 'required' : ''"}],ref:index === 0 ? 'focusInput' : '',refInFor:true,class:[{'is-invalid': _vm.errors.has(("mainEdit." + (field.key)))}],attrs:{"data-vv-validate-on":"submit","name":field.key,"type":"text","data-vv-as":field.title,"data-vv-scope":"mainEdit","autocomplete":field.key},model:{value:(_vm.formFields[field.key]),callback:function ($$v) {_vm.$set(_vm.formFields, field.key, (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"formFields[field.key]"}}):_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:(field.required ? 'required' : ''),expression:"field.required ? 'required' : ''"}],ref:index === 0 ? 'focusInput' : '',refInFor:true,class:[{'is-invalid': _vm.errors.has(("mainEdit." + (field.key)))}],attrs:{"horizontal":"","data-vv-validate-on":"submit","name":field.key,"type":"number","data-vv-as":field.title,"data-vv-scope":"mainEdit","autocomplete":field.key},model:{value:(_vm.formFields[field.key]),callback:function ($$v) {_vm.$set(_vm.formFields, field.key, _vm._n($$v))},expression:"formFields[field.key]"}}),_vm._v(" "),_c('fr-validation-error',{attrs:{"validatorErrors":_vm.errors,"fieldName":("mainEdit." + (field.key))}})],1):_vm._e(),_vm._v(" "),(field.type === 'boolean')?_c('b-form-group',{key:'createResource' +index},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-form-label col-sm-3",attrs:{"for":field.title}},[_vm._v(_vm._s(field.title))]),_vm._v(" "),_c('div',{staticClass:"mr-auto"},[_c('toggle-button',{staticClass:"mt-2 p-0 fr-toggle-primary",attrs:{"height":28,"width":56,"sync":true,"cssColors":true,"labels":{checked: _vm.$t('common.form.yes'), unchecked: _vm.$t('common.form.no')}},model:{value:(_vm.formFields[field.key]),callback:function ($$v) {_vm.$set(_vm.formFields, field.key, $$v)},expression:"formFields[field.key]"}})],1)])]):_vm._e()]:[((field.type === 'string' || field.type === 'number') && field.encryption === undefined)?_c('b-form-group',{key:'readResource' +index,attrs:{"label":field.title,"label-for":"field.key","horizontal":""}},[_c('b-form-input',{attrs:{"horizontal":"","type":"text","plaintext":""},model:{value:(_vm.formFields[field.key]),callback:function ($$v) {_vm.$set(_vm.formFields, field.key, $$v)},expression:"formFields[field.key]"}})],1):_vm._e(),_vm._v(" "),(field.type === 'boolean')?_c('b-form-group',{key:'readResource' +index},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-form-label col-sm-3",attrs:{"for":field.title}},[_vm._v(_vm._s(field.title))]),_vm._v(" "),_c('div',{staticClass:"mr-auto"},[_c('toggle-button',{staticClass:"mt-2 p-0 fr-toggle-primary",attrs:{"height":28,"width":56,"disabled":true,"sync":true,"cssColors":true,"labels":{checked: _vm.$t('common.form.yes'), unchecked: _vm.$t('common.form.no')}},model:{value:(_vm.formFields[field.key]),callback:function ($$v) {_vm.$set(_vm.formFields, field.key, $$v)},expression:"formFields[field.key]"}})],1)])]):_vm._e()]]}),_vm._v(" "),(!_vm.disableSaveButton)?_c('div',{staticClass:"float-right mt-4"},[_c('b-btn',{attrs:{"type":"button","variant":"primary"},on:{"click":_vm.saveResource}},[_vm._v(_vm._s(_vm.$t('common.form.save')))])],1):_vm._e()]:_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t('pages.access.noAvailableProperties'))+"\n                ")])],2)],1)],1),_vm._v(" "),(_vm.canDelete)?_c('b-modal',{ref:"deleteModal",attrs:{"id":"deleteModal","title":this.$t('pages.access.deleteModalTitle')}},[_c('div',[_vm._v("\n            "+_vm._s(_vm.$t('pages.access.deleteConfirm'))+" "+_vm._s(this.name)+"?\n        ")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"type":"button","variant":"danger"},on:{"click":_vm.deleteResource}},[_vm._v(_vm._s(_vm.$t('common.form.delete')))])],1)])]):_vm._e(),_vm._v(" "),(_vm.canChangePassword)?_c('b-modal',{ref:"resetModal",attrs:{"id":"resetModal","title":this.$t('pages.access.resetPassword')}},[_c('fr-password-policy-input',{attrs:{"policyApi":(_vm.resource + "/" + _vm.name + "/policyTest")},model:{value:(_vm.formFields['password']),callback:function ($$v) {_vm.$set(_vm.formFields, 'password', $$v)},expression:"formFields['password']"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"slot":"custom-input"},slot:"custom-input"},[_c('label',{attrs:{"for":"updatePassword"}},[_vm._v(_vm._s(_vm.$t('pages.access.password')))]),_vm._v(" "),_c('div',{staticClass:"form-label-password form-label-group mb-0"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate.initial",value:('required|policy'),expression:"'required|policy'",modifiers:{"initial":true}}],attrs:{"id":"updatePassword","autocomplete":"password","type":_vm.passwordInputType,"name":"password"},model:{value:(_vm.formFields['password']),callback:function ($$v) {_vm.$set(_vm.formFields, 'password', $$v)},expression:"formFields['password']"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.revealNew}},[_c('i',{class:[{'fa-eye-slash': !_vm.showPassword}, {'fa-eye': _vm.showPassword}, 'fa']})])])],1)])],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"type":"button","variant":"primary"},on:{"click":_vm.savePassword}},[_vm._v(_vm._s(_vm.$t('common.form.save')))])],1)])],1):_vm._e()],1)}
var EditResource_staticRenderFns = []
var EditResource_esExports = { render: EditResource_render, staticRenderFns: EditResource_staticRenderFns }
/* harmony default export */ var access_EditResource = (EditResource_esExports);
// CONCATENATED MODULE: ./src/components/access/EditResource.vue
var EditResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var EditResource___vue_template_functional__ = false
/* styles */
var EditResource___vue_styles__ = null
/* scopeId */
var EditResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditResource___vue_module_identifier__ = null
var EditResource_Component = EditResource_normalizeComponent(
  EditResource,
  access_EditResource,
  EditResource___vue_template_functional__,
  EditResource___vue_styles__,
  EditResource___vue_scopeId__,
  EditResource___vue_module_identifier__
)

/* harmony default export */ var components_access_EditResource = (EditResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/common/Captcha.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Selfservice stage for multiple selfservice flows, displays a google captcha
 *
 **/
/* harmony default export */ var Captcha = ({
    name: 'Captcha',
    props: {
        advanceStage: { required: false },
        selfServiceDetails: { required: true },
        apiType: { required: false }
    },
    created: function created() {
        var recaptchaScript = document.createElement('script');

        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
        document.head.appendChild(recaptchaScript);
    },
    mounted: function mounted() {
        this.loadRecaptcha();
    },

    methods: {
        loadRecaptcha: function loadRecaptcha() {
            var _this = this;

            /* istanbul ignore next */
            if (this.selfServiceDetails.requirements.properties.response.recaptchaSiteKey || this.selfServiceDetails.requirements.properties.response.recaptchaSiteKey.length === 0) {
                this.displayNotification('error', this.$t('pages.selfservice.captchaError'));
            } else {
                setTimeout(function () {
                    if (typeof window.grecaptcha === 'undefined') {
                        _this.loadRecaptcha();
                    } else {
                        window.grecaptcha.render('recaptchaContainer', {
                            sitekey: _this.selfServiceDetails.requirements.properties.response.recaptchaSiteKey,
                            callback: _this.handleCaptchaCallback
                        });
                    }
                }, 500);
            }
        },
        handleCaptchaCallback: function handleCaptchaCallback(response) {
            this.recaptchaResponse = response;
            /* istanbul ignore next */
            if (this.$listeners.advanceStage) {
                this.$emit('advanceStage', this.getData());
            }
        },
        getData: function getData() {
            return {
                response: this.recaptchaResponse,
                'g-recaptcha-response': this.recaptchaResponse
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a45f956e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/common/Captcha.vue
var Captcha_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4",attrs:{"id":"captchaBody"}},[(_vm.apiType)?_c('p',{staticClass:"text-center mb-4"},[_vm._v("\n        "+_vm._s(_vm.$t(("pages.selfservice.headers." + _vm.apiType + ".description")))+"\n    ")]):_vm._e(),_vm._v(" "),_vm._m(0)])}
var Captcha_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recaptcha-wrapper "},[_c('div',{staticClass:"recaptcha-bound"},[_c('div',{attrs:{"id":"recaptchaContainer"}})])])}]
var Captcha_esExports = { render: Captcha_render, staticRenderFns: Captcha_staticRenderFns }
/* harmony default export */ var common_Captcha = (Captcha_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/common/Captcha.vue
var Captcha_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Captcha___vue_template_functional__ = false
/* styles */
var Captcha___vue_styles__ = null
/* scopeId */
var Captcha___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Captcha___vue_module_identifier__ = null
var Captcha_Component = Captcha_normalizeComponent(
  Captcha,
  common_Captcha,
  Captcha___vue_template_functional__,
  Captcha___vue_styles__,
  Captcha___vue_scopeId__,
  Captcha___vue_module_identifier__
)

/* harmony default export */ var selfservice_common_Captcha = (Captcha_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/forgotusername/EmailUsername.vue
//
//
//
//
//
//

/**
 * @description Selfservice stage for username recovery, displays a message notifying a user they have been sent an email
 *
 **/
/* harmony default export */ var EmailUsername = ({
  name: 'Email-Username'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024b4aa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/forgotusername/EmailUsername.vue
var EmailUsername_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":"success","show":""}},[_vm._v("\n    "+_vm._s(_vm.$t('pages.selfservice.forgotUsername.emailSent'))+"\n")])}
var EmailUsername_staticRenderFns = []
var EmailUsername_esExports = { render: EmailUsername_render, staticRenderFns: EmailUsername_staticRenderFns }
/* harmony default export */ var forgotusername_EmailUsername = (EmailUsername_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/forgotusername/EmailUsername.vue
var EmailUsername_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var EmailUsername___vue_template_functional__ = false
/* styles */
var EmailUsername___vue_styles__ = null
/* scopeId */
var EmailUsername___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EmailUsername___vue_module_identifier__ = null
var EmailUsername_Component = EmailUsername_normalizeComponent(
  EmailUsername,
  forgotusername_EmailUsername,
  EmailUsername___vue_template_functional__,
  EmailUsername___vue_styles__,
  EmailUsername___vue_scopeId__,
  EmailUsername___vue_module_identifier__
)

/* harmony default export */ var selfservice_forgotusername_EmailUsername = (EmailUsername_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/forgotusername/RetrieveUsername.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Selfservice stage for username recovery, displays the found username
 *
 **/
/* harmony default export */ var RetrieveUsername = ({
    name: 'Retrieve-Username',
    props: {
        selfServiceDetails: { required: true }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749ae7b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/forgotusername/RetrieveUsername.vue
var RetrieveUsername_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof _vm.selfServiceDetails.error !== 'string')?_c('div',[_c('b-alert',{attrs:{"variant":"success","show":""}},[_vm._v("\n        "+_vm._s(_vm.$t('pages.selfservice.forgotUsername.yourUsername'))+" "),_c('b',[_vm._v(_vm._s(_vm.selfServiceDetails.additions.userName))])])],1):_c('div',[_c('b-alert',{attrs:{"variant":"danger","show":""}},[_c('b',[_vm._v(_vm._s(_vm.$t('pages.selfservice.forgotUsername.unableToRetrieve')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.selfServiceDetails.error))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('b-link',{attrs:{"href":"#/forgotUsername"},on:{"click":function($event){_vm.$router.go(_vm.$router.currentRoute)}}},[_vm._v("\n            "+_vm._s(_vm.$t("pages.selfservice.forgotUsername.tryAgain"))+"\n        ")])],1)],1)}
var RetrieveUsername_staticRenderFns = []
var RetrieveUsername_esExports = { render: RetrieveUsername_render, staticRenderFns: RetrieveUsername_staticRenderFns }
/* harmony default export */ var forgotusername_RetrieveUsername = (RetrieveUsername_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/forgotusername/RetrieveUsername.vue
var RetrieveUsername_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var RetrieveUsername___vue_template_functional__ = false
/* styles */
var RetrieveUsername___vue_styles__ = null
/* scopeId */
var RetrieveUsername___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RetrieveUsername___vue_module_identifier__ = null
var RetrieveUsername_Component = RetrieveUsername_normalizeComponent(
  RetrieveUsername,
  forgotusername_RetrieveUsername,
  RetrieveUsername___vue_template_functional__,
  RetrieveUsername___vue_styles__,
  RetrieveUsername___vue_scopeId__,
  RetrieveUsername___vue_module_identifier__
)

/* harmony default export */ var selfservice_forgotusername_RetrieveUsername = (RetrieveUsername_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/common/UserQuery.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Selfservice stage for multiple selfservice flows, typically used with an email to locate a user in the system to continue on with further
 * selfservice stages
 *
 **/
/* harmony default export */ var UserQuery = ({
    name: 'User-Query',
    components: {
        'fr-floating-label-input': components_utils_FloatingLabelInput
    },
    props: {
        apiType: { required: true }
    },
    data: function data() {
        return {
            mail: ''
        };
    },

    methods: {
        getData: function getData() {
            return {
                queryFilter: 'mail eq "' + this.mail + '"'
            };
        },
        save: function save() {
            /* istanbul ignore next */
            this.$emit('advanceStage', this.getData());
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c59c6968","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/common/UserQuery.vue
var UserQuery_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save($event)},"submit":function($event){$event.preventDefault();}}},[_c('p',{staticClass:"text-center mb-4"},[_vm._v("\n        "+_vm._s(_vm.$t('pages.selfservice.passwordReset.userQuery'))+"\n    ")]),_vm._v(" "),_c('b-form-group',[_c('fr-floating-label-input',{attrs:{"fieldName":"mail","label":_vm.$t('common.placeholders.emailAddress'),"type":"text","autofocus":"true"},model:{value:(_vm.mail),callback:function ($$v) {_vm.mail=$$v},expression:"mail"}})],1),_vm._v(" "),_c('b-button',{attrs:{"size":"lg","block":true,"variant":"primary"},on:{"click":_vm.save}},[(_vm.apiType === 'username')?_c('div',[_vm._v("\n            "+_vm._s(_vm.$t("pages.selfservice.forgotUsername.advanceStageButtonText"))+"\n        ")]):_c('div',[_vm._v("\n            "+_vm._s(_vm.$t("pages.selfservice.passwordReset.advanceStageButtonText"))+"\n        ")])])],1)}
var UserQuery_staticRenderFns = []
var UserQuery_esExports = { render: UserQuery_render, staticRenderFns: UserQuery_staticRenderFns }
/* harmony default export */ var common_UserQuery = (UserQuery_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/common/UserQuery.vue
var UserQuery_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var UserQuery___vue_template_functional__ = false
/* styles */
var UserQuery___vue_styles__ = null
/* scopeId */
var UserQuery___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserQuery___vue_module_identifier__ = null
var UserQuery_Component = UserQuery_normalizeComponent(
  UserQuery,
  common_UserQuery,
  UserQuery___vue_template_functional__,
  UserQuery___vue_styles__,
  UserQuery___vue_scopeId__,
  UserQuery___vue_module_identifier__
)

/* harmony default export */ var selfservice_common_UserQuery = (UserQuery_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/common/GenericSelfService.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Selfservice stage for multiple selfservice flows, attempts to auto generate a form for a user to fill out. Currently
 * generates only numbers, strings and boolean fields. This stage will only load when no other stage is found.
 *
 **/
/* harmony default export */ var GenericSelfService = ({
    name: 'Generic-Self-Service',
    props: {
        selfServiceDetails: { required: true }
    },
    data: function data() {
        var saveData = {},
            displayDetails = [];

        if (this.selfServiceDetails && this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.properties) {
            lodash_default.a.each(this.selfServiceDetails.requirements.properties, function (prop, key) {
                displayDetails.push({
                    type: prop.type,
                    text: prop.description,
                    key: key
                });

                if (prop.type === 'string') {
                    saveData[key] = '';
                } else if (prop.type === 'boolean') {
                    saveData[key] = false;
                } else {
                    saveData[key] = null;
                }
            });
        }

        return {
            saveFields: saveData,
            displayDetails: displayDetails
        };
    },

    methods: {
        getData: function getData() {
            return this.saveFields;
        },
        save: function save() {
            this.$emit('advanceStage', this.getData());
        },
        isValid: function isValid() {
            return promise_default.a.resolve(true);
        }
    },
    filters: {
        startCase: function startCase(value) {
            return lodash_default.a.startCase(value);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24242773","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/common/GenericSelfService.vue
var GenericSelfService_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.displayDetails),function(field,index){return [((field.type === 'string' || field.type === 'number'))?_c('b-form-group',{key:'genericField' +index,attrs:{"label":_vm._f("startCase")(field.key),"label-for":"field.key","horizontal":""}},[(field.type === 'string')?_c('b-form-input',{ref:index === 0 ? 'focusInput' : '',refInFor:true,attrs:{"name":field.key,"placeholder":field.text,"type":"text","autocomplete":field.key},model:{value:(_vm.saveFields[field.key]),callback:function ($$v) {_vm.$set(_vm.saveFields, field.key, (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"saveFields[field.key]"}}):_vm._e(),_vm._v(" "),(field.type === 'number')?_c('b-form-input',{ref:index === 0 ? 'focusInput' : '',refInFor:true,attrs:{"horizontal":"","name":field.key,"type":"number","autocomplete":field.key},model:{value:(_vm.saveFields[field.key]),callback:function ($$v) {_vm.$set(_vm.saveFields, field.key, _vm._n($$v))},expression:"saveFields[field.key]"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(field.type === 'boolean')?_c('b-form-group',{key:'genericField' +index},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-form-label col-sm-3",attrs:{"for":field.key}},[_vm._v(_vm._s(_vm._f("startCase")(field.key)))]),_vm._v(" "),_c('div',{staticClass:"mr-auto"},[_c('toggle-button',{staticClass:"mt-2 p-0 fr-toggle-primary",attrs:{"height":28,"width":56,"sync":true,"cssColors":true},model:{value:(_vm.saveFields[field.key]),callback:function ($$v) {_vm.$set(_vm.saveFields, field.key, $$v)},expression:"saveFields[field.key]"}})],1)])]):_vm._e()]}),_vm._v(" "),_c('b-button',{staticClass:"mt-4",attrs:{"block":true,"size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("\n        "+_vm._s(_vm.$t("common.form.submit"))+"\n    ")])],2)}
var GenericSelfService_staticRenderFns = []
var GenericSelfService_esExports = { render: GenericSelfService_render, staticRenderFns: GenericSelfService_staticRenderFns }
/* harmony default export */ var common_GenericSelfService = (GenericSelfService_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/common/GenericSelfService.vue
function GenericSelfService_injectStyle (ssrContext) {
  __webpack_require__("4WAc")
}
var GenericSelfService_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var GenericSelfService___vue_template_functional__ = false
/* styles */
var GenericSelfService___vue_styles__ = GenericSelfService_injectStyle
/* scopeId */
var GenericSelfService___vue_scopeId__ = "data-v-24242773"
/* moduleIdentifier (server only) */
var GenericSelfService___vue_module_identifier__ = null
var GenericSelfService_Component = GenericSelfService_normalizeComponent(
  GenericSelfService,
  common_GenericSelfService,
  GenericSelfService___vue_template_functional__,
  GenericSelfService___vue_styles__,
  GenericSelfService___vue_scopeId__,
  GenericSelfService___vue_module_identifier__
)

/* harmony default export */ var selfservice_common_GenericSelfService = (GenericSelfService_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/forgotusername/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/**
 * @description Selfservice controlling component for retrieving a forgotten username. Makes use of selfservice-username.json config file.
 *
 * @mixin - selfservice/mixins/SelfserviceAPIMixin.vue
 */
/* harmony default export */ var forgotusername = ({
    name: 'Forgot-Username',
    components: {
        Captcha: selfservice_common_Captcha,
        EmailUsername: selfservice_forgotusername_EmailUsername,
        RetrieveUsername: selfservice_forgotusername_RetrieveUsername,
        UserQuery: selfservice_common_UserQuery,
        GenericSelfService: selfservice_common_GenericSelfService,
        'bounce-loader': vue_spinner_min["BounceLoader"],
        'fr-center-card': components_utils_CenterCard
    },
    data: function data() {
        return {
            selfServiceType: null,
            selfServiceDetails: null,
            loadingColor: main_default.a.baseColor,
            apiType: 'username'
        };
    },
    mounted: function mounted() {
        /* istanbul ignore next */
        this.loadData();
    },

    methods: {
        setChildComponent: function setChildComponent(type, details) {
            this.selfServiceDetails = details;

            var stageCheck = false;

            lodash_default.a.each(this.$options.components, function (value, key) {
                if (lodash_default.a.toLower(key) === lodash_default.a.toLower(type)) {
                    stageCheck = true;
                }
            });

            if (stageCheck) {
                this.selfServiceType = type;
            } else {
                this.selfServiceType = 'GenericSelfService';
            }
        },
        apiErrorCallback: function apiErrorCallback(error) {
            /* istanbul ignore next */
            this.setChildComponent('retrieveUsername', { error: error.response.data.message });
        }
    },
    mixins: [mixins_SelfserviceAPIMixin]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c1fbc0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/forgotusername/index.vue
var forgotusername_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selfServiceType !== null)?_c('fr-center-card',{attrs:{"showLogo":true}},[_c('div',{attrs:{"slot":"center-card-header"},slot:"center-card-header"},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.$t("pages.selfservice.headers.username.title")))])]),_vm._v(" "),_c('b-card-body',{attrs:{"slot":"center-card-body"},slot:"center-card-body"},[_c(_vm.selfServiceType,{ref:"selfServiceStage",tag:"component",attrs:{"selfServiceDetails":_vm.selfServiceDetails,"apiType":_vm.apiType},on:{"advanceStage":_vm.advanceStage}})],1),_vm._v(" "),_c('b-card-footer',{attrs:{"slot":"center-card-footer"},slot:"center-card-footer"},[_c('b-link',{attrs:{"href":"#/login"}},[_vm._v(_vm._s(_vm.$t("pages.selfservice.signIn")))])],1)],1):_c('b-container',{staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"m-auto fr-center-card"},[_c('bounce-loader',{attrs:{"color":_vm.loadingColor}})],1)])])}
var forgotusername_staticRenderFns = []
var forgotusername_esExports = { render: forgotusername_render, staticRenderFns: forgotusername_staticRenderFns }
/* harmony default export */ var selfservice_forgotusername = (forgotusername_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/forgotusername/index.vue
var forgotusername_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var forgotusername___vue_template_functional__ = false
/* styles */
var forgotusername___vue_styles__ = null
/* scopeId */
var forgotusername___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var forgotusername___vue_module_identifier__ = null
var forgotusername_Component = forgotusername_normalizeComponent(
  forgotusername,
  selfservice_forgotusername,
  forgotusername___vue_template_functional__,
  forgotusername___vue_styles__,
  forgotusername___vue_scopeId__,
  forgotusername___vue_module_identifier__
)

/* harmony default export */ var components_selfservice_forgotusername = (forgotusername_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/access/CreateResource.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Dialog used for managing the create portion of delegated admin. Auto generates fields based on backend return.
 * Currently generates string, number, boolean and password (not based on type, but on field name being passsword).
 *
 * @param {array} createProperties - Required list of objects used to generate the fields for creating a user
 * @param {string} resourceName - Required resource name
 * @param {string} resourceType - Required type of resource, currently only supports managed
 *
 * @mixin - utils/mixins/ResourceMixin.vue
 *
 * @fires POST type/name?_action=create (e.g. managed/user?_action=create) - Creates a record for the specified managed resource
 */
/* harmony default export */ var CreateResource = ({
    name: 'Create-Resource',
    components: {
        'fr-validation-error': components_utils_ValidationError,
        'fr-password-policy-input': components_utils_PolicyPasswordInput
    },
    mixins: [mixins_ResourceMixin],
    props: {
        createProperties: {
            type: Array,
            required: true,
            default: function _default() {
                return [];
            }
        },
        resourceName: {
            type: String,
            required: true
        },
        resourceType: {
            type: String,
            required: true
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    data: function data() {
        var tempFormFields = {},
            tempPasswordCheck = false;

        lodash_default.a.each(this.createProperties, function (prop) {
            if (prop.type === 'string' || prop.type === 'number') {
                tempFormFields[prop.key] = '';
            } else {
                tempFormFields[prop.key] = false;
            }

            // Special logic for password
            if (prop.key === 'password') {
                tempPasswordCheck = true;
            }
        });

        return {
            formFields: tempFormFields,
            passwordCheck: tempPasswordCheck,
            passwordInputType: 'password',
            showPassword: true
        };
    },

    methods: {
        saveForm: function saveForm() {
            var _this = this;

            /* istanbul ignore next */
            var idmInstance = this.getRequestService();

            /* istanbul ignore next */
            this.$validator.validateAll().then(function (valid) {
                if (valid) {
                    var saveData = _this.cleanData(lodash_default.a.clone(_this.formFields));

                    idmInstance.post(_this.resourceType + '/' + _this.resourceName + '?_action=create', saveData).then(function () {
                        _this.$emit('refreshGrid');
                        _this.errors.clear();
                        _this.hideModal();

                        _this.displayNotification('success', _this.$t('pages.access.successCreate', { resource: lodash_default.a.capitalize(_this.resourceName) }));
                    }, function (error) {
                        var generatedErrors = _this.findPolicyError(error.response, _this.createProperties);

                        _this.errors.clear();

                        if (generatedErrors.length > 0) {
                            lodash_default.a.each(generatedErrors, function (generatedError) {
                                if (generatedError.exists) {
                                    _this.errors.add(generatedError);
                                }
                            });
                        } else {
                            _this.displayNotification('error', _this.$t('pages.access.invalidCreate'));
                        }
                    });
                } else {
                    _this.displayNotification('error', _this.$t('pages.access.invalidCreate'));
                }
            });
        },
        hideModal: function hideModal() {
            this.resetDialog();

            this.$refs.createModal.hide();
        },

        // Clean dialog after closing/saving
        resetDialog: function resetDialog() {
            var _this2 = this;

            this.errors.clear();

            this.passwordInputType = 'password';
            this.showPassword = true;

            lodash_default.a.each(this.formFields, function (value, key) {
                if (lodash_default.a.isString(value) || lodash_default.a.isNumber(value)) {
                    _this2.formFields[key] = '';
                } else {
                    _this2.formFields[key] = false;
                }
            });
        },

        // Hide/show for special password field
        revealNew: function revealNew() {
            if (this.passwordInputType === 'password') {
                this.passwordInputType = 'text';
                this.showPassword = false;
            } else {
                this.passwordInputType = 'password';
                this.showPassword = true;
            }
        },

        // Remove optional fields to not save with empty string
        cleanData: function cleanData(data) {
            lodash_default.a.each(data, function (value, key) {
                if (lodash_default.a.isString(value) && value.length === 0) {
                    delete data[key];
                }
            });

            return data;
        },
        focusField: function focusField() {
            /* istanbul ignore next */
            if (lodash_default.a.isArray(this.$refs.focusInput)) {
                this.$refs.focusInput[0].focus();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7dfb290","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/access/CreateResource.vue
var CreateResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"createModal",attrs:{"id":"createResourceModal","cancel-variant":"outline-secondary"},on:{"shown":_vm.focusField},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.saveForm($event)}}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h5',{staticClass:"modal-title align-self-center text-center"},[_vm._v(_vm._s(_vm.$t('common.form.new'))+" "+_vm._s(_vm.resourceName))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.hideModal}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.createProperties.length > 0)?_c('b-form',{staticClass:"mb-3",attrs:{"name":"edit-personal-form"}},[_vm._l((_vm.createProperties),function(field,index){return [((field.type === 'string' || field.type === 'number') && field.encryption === undefined)?_c('b-form-group',{key:'createResource' +index},[(field.title)?_c('label',{staticClass:"float-left",attrs:{"for":field.title}},[_vm._v(_vm._s(field.title))]):_c('label',{staticClass:"float-left",attrs:{"for":field.key}},[_vm._v(_vm._s(field.key))]),_vm._v(" "),(field.type === 'string')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(field.required ? 'required' : ''),expression:"field.required ? 'required' : ''"},{name:"model",rawName:"v-model.trim",value:(_vm.formFields[field.key]),expression:"formFields[field.key]",modifiers:{"trim":true}}],ref:index === 0 ? 'focusInput' : '',refInFor:true,class:[{'is-invalid': _vm.errors.has(field.key)}, 'form-control'],attrs:{"data-vv-validate-on":"submit","name":field.key,"type":"text","data-vv-as":field.title,"autocomplete":field.key},domProps:{"value":(_vm.formFields[field.key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formFields, field.key, $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(field.required ? 'required' : ''),expression:"field.required ? 'required' : ''"},{name:"model",rawName:"v-model.number",value:(_vm.formFields[field.key]),expression:"formFields[field.key]",modifiers:{"number":true}}],ref:index === 0 ? 'focusInput' : '',refInFor:true,class:[{'is-invalid': _vm.errors.has(field.key)}, 'form-control'],attrs:{"data-vv-validate-on":"submit","name":field.key,"type":"number","data-vv-as":field.title,"autocomplete":field.key},domProps:{"value":(_vm.formFields[field.key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formFields, field.key, _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('fr-validation-error',{attrs:{"validatorErrors":_vm.errors,"fieldName":field.key}})],1):_vm._e(),_vm._v(" "),(field.type === 'boolean')?_c('b-form-group',{key:'createResource' +index},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"mr-auto",attrs:{"for":field.title}},[_vm._v(_vm._s(field.title))]),_vm._v(" "),_c('div',{staticClass:"mr-auto"},[_c('toggle-button',{staticClass:"mt-2 p-0 fr-toggle-primary",attrs:{"height":28,"width":56,"sync":true,"cssColors":true,"labels":{checked: _vm.$t('common.form.yes'), unchecked: _vm.$t('common.form.no')}},model:{value:(_vm.formFields[field.key]),callback:function ($$v) {_vm.$set(_vm.formFields, field.key, $$v)},expression:"formFields[field.key]"}})],1)])]):_vm._e()]}),_vm._v(" "),(_vm.passwordCheck)?_c('fr-password-policy-input',{attrs:{"policyApi":(_vm.resourceType + "/" + _vm.resourceName + "/policyTest")},model:{value:(_vm.formFields['password']),callback:function ($$v) {_vm.$set(_vm.formFields, 'password', $$v)},expression:"formFields['password']"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"slot":"custom-input"},slot:"custom-input"},[_c('label',{attrs:{"for":"createPassword"}},[_vm._v(_vm._s(_vm.$t('pages.access.password')))]),_vm._v(" "),_c('div',{staticClass:"form-label-password form-label-group mb-0"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate.initial",value:('required|policy'),expression:"'required|policy'",modifiers:{"initial":true}}],attrs:{"id":"createPassword","autocomplete":"password","type":_vm.passwordInputType,"name":"password"},model:{value:(_vm.formFields['password']),callback:function ($$v) {_vm.$set(_vm.formFields, 'password', $$v)},expression:"formFields['password']"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.revealNew}},[_c('i',{class:[{'fa-eye-slash': !_vm.showPassword}, {'fa-eye': _vm.showPassword}, 'fa']})])])],1)])],1):_vm._e()],2):[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('pages.access.noFields')))])]],2)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":"primary","disabled":_vm.formFields.length === 0},on:{"click":_vm.saveForm}},[_vm._v(_vm._s(_vm.$t('common.form.save')))])],1)])],1)}
var CreateResource_staticRenderFns = []
var CreateResource_esExports = { render: CreateResource_render, staticRenderFns: CreateResource_staticRenderFns }
/* harmony default export */ var access_CreateResource = (CreateResource_esExports);
// CONCATENATED MODULE: ./src/components/access/CreateResource.vue
var CreateResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var CreateResource___vue_template_functional__ = false
/* styles */
var CreateResource___vue_styles__ = null
/* scopeId */
var CreateResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateResource___vue_module_identifier__ = null
var CreateResource_Component = CreateResource_normalizeComponent(
  CreateResource,
  access_CreateResource,
  CreateResource___vue_template_functional__,
  CreateResource___vue_styles__,
  CreateResource___vue_scopeId__,
  CreateResource___vue_module_identifier__
)

/* harmony default export */ var components_access_CreateResource = (CreateResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/access/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description Controlling component for delegated admin, allows for listing available resources and connects to the create, delete and edit features.
 *
 * @fires GET schema/type/name/ (e.g. schema/managed/user) - Schema for a resource (e.g. managed/user schema)
 * @fires GET privilege/type/name/ (e.g. privilege/managed/user/) - Privileges for a resource (e.g. managed/user)
 * @fires GET resource/name?_queryFilter=filter&_pageSize=10&_totalPagedResultsPolicy=EXACT (e.g. managed/user?_queryFilter=true&_pageSize=10&_totalPagedResultsPolicy=EXACT) -
 * List resource items, limited to 10 returned items and makes use of a query filter search if provided (defaults to queryFilter = true if none provided by the user).
 */
/* harmony default export */ var components_access = ({
    name: 'Access',
    components: {
        'fr-create-resource': components_access_CreateResource
    },
    data: function data() {
        return {
            name: this.$route.params.resourceName,
            resource: this.$route.params.resourceType,
            schemaProperties: {},
            isRowSelected: false,
            tableHover: true,
            gridData: [],
            columns: [],
            displayFields: [],
            currentPage: 1,
            lastPage: false,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: '',
            createProperties: [],
            userCanUpdate: false
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            var idmInstance = this.getRequestService();

            /* istanbul ignore next */
            axios_default.a.all([idmInstance.get('schema/' + this.resource + '/' + this.name), idmInstance.get('privilege/' + this.resource + '/' + this.name)]).then(axios_default.a.spread(function (schema, privilege) {
                if (privilege.data.VIEW.allowed) {
                    // Generate columns for display and filtering for read/query
                    lodash_default.a.each(privilege.data.VIEW.properties, function (readProp) {
                        if (_this.columns.length <= 3 && lodash_default.a.isUndefined(schema.data.properties[readProp].encryption)) {
                            _this.columns.push({
                                key: readProp,
                                label: schema.data.properties[readProp].title,
                                sortable: true,
                                sortDirection: 'desc'
                            });

                            _this.displayFields.push(readProp);
                        }
                    });
                }

                if (privilege.data.UPDATE) {
                    _this.userCanUpdate = true;
                }

                _this.schemaProperties = schema.data.properties;

                if (privilege.data.CREATE.allowed) {
                    // Generate create list for create resource dialog
                    lodash_default.a.each(privilege.data.CREATE.properties, function (createProp) {
                        if (schema.data.properties[createProp].type === 'string' || schema.data.properties[createProp].type === 'number' || schema.data.properties[createProp].type === 'boolean') {
                            schema.data.properties[createProp].key = createProp;

                            lodash_default.a.each(schema.data.required, function (requiredKey) {
                                if (requiredKey === schema.data.properties[createProp].key) {
                                    schema.data.properties[createProp].required = true;
                                }
                            });

                            _this.createProperties.push(schema.data.properties[createProp]);
                        }
                    });
                }

                _this.loadGrid('true', _this.displayFields, _this.displayFields[0], 1);
            })).catch(function (error) {
                _this.displayNotification('error', error.response.data.message);
            });
        },
        loadGrid: function loadGrid(filter, fields, sortField, page) {
            var _this2 = this;

            var idmInstance = this.getRequestService();

            /* istanbul ignore next */
            idmInstance.get(this.buildGridUrl(filter, fields, sortField, page)).then(function (resourceData) {
                // this.totalRows = resourceData.data.totalPagedResults;
                if (resourceData.data.pagedResultsCookie) {
                    _this2.lastPage = false;
                } else {
                    _this2.lastPage = true;
                }

                _this2.gridData = resourceData.data.result;
            });
        },
        buildGridUrl: function buildGridUrl(filter, fields, sortField, page) {
            var resourceUrl = this.resource + '/' + this.name + '?_queryFilter=' + filter + '&_pageSize=10&_totalPagedResultsPolicy=EXACT';

            if (lodash_default.a.isNull(sortField)) {
                // If there is no sortField default to sorting on the first column.
                sortField = fields[0];
            }

            resourceUrl = resourceUrl + '&_sortKeys=' + sortField;

            if (fields.length) {
                resourceUrl = resourceUrl + '&_fields=' + fields.join(',');
            }

            if (page > 1) {
                // Pagination starts at 1 and we need to go back an additional one to get the previous page
                var offsetCalc = (page - 1) * 10;

                resourceUrl = resourceUrl + '&_pagedResultsOffset=' + offsetCalc;
            }

            return resourceUrl;
        },
        calculateSort: function calculateSort(sortDesc, sortBy) {
            var sortUrl = null;

            if (!lodash_default.a.isNull(sortBy)) {
                if (sortDesc) {
                    sortUrl = '' + sortBy;
                } else {
                    sortUrl = '-' + sortBy;
                }
            }

            return sortUrl;
        },
        sortingChanged: function sortingChanged(sort) {
            this.currentPage = 1;
            this.lastPage = false;

            this.loadGrid(this.generateSearch(this.filter, this.displayFields, this.schemaProperties), this.displayFields, this.calculateSort(sort.sortDesc, sort.sortBy), 1);
        },
        paginationChange: function paginationChange(page) {
            /* istanbul ignore next */
            this.currentPage = page;
            this.loadGrid(this.generateSearch(this.filter, this.displayFields, this.schemaProperties), this.displayFields, this.calculateSort(this.sortDesc, this.sortBy), page);
        },
        search: function search() {
            this.sortBy = null;
            this.sortDesc = false;
            this.currentPage = 1;
            this.lastPage = false;

            this.loadGrid(this.generateSearch(this.filter, this.displayFields, this.schemaProperties), this.displayFields, null, 1);
        },
        generateSearch: function generateSearch(filter, displayFields, schemaProps) {
            var filterUrl = '';

            if (filter.length > 0) {
                lodash_default.a.each(displayFields, function (field, index) {
                    var type = 'string';

                    if (!lodash_default.a.isUndefined(schemaProps)) {
                        type = schemaProps[field].type;
                    }

                    // Search based on number and proper number value
                    if (type === 'number' && !lodash_default.a.isNaN(lodash_default.a.toNumber(filter))) {
                        if (index + 1 < displayFields.length) {
                            filterUrl = '' + filterUrl + field + '+eq+ ' + filter + '+OR+';
                        } else {
                            filterUrl = '' + filterUrl + field + '+eq+ ' + filter;
                        }
                        // Search based on boolean and proper boolean true/false
                    } else if (type === 'boolean' && (filter === 'true' || filter === 'false')) {
                        if (index + 1 < displayFields.length) {
                            filterUrl = '' + filterUrl + field + '+eq+ ' + filter + '+OR+';
                        } else {
                            filterUrl = '' + filterUrl + field + '+eq+ ' + filter;
                        }
                        // Fallback to general string search if all other criteria fails
                    } else {
                        if (index + 1 < displayFields.length) {
                            filterUrl = '' + filterUrl + field + '+sw+"' + filter + '"+OR+';
                        } else {
                            filterUrl = '' + filterUrl + field + '+sw+"' + filter + '"';
                        }
                    }
                });
            } else {
                filterUrl = 'true';
            }

            return filterUrl;
        },
        clear: function clear() {
            this.filter = '';
            this.sortBy = null;
            this.sortDesc = false;
            this.currentPage = 1;

            this.loadGrid('true', this.displayFields, null, 1);
        },
        resourceClicked: function resourceClicked(item) {
            if (this.userCanUpdate) {
                this.$router.push({
                    name: 'EditResource',
                    params: {
                        resourceType: this.resource,
                        resourceName: this.name,
                        resourceId: item._id
                    }
                });
            } else {
                this.displayNotification('error', this.$t('pages.access.unableToEditResource', { resource: this.name }));
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454e89d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/access/index.vue
var access_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header py-2"},[_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"md":"7"}},[(_vm.createProperties.length > 0)?_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.createResourceModal",modifiers:{"createResourceModal":true}}],attrs:{"type":"button","variant":"primary"}},[_c('i',{staticClass:"fa fa-plus mr-3"}),_vm._v(_vm._s(_vm.$t("common.form.new"))+" "+_vm._s(this.name))]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"md":"5"}},[_c('div',{staticClass:"d-flex"},[_c('b-input-group',[_c('b-input-group-prepend',[_c('div',{staticClass:"input-group-text inset"},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('b-form-input',{staticClass:"inset-left inset-right",attrs:{"placeholder":this.$t('pages.access.typeSearch')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{staticClass:"inset clear",attrs:{"variant":"outline-default","disabled":!_vm.filter},on:{"click":_vm.clear}},[_c('i',{staticClass:"fa fa-times-circle"})])],1)],1)],1)])],1)],1),_vm._v(" "),_c('b-table',{staticClass:"mb-0",attrs:{"show-empty":"","table-responsive":"","stacked":"lg","items":_vm.gridData,"fields":_vm.columns,"per-page":0,"hover":_vm.tableHover,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"no-local-sorting":true,"sort-direction":_vm.sortDirection},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"row-clicked":_vm.resourceClicked,"sort-changed":_vm.sortingChanged}}),_vm._v(" "),_c('div',{staticClass:"card-footer py-2"},[_c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('ul',{staticClass:"pagination justify-content-center mb-0"},[_c('li',{class:[{ disabled: _vm.currentPage === 1 }, 'page-item'],on:{"click":function($event){$event.preventDefault();_vm.currentPage === 1 ? '' : _vm.paginationChange(1)}}},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-angle-double-left"})])]),_vm._v(" "),_c('li',{class:[{ disabled: _vm.currentPage === 1 }, 'page-item'],on:{"click":function($event){$event.preventDefault();_vm.currentPage === 1 ? '' : _vm.paginationChange(_vm.currentPage - 1)}}},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-angle-left"})])]),_vm._v(" "),_c('li',{class:[{ disabled: _vm.lastPage }, 'page-item'],on:{"click":function($event){$event.preventDefault();_vm.lastPage ?  '' : _vm.paginationChange(_vm.currentPage + 1)}}},[_c('a',{staticClass:"page-link",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-angle-right"})])])])])])],1),_vm._v(" "),(_vm.createProperties.length > 0)?_c('fr-create-resource',{attrs:{"resourceName":_vm.name,"resourceType":_vm.resource,"createProperties":_vm.createProperties},on:{"refreshGrid":_vm.clear}}):_vm._e()],1)}
var access_staticRenderFns = []
var access_esExports = { render: access_render, staticRenderFns: access_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_access = (access_esExports);
// CONCATENATED MODULE: ./src/components/access/index.vue
function access_injectStyle (ssrContext) {
  __webpack_require__("3PBY")
}
var access_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var access___vue_template_functional__ = false
/* styles */
var access___vue_styles__ = access_injectStyle
/* scopeId */
var access___vue_scopeId__ = "data-v-454e89d4"
/* moduleIdentifier (server only) */
var access___vue_module_identifier__ = null
var access_Component = access_normalizeComponent(
  components_access,
  selectortype_template_index_0_src_components_access,
  access___vue_template_functional__,
  access___vue_styles__,
  access___vue_scopeId__,
  access___vue_module_identifier__
)

/* harmony default export */ var src_components_access = (access_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Controlling component to allow users to manually login, socially login or start of a selfservice process (username, password or registration) if configured.
 *
 * @fires POST authentication?_action=logout - Ends current user session
 * @fires POST authentication?_action=login - Uses username and password to establish a new user session
 * @fires GET type/name/id (e.g. managed/user/_id) - Resource details, in this context it is for the successfully logged in user
 * @fires POST privilege?_action=listPrivileges - Check to see if a user has any privilege based access
 * @fires GET schema/type/name/ (e.g. schema/managed/user) - Schema for a resource
 *
 */
/* harmony default export */ var Login = ({
    name: 'Login',
    components: {
        'fr-floating-label-input': components_utils_FloatingLabelInput,
        'fr-center-card': components_utils_CenterCard,
        'fr-social-buttons': components_utils_SocialButtons
    },
    data: function data() {
        return {
            username: '',
            password: '',
            wrongPasswordSubmitted: false
        };
    },
    mounted: function mounted() {
        // In case account claiming is cancelled midway through this will clear the storage token
        localStorage.removeItem('accountClaimingToken');
    },

    methods: {
        submit: function submit() {
            var _this = this;

            /* istanbul ignore next */
            var loginServiceInstance = this.getRequestService({
                headers: {
                    'X-OpenIDM-NoSession': false,
                    'X-OpenIDM-Password': this.password,
                    'X-OpenIDM-Username': this.username
                }
            }),
                idmInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });

            /* istanbul ignore next */
            idmInstance.post('/authentication?_action=logout').then(function () {
                loginServiceInstance.post('/authentication?_action=login').then(function (userDetails) {
                    _this.$root.userStore.clearStoreAction();

                    _this.$root.userStore.setUserIdAction(userDetails.data.authorization.id);
                    _this.$root.userStore.setManagedResourceAction(userDetails.data.authorization.component);
                    _this.$root.userStore.setRolesAction(userDetails.data.authorization.roles);
                    // Check for progressive profiling.
                    _this.progressiveProfileCheck(userDetails, function () {
                        axios_default.a.all([loginServiceInstance.get(userDetails.data.authorization.component + '/' + userDetails.data.authorization.id), loginServiceInstance.post('privilege?_action=listPrivileges'), loginServiceInstance.get('schema/' + userDetails.data.authorization.component)]).then(axios_default.a.spread(function (profile, privilege, schema) {
                            _this.$root.userStore.setProfileAction(profile.data);
                            _this.$root.userStore.setSchemaAction(schema.data);
                            _this.$root.userStore.setAccess(privilege.data);

                            window.history.pushState('', '', window.location.pathname);

                            _this.completeLogin();
                        })).catch(function (error) {
                            /* istanbul ignore next */
                            _this.displayNotification('error', error.response.data.message);
                        });
                    });
                }).catch(function () {
                    _this.wrongPasswordSubmitted = true;
                });
            });

            return false;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674b5ea8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-center-card',{attrs:{"showLogo":true}},[_c('div',{attrs:{"slot":"center-card-header"},slot:"center-card-header"},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.$t('pages.login.signIn')))])]),_vm._v(" "),_c('b-card-body',{attrs:{"slot":"center-card-body"},slot:"center-card-body"},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.wrongPasswordSubmitted)?_c('div',{staticClass:"alert alert-danger mb-4 text-left",attrs:{"role":"alert"}},[_vm._v("\n                "+_vm._s(_vm.$t('pages.login.badPassword'))+"\n                "),(this.$root.applicationStore.state.passwordReset)?_c('span',[_vm._v(_vm._s(_vm.$t('pages.login.weCanHelp'))+" "),(this.$root.applicationStore.state.passwordReset)?_c('router-link',{attrs:{"to":"passwordreset"}},[_vm._v(_vm._s(_vm.$t('pages.login.recoverPassword')))]):_vm._e()],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('fr-social-buttons',{attrs:{"signin":true}}),_vm._v(" "),_c('b-form',{staticClass:"form-signin mb-3",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('fr-floating-label-input',{attrs:{"fieldName":"username","label":_vm.$t('pages.login.username'),"type":"text","autofocus":"true"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('fr-floating-label-input',{attrs:{"fieldName":"password","label":_vm.$t('pages.login.password'),"reveal":true,"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('b-button',{staticClass:"btn btn-block btn-lg",attrs:{"type":"submit","variant":"primary"}},[_vm._v("\n                "+_vm._s(_vm.$t('pages.login.signIn'))+"\n            ")])],1),_vm._v(" "),_c('p',{staticClass:"text-center"},[(this.$root.applicationStore.state.usernameRecovery)?_c('router-link',{attrs:{"action":"","to":"forgotusername"}},[_vm._v(_vm._s(_vm.$t('pages.login.forgotUsername')))]):_vm._e(),_vm._v(" "),(this.$root.applicationStore.state.usernameRecovery && this.$root.applicationStore.state.passwordReset)?_c('span',[_vm._v("·")]):_vm._e(),_vm._v(" "),(this.$root.applicationStore.state.passwordReset)?_c('router-link',{attrs:{"to":"passwordreset"}},[_vm._v(_vm._s(_vm.$t('pages.login.forgotPassword')))]):_vm._e()],1)],1),_vm._v(" "),(this.$root.applicationStore.state.registration)?[_c('b-card-footer',{staticClass:"fr-footer-bottom",attrs:{"slot":"center-card-footer"},slot:"center-card-footer"},[_vm._v("\n            "+_vm._s(_vm.$t('pages.login.newHere'))+"\n            "),_c('router-link',{attrs:{"action":"","to":{name: 'Registration'}}},[_vm._v(_vm._s(_vm.$t('pages.login.createAccount')))])],1)]:_vm._e()],2)}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var components_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = null
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  components_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (Login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NotFound.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description The default 404 page when Vue router is unable to locate a route.
 */
/* harmony default export */ var NotFound = ({
  name: 'NotFound'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e3a6708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"h-100 d-flex",attrs:{"id":"notFoundContainer","fluid":""}},[_c('div',{staticClass:"m-auto align-self-center text-center",staticStyle:{"width":"350px"}},[_c('b-img',{staticClass:"fr-ghost mb-2",attrs:{"src":"static/images/ghost.svg","width":"112","height":"112","alt":"img"}}),_vm._v(" "),_c('div',{staticClass:"fr-code"},[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"text-centered"},[_vm._v(_vm._s(_vm.$t("pages.notFound.couldNotFind")))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('b-button',{staticClass:"mt-2 mb-2",staticStyle:{"width":"250px"},attrs:{"variant":"primary"}},[_vm._v("\n                "+_vm._s(_vm.$t("pages.notFound.returnToDashboard"))+"\n            ")])],1),_vm._v(" "),_c('b-img',{staticClass:"fr-shadow",attrs:{"src":"static/images/ghost-shadow.svg","width":"112","height":"112","alt":"img"}})],1)])}
var NotFound_staticRenderFns = []
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var components_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/components/NotFound.vue
function NotFound_injectStyle (ssrContext) {
  __webpack_require__("z1vY")
}
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = NotFound_injectStyle
/* scopeId */
var NotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  components_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var src_components_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/OAuthReturn.vue
//
//
//
//
//
//
//
//
//
//





/**
 * @description Return page used for oauth provider authentication. Will appropriately redirect a user to login or account claiming.
 *
 * @fires POST identityProviders?_action=handlePostAuth - Generates the token used for continuing the authentication process based off of the returned provider information
 * @fires POST authentication?_action=login - Uses data store token to establish a new user session
 */
/* harmony default export */ var OAuthReturn = ({
    name: 'OAuth-Return',
    components: {
        'bounce-loader': vue_spinner_min["BounceLoader"]
    },
    data: function data() {
        return {
            loadingColor: main_default.a.baseColor
        };
    },
    created: function created() {
        var _this = this;

        var queryParams = void 0;

        /*
            This check is for openAM fullstack only. With the return of a special URL #/handleOAuth/
            We are given a clientToken that we can directly pass on to accountClaiming / Registration
        */
        if (this.$route.params.amData) {
            queryParams = {};

            lodash_default.a.each(this.$route.params.amData.replace('?', '').split('&'), function (param) {
                if (param.length > 0) {
                    var parts = param.split('=');
                    queryParams[parts[0]] = parts[1];
                }
            });

            window.history.pushState('', '', window.location.pathname);

            this.$router.push({
                name: 'AccountClaiming',
                params: {
                    clientToken: queryParams.clientToken,
                    returnParams: queryParams.returnParams
                }
            });
        } else {
            queryParams = window.location.search.replace('?', '').split('&').reduce(function (map, item) {
                var parts = item.split('='),
                    decodedValue = [decodeURIComponent(parts[1])];

                map[parts[0]] = map[parts[0]] ? map[parts[0]].concat(decodedValue) : decodedValue;
                return map;
            }, {});

            window.history.pushState('', '', window.location.pathname);

            this.$root.applicationStore.clearAuthHeadersAction();

            /* istanbul ignore next */
            var socialInstance = this.getRequestService({
                headers: lodash_default.a.extend(this.getAnonymousHeaders(), {
                    'X-OpenIDM-NoSession': 'true',
                    'X-OpenIDM-DataStoreToken': localStorage.getItem('dataStoreToken')
                })
            }),
                linkedProvider = localStorage.getItem('linkedProvider');

            /* istanbul ignore next */
            localStorage.removeItem('dataStoreToken');
            localStorage.removeItem('linkedProvider');

            /* istanbul ignore next */
            socialInstance.post('/identityProviders?_action=handlePostAuth', queryParams).then(function (response) {
                var dataStoreToken = response.data.token,
                    originalToken = localStorage.getItem('accountClaimingToken');

                localStorage.removeItem('accountClaimingToken');

                var socialLoginInstance = _this.getRequestService({
                    headers: {
                        'X-OpenIDM-NoSession': 'false',
                        'X-OpenIDM-OAuth-Login': 'true',
                        'X-OpenIDM-DataStoreToken': dataStoreToken,
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });
                socialLoginInstance.post('/authentication?_action=login').then(function (response) {
                    /* If setAuthHeaders is true we know this if fullStack mode.
                       We need to set the headers to be used on all this user's authenticated requests.
                       Basically re-logging in on every request with a valid am token. We also need to
                       grab the logoutUrl so we can use that to kill not only the idm session
                       but also the am session. */
                    if (sessionStorage.getItem('setAuthHeaders')) {
                        _this.$root.applicationStore.setAuthHeadersAction({
                            'X-OpenIDM-OAuth-Login': 'true',
                            'X-OpenIDM-DataStoreToken': dataStoreToken,
                            'X-Requested-With': 'XMLHttpRequest'
                        });

                        sessionStorage.setItem('amToken', dataStoreToken);
                        sessionStorage.setItem('resubmitDataStoreToken', 'true');
                        sessionStorage.removeItem('setAuthHeaders');
                    }

                    // Check for progressive profiling.
                    _this.progressiveProfileCheck(response, function () {
                        if (linkedProvider) {
                            _this.$router.push({
                                name: 'Profile',
                                params: {
                                    clientToken: dataStoreToken,
                                    linkedProvider: linkedProvider
                                }
                            });
                        } else if (lodash_default.a.isNull(originalToken)) {
                            _this.$router.push('/');
                        } else {
                            _this.$router.push({
                                name: 'AccountClaiming',
                                params: {
                                    clientToken: dataStoreToken,
                                    originalToken: originalToken
                                }
                            });
                        }
                    });
                }).catch(function () {
                    _this.$router.push({
                        name: 'AccountClaiming',
                        params: {
                            clientToken: dataStoreToken,
                            originalToken: originalToken
                        }
                    });
                });
            }).catch(function (error) {
                _this.$router.push('/login');
                _this.displayNotification('error', error.response.data.message);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ada2866c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OAuthReturn.vue
var OAuthReturn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"m-auto fr-center-card"},[_c('bounce-loader',{attrs:{"color":_vm.loadingColor}})],1)])])}
var OAuthReturn_staticRenderFns = []
var OAuthReturn_esExports = { render: OAuthReturn_render, staticRenderFns: OAuthReturn_staticRenderFns }
/* harmony default export */ var components_OAuthReturn = (OAuthReturn_esExports);
// CONCATENATED MODULE: ./src/components/OAuthReturn.vue
var OAuthReturn_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var OAuthReturn___vue_template_functional__ = false
/* styles */
var OAuthReturn___vue_styles__ = null
/* scopeId */
var OAuthReturn___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var OAuthReturn___vue_module_identifier__ = null
var OAuthReturn_Component = OAuthReturn_normalizeComponent(
  OAuthReturn,
  components_OAuthReturn,
  OAuthReturn___vue_template_functional__,
  OAuthReturn___vue_styles__,
  OAuthReturn___vue_scopeId__,
  OAuthReturn___vue_module_identifier__
)

/* harmony default export */ var src_components_OAuthReturn = (OAuthReturn_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/common/EmailValidation.vue
//
//
//
//
//
//

/**
 * @description Selfservice stage for multiple selfservice flows, displays a email sent message
 *
 **/
/* harmony default export */ var EmailValidation = ({
    name: 'Email-Validation',
    props: {
        apiType: { required: true }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49dc5384","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/common/EmailValidation.vue
var EmailValidation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":""}},[_vm._v("\n    "+_vm._s(_vm.$t(("pages.selfservice.headers." + _vm.apiType + ".emailSent")))+"\n")])}
var EmailValidation_staticRenderFns = []
var EmailValidation_esExports = { render: EmailValidation_render, staticRenderFns: EmailValidation_staticRenderFns }
/* harmony default export */ var common_EmailValidation = (EmailValidation_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/common/EmailValidation.vue
var EmailValidation_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var EmailValidation___vue_template_functional__ = false
/* styles */
var EmailValidation___vue_styles__ = null
/* scopeId */
var EmailValidation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EmailValidation___vue_module_identifier__ = null
var EmailValidation_Component = EmailValidation_normalizeComponent(
  EmailValidation,
  common_EmailValidation,
  EmailValidation___vue_template_functional__,
  EmailValidation___vue_styles__,
  EmailValidation___vue_scopeId__,
  EmailValidation___vue_module_identifier__
)

/* harmony default export */ var selfservice_common_EmailValidation = (EmailValidation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/passwordreset/ResetStage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Selfservice stage for password reset, handles the final result of password reset, either displaying an error or that the reset has been complete
 *
 **/
/* harmony default export */ var ResetStage = ({
    name: 'Reset-Stage',
    components: {
        'fr-policy-password-input': components_utils_PolicyPasswordInput
    },
    props: {
        selfServiceDetails: { required: true }
    },
    data: function data() {
        return {
            password: ''
        };
    },

    methods: {
        getData: function getData() {
            return {
                password: this.password
            };
        },
        save: function save() {
            this.$emit('advanceStage', this.getData());
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d65ff886","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/passwordreset/ResetStage.vue
var ResetStage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selfServiceDetails.tag ==='end')?_c('div',[_c('b-alert',{attrs:{"show":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('pages.selfservice.passwordReset.successMessage')))])])],1):(typeof _vm.selfServiceDetails.error !== 'string')?_c('div',[_c('b-form',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save($event)},"submit":function($event){$event.preventDefault();}}},[_c('fr-policy-password-input',{attrs:{"policyApi":"selfservice/reset","name":"password","label":_vm.$t('pages.selfservice.passwordReset.newPassword')},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('b-button',{attrs:{"block":true,"size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("\n            "+_vm._s(_vm.$t("pages.selfservice.passwordReset.changePassword"))+"\n        ")])],1)],1):_c('div',[_c('b-alert',{attrs:{"variant":"danger","show":""}},[_c('b',[_vm._v(_vm._s(_vm.$t('pages.selfservice.passwordReset.errorMessage')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.selfServiceDetails.error))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('b-link',{attrs:{"href":"#/passwordReset"},on:{"click":function($event){_vm.$router.go(_vm.$router.currentRoute)}}},[_vm._v("\n            "+_vm._s(_vm.$t("pages.selfservice.passwordReset.tryAgain"))+"\n        ")])],1)],1)}
var ResetStage_staticRenderFns = []
var ResetStage_esExports = { render: ResetStage_render, staticRenderFns: ResetStage_staticRenderFns }
/* harmony default export */ var passwordreset_ResetStage = (ResetStage_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/passwordreset/ResetStage.vue
var ResetStage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ResetStage___vue_template_functional__ = false
/* styles */
var ResetStage___vue_styles__ = null
/* scopeId */
var ResetStage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ResetStage___vue_module_identifier__ = null
var ResetStage_Component = ResetStage_normalizeComponent(
  ResetStage,
  passwordreset_ResetStage,
  ResetStage___vue_template_functional__,
  ResetStage___vue_styles__,
  ResetStage___vue_scopeId__,
  ResetStage___vue_module_identifier__
)

/* harmony default export */ var selfservice_passwordreset_ResetStage = (ResetStage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/passwordreset/KbaVerification.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @description Selfservice stage for password reset, handles securing a users password change with verifying KBA answers
 *
 **/
/* harmony default export */ var KbaVerification = ({
    name: 'Kba-Verification',
    inject: ['$validator'],
    components: {
        'fr-validation-error': components_utils_ValidationError
    },
    props: {
        selfServiceDetails: { required: true }
    },
    data: function data() {
        var _$i18n = this.$i18n,
            locale = _$i18n.locale,
            fallbackLocale = _$i18n.fallbackLocale,
            _selfServiceDetails$r = this.selfServiceDetails.requirements,
            properties = _selfServiceDetails$r.properties,
            required = _selfServiceDetails$r.required;


        return {
            questionText: lodash_default.a.mapValues(properties, function (value) {
                if (lodash_default.a.has(value, 'systemQuestion')) {
                    var question = value.systemQuestion[locale] || value.systemQuestion[fallbackLocale];
                    return question;
                }

                if (lodash_default.a.has(value, 'userQuestion')) {
                    return value.userQuestion;
                }
            }),
            answers: required.reduce(function (acc, answer) {
                return lodash_default.a.set(acc, answer, '');
            }, {})
        };
    },
    mounted: function mounted() {
        // This will auto focus as long as one answer field is generated
        if (this.$refs && this.$refs['answer1']) {
            this.$refs['answer1'][0].focus();
        }
    },

    methods: {
        emitData: function emitData() {
            this.$emit('advanceStage', this.getData());
        },
        getData: function getData() {
            return this.answers;
        },
        isValid: function isValid() {
            /* istanbul ignore next */
            return this.$validator.validateAll();
        },
        save: function save() {
            var _this = this;

            /* istanbul ignore next */
            this.isValid().then(function (valid) {
                if (valid) {
                    _this.emitData();
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b9c147","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/passwordreset/KbaVerification.vue
var KbaVerification_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save($event)},"submit":function($event){$event.preventDefault();}}},[_c('p',{staticClass:"text-center mb-4"},[_vm._v("\n        "+_vm._s(_vm.$t("pages.selfservice.passwordReset.kbaVerificationStageDescription"))+"\n    ")]),_vm._v(" "),_vm._l((_vm.answers),function(value,key){return _c('div',{key:key,staticClass:"form-group text-left"},[_c('label',{staticClass:"col-form-label pt-0 pb-2",attrs:{"for":key}},[_vm._v(_vm._s(_vm.questionText[key]))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model.trim",value:(_vm.answers[key]),expression:"answers[key]",modifiers:{"trim":true}}],key:key,ref:key,refInFor:true,class:{'form-control': true, 'is-invalid': _vm.errors.has(key)},attrs:{"data-vv-as":_vm.$t('common.user.kba.answer'),"autofocus":"true","name":key,"id":key},domProps:{"value":(_vm.answers[key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.answers, key, $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('fr-validation-error',{attrs:{"validatorErrors":_vm.errors,"fieldName":key}})],1)}),_vm._v(" "),_c('b-button',{attrs:{"block":true,"size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("\n        "+_vm._s(_vm.$tc('common.user.kba.submitAnswers', _vm.selfServiceDetails.requirements.required.length))+"\n    ")])],2)}
var KbaVerification_staticRenderFns = []
var KbaVerification_esExports = { render: KbaVerification_render, staticRenderFns: KbaVerification_staticRenderFns }
/* harmony default export */ var passwordreset_KbaVerification = (KbaVerification_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/passwordreset/KbaVerification.vue
var KbaVerification_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var KbaVerification___vue_template_functional__ = false
/* styles */
var KbaVerification___vue_styles__ = null
/* scopeId */
var KbaVerification___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var KbaVerification___vue_module_identifier__ = null
var KbaVerification_Component = KbaVerification_normalizeComponent(
  KbaVerification,
  passwordreset_KbaVerification,
  KbaVerification___vue_template_functional__,
  KbaVerification___vue_styles__,
  KbaVerification___vue_scopeId__,
  KbaVerification___vue_module_identifier__
)

/* harmony default export */ var selfservice_passwordreset_KbaVerification = (KbaVerification_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/passwordreset/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/**
 * @description Selfservice controlling component for recovering a lost password. Makes use of selfservice-reset.json config file.
 *
 * @mixin - selfservice/mixins/SelfserviceAPIMixin.vue
 */
/* harmony default export */ var passwordreset = ({
    name: 'Password-Reset',
    components: {
        Captcha: selfservice_common_Captcha,
        EmailValidation: selfservice_common_EmailValidation,
        UserQuery: selfservice_common_UserQuery,
        ResetStage: selfservice_passwordreset_ResetStage,
        kbaSecurityAnswerVerificationStage: selfservice_passwordreset_KbaVerification,
        GenericSelfService: selfservice_common_GenericSelfService,
        'bounce-loader': vue_spinner_min["BounceLoader"],
        'fr-center-card': components_utils_CenterCard
    },
    data: function data() {
        return {
            selfServiceType: null,
            selfServiceDetails: null,
            loadingColor: main_default.a.baseColor,
            apiType: 'reset'
        };
    },
    mounted: function mounted() {
        /* istanbul ignore next */
        if (this.$route.params.queryParams) {
            var queryParams = this.parseQueryParams(this.$route.params.queryParams);

            this.advanceStage(queryParams);
        } else {
            this.loadData();
        }
    },

    methods: {
        setChildComponent: function setChildComponent(type, details) {
            this.selfServiceDetails = details;

            if (type === 'parameters') {
                this.selfServiceType = null;
                this.advanceStage({});
            } else {
                var stageCheck = false;

                lodash_default.a.each(this.$options.components, function (value, key) {
                    if (lodash_default.a.toLower(key) === lodash_default.a.toLower(type)) {
                        stageCheck = true;
                    }
                });

                if (stageCheck) {
                    this.selfServiceType = type;
                } else {
                    this.selfServiceType = 'GenericSelfService';
                }
            }
        },
        apiErrorCallback: function apiErrorCallback(error) {
            this.setChildComponent('resetStage', { error: error.response.data.message });
        }
    },
    mixins: [mixins_SelfserviceAPIMixin]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0272d1d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/passwordreset/index.vue
var passwordreset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selfServiceType !== null && _vm.selfServiceType !== 'parameters')?_c('fr-center-card',{attrs:{"showLogo":true}},[_c('div',{attrs:{"slot":"center-card-header"},slot:"center-card-header"},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.$t("pages.selfservice.headers.reset.title")))])]),_vm._v(" "),_c('b-card-body',{attrs:{"slot":"center-card-body"},slot:"center-card-body"},[_c(_vm.selfServiceType,{ref:"selfServiceStage",tag:"component",attrs:{"selfServiceDetails":_vm.selfServiceDetails,"apiType":_vm.apiType},on:{"advanceStage":_vm.advanceStage}})],1),_vm._v(" "),_c('b-card-footer',{attrs:{"slot":"center-card-footer"},slot:"center-card-footer"},[_c('b-link',{attrs:{"href":"#/login"}},[_vm._v(_vm._s(_vm.$t("pages.selfservice.signIn")))])],1)],1):_c('b-container',{staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"m-auto fr-center-card"},[_c('bounce-loader',{attrs:{"color":_vm.loadingColor}})],1)])])}
var passwordreset_staticRenderFns = []
var passwordreset_esExports = { render: passwordreset_render, staticRenderFns: passwordreset_staticRenderFns }
/* harmony default export */ var selfservice_passwordreset = (passwordreset_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/passwordreset/index.vue
var passwordreset_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var passwordreset___vue_template_functional__ = false
/* styles */
var passwordreset___vue_styles__ = null
/* scopeId */
var passwordreset___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var passwordreset___vue_module_identifier__ = null
var passwordreset_Component = passwordreset_normalizeComponent(
  passwordreset,
  selfservice_passwordreset,
  passwordreset___vue_template_functional__,
  passwordreset___vue_styles__,
  passwordreset___vue_scopeId__,
  passwordreset___vue_module_identifier__
)

/* harmony default export */ var components_selfservice_passwordreset = (passwordreset_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/AccountControls.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description Handles displaying basic account controls (delete and download).
 *
 * @fires DELETE resource/name/id (e.g. managed/user/fakeid) - Deletes specific resource record
 * @fires GET resource/name/id?_fields=*,idps/*,_meta/createDate,_meta/lastChanged,_meta/termsAccepted,_meta/loginCount (e.g. managed/user/fakeid) - Gets JSON data on a resource including certain meta data,
 * this is used to generate a downloadable file.
 *
 */
/* harmony default export */ var AccountControls = ({
    name: 'Account-Controls',
    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem
    },
    data: function data() {
        return {
            confirmDelete: false
        };
    },
    mounted: function mounted() {},
    methods: {
        deleteAccount: function deleteAccount() {
            var _this = this;

            /* istanbul ignore next */
            var selfServiceInstance = this.getRequestService();

            /* istanbul ignore next */
            selfServiceInstance.delete('/' + this.$root.userStore.state.managedResource + '/' + this.$root.userStore.state.userId).then(function () {
                _this.$refs.deleteModal.hide();
                _this.displayNotification('success', _this.$t('pages.profile.accountControls.deleteAccountSuccessful'));
                _this.logoutUser();
            });
        },
        downloadAccount: function downloadAccount() {
            var selfServiceInstance = this.getRequestService();

            /* istanbul ignore next */
            selfServiceInstance.get('/' + this.$root.userStore.state.managedResource + '/' + this.$root.userStore.state.userId + '?_fields=*,idps/*,_meta/createDate,_meta/lastChanged,_meta/termsAccepted,_meta/loginCount', []).then(function (result) {
                var data = void 0,
                    downloadName = '';

                if (result.data._meta) {
                    lodash_default.a.each(result._meta, function (value, key) {
                        if (key.match('_')) {
                            delete result._meta[key];
                        }
                    });
                }

                if (result.data.idps) {
                    lodash_default.a.each(result.idps, function (idp) {
                        lodash_default.a.each(idp, function (value, key) {
                            if (key.match('_') && lodash_default.a.isNull(key.match('_meta'))) {
                                delete idp[key];
                            }
                        });
                    });
                }

                delete result.data._rev;
                delete result.data.kbaInfo;

                data = stringify_default()(result.data, null, 4);

                if (navigator.msSaveBlob) {
                    return navigator.msSaveBlob(new Blob([data], { type: 'data:application/json' }), downloadName);
                } else {
                    var blob = new Blob([data], { type: 'data:application/json' }),
                        e = document.createEvent('MouseEvents'),
                        a = document.createElement('a');

                    a.download = 'userProfile.json';
                    a.href = window.URL.createObjectURL(blob);
                    a.dataset.downloadurl = ['data:application/json', a.download, a.href].join(':');
                    e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    a.dispatchEvent(e);
                }
            });
        },
        hideModal: function hideModal() {
            this.$refs.deleteModal.hide();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a9983c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/AccountControls.vue
var AccountControls_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fr-list-group',{attrs:{"title":_vm.$t('pages.profile.accountControls.title'),"subtitle":_vm.$t('pages.profile.accountControls.subtitle')}},[_c('fr-list-item',{attrs:{"collapsible":false,"panelShown":false,"hoverItem":true},on:{"row-click":_vm.downloadAccount}},[_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"flex-grow-1"},[_c('div',[_vm._v("\n                        "+_vm._s(_vm.$t('pages.profile.accountControls.downloadTitle'))+"\n                    ")]),_vm._v(" "),_c('small',{staticClass:"text-muted subtext"},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.downloadSubtitle')))])]),_vm._v(" "),_c('a',{staticClass:"align-self-center flex-grow-2 text-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.downloadLink')))])])]),_vm._v(" "),_c('fr-list-item',{directives:[{name:"b-modal",rawName:"v-b-modal.deleteAccountModal",modifiers:{"deleteAccountModal":true}}],attrs:{"collapsible":false,"panelShown":false,"hoverItem":true}},[_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"flex-grow-1"},[_c('div',[_vm._v("\n                        "+_vm._s(_vm.$t('pages.profile.accountControls.deleteTitle'))+"\n                    ")]),_vm._v(" "),_c('small',{staticClass:"text-muted subtext"},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteSubtitle')))])]),_vm._v(" "),_c('a',{staticClass:"align-self-center flex-grow-2 text-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteAccount')))])])])],1),_vm._v(" "),_c('b-modal',{ref:"deleteModal",staticClass:"fr-full-screen",attrs:{"id":"deleteAccountModal","cancel-variant":"outline-secondary"}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h5',{staticClass:"modal-title align-self-center text-center"},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteModalTitle')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.hideModal}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('b-container',[_c('h1',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteModalHeader')))]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.$t('pages.profile.accountControls.deleteModalDetails'))+"\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.$t('pages.profile.accountControls.deleteModalDownload1'))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.downloadAccount($event)}}},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteModalDownload2')))]),_vm._v(" "+_vm._s(_vm.$t('pages.profile.accountControls.deleteModalDownload3'))+"\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteModalContentList')))]),_vm._v(" "),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteModalContentListItem')))])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmDelete),expression:"confirmDelete"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"confirmDeleteCheck"},domProps:{"checked":Array.isArray(_vm.confirmDelete)?_vm._i(_vm.confirmDelete,null)>-1:(_vm.confirmDelete)},on:{"change":function($event){var $$a=_vm.confirmDelete,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.confirmDelete=$$a.concat([$$v]))}else{$$i>-1&&(_vm.confirmDelete=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.confirmDelete=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"confirmDeleteCheck"}},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteModalAcceptMessage')))])])]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('b-btn',{attrs:{"disabled":!_vm.confirmDelete,"type":"button","variant":"danger"},on:{"click":_vm.deleteAccount}},[_vm._v(_vm._s(_vm.$t('pages.profile.accountControls.deleteModalButton')))])],1)])],1)],1)}
var AccountControls_staticRenderFns = []
var AccountControls_esExports = { render: AccountControls_render, staticRenderFns: AccountControls_staticRenderFns }
/* harmony default export */ var profile_AccountControls = (AccountControls_esExports);
// CONCATENATED MODULE: ./src/components/profile/AccountControls.vue
function AccountControls_injectStyle (ssrContext) {
  __webpack_require__("OstF")
}
var AccountControls_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var AccountControls___vue_template_functional__ = false
/* styles */
var AccountControls___vue_styles__ = AccountControls_injectStyle
/* scopeId */
var AccountControls___vue_scopeId__ = "data-v-7a9983c0"
/* moduleIdentifier (server only) */
var AccountControls___vue_module_identifier__ = null
var AccountControls_Component = AccountControls_normalizeComponent(
  AccountControls,
  profile_AccountControls,
  AccountControls___vue_template_functional__,
  AccountControls___vue_styles__,
  AccountControls___vue_scopeId__,
  AccountControls___vue_module_identifier__
)

/* harmony default export */ var components_profile_AccountControls = (AccountControls_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/LoadingButton.vue
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Button with built in loading spinner that can be used to show users something is loading
 *
 **/
/* harmony default export */ var LoadingButton = ({
    name: 'LoadingButton',
    components: { ClipLoader: vue_spinner_min["ClipLoader"] },
    props: {
        label: String,
        loading: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17270933","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/LoadingButton.vue
var LoadingButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn btn-primary d-flex align-items-center', {'disabled': _vm.loading}],attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('click')}}},[_c('span',{class:[{'align-self-start': !_vm.large, 'm-auto': _vm.large}]},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_c('span',{class:['fr-grow', {'fr-grow-in': _vm.loading}]},[_c('transition',{attrs:{"name":"fr-fade"}},[(_vm.loading)?_c('clip-loader',{staticClass:"position-relative fr-clip-loader ml-3",attrs:{"color":'white',"size":'1rem'}}):_vm._e()],1)],1)])}
var LoadingButton_staticRenderFns = []
var LoadingButton_esExports = { render: LoadingButton_render, staticRenderFns: LoadingButton_staticRenderFns }
/* harmony default export */ var utils_LoadingButton = (LoadingButton_esExports);
// CONCATENATED MODULE: ./src/components/utils/LoadingButton.vue
function LoadingButton_injectStyle (ssrContext) {
  __webpack_require__("xYWi")
}
var LoadingButton_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var LoadingButton___vue_template_functional__ = false
/* styles */
var LoadingButton___vue_styles__ = LoadingButton_injectStyle
/* scopeId */
var LoadingButton___vue_scopeId__ = "data-v-17270933"
/* moduleIdentifier (server only) */
var LoadingButton___vue_module_identifier__ = null
var LoadingButton_Component = LoadingButton_normalizeComponent(
  LoadingButton,
  utils_LoadingButton,
  LoadingButton___vue_template_functional__,
  LoadingButton___vue_styles__,
  LoadingButton___vue_scopeId__,
  LoadingButton___vue_module_identifier__
)

/* harmony default export */ var components_utils_LoadingButton = (LoadingButton_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/EditKBA.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Allows a user to change their KBA, will ensure based on KBA configuration a user must match the systems KBA requirements.
 *
 */
/* harmony default export */ var EditKBA = ({
    name: 'Edit-KBA',
    components: {
        'fr-list-item': components_utils_ListItem,
        'fr-loading-button': components_utils_LoadingButton,
        'fr-validation-error': components_utils_ValidationError
    },
    $_veeValidate: {
        validator: 'new'
    },
    props: ['kbaData'],
    data: function data() {
        return {
            questions: {},
            selectOptions: [],
            selected: [],
            customIndex: null,
            loading: false
        };
    },
    mounted: function mounted() {
        this.questions = this.kbaData.questions;
        this.initializeForm(this.kbaData.minimumAnswersToDefine);
    },

    methods: {
        initializeForm: function initializeForm(minimumRequired) {
            var _this = this;

            var _$i18n = this.$i18n,
                locale = _$i18n.locale,
                fallbackLocale = _$i18n.fallbackLocale;

            // set form state based on stored user questions

            lodash_default.a.times(minimumRequired, function (index) {
                _this.selected.push({ selected: null, index: index + 1, answer: '', custom: '' });
            });

            // create select options
            this.selectOptions = lodash_default.a.map(this.questions, function (question, key) {
                return { value: key, text: question[locale] || question[fallbackLocale], disabled: true };
            });

            this.customIndex = this.selectOptions.length + 1;
            this.selectOptions.unshift({ value: null, text: this.$t('common.user.kba.selectQuestion'), disabled: true });
            this.selectOptions.push({ value: this.customIndex, text: this.$t('common.user.kba.custom'), disabled: false });
        },
        generatePatch: function generatePatch() {
            var values = lodash_default.a.map(this.selected, function (field) {
                if (field.custom) {
                    return {
                        answer: field.answer,
                        customQuestion: field.custom
                    };
                } else {
                    return {
                        answer: field.answer,
                        questionId: field.selected
                    };
                }
            });

            return [{
                operation: 'replace',
                field: '/kbaInfo',
                value: values
            }];
        },
        clearComponent: function clearComponent() {
            this.loading = false;

            this.questions = {};
            this.selectOptions = [];
            this.selected = [];
            this.customIndex = null;

            this.questions = this.kbaData.questions;
            this.initializeForm(this.kbaData.minimumAnswersToDefine);

            this.errors.clear();
        },
        onSaveKBA: function onSaveKBA() {
            var _this2 = this;

            this.isValid().then(function (valid) {
                if (valid) {
                    _this2.loading = true;

                    _this2.$emit('updateKBA', _this2.generatePatch(), { onSuccess: function onSuccess() {
                            _this2.$refs.cancel.click();
                        } });
                }
            });
        },
        isValid: function isValid() {
            /* istanbul ignore next */
            return this.$validator.validateAll();
        }
    },
    watch: {
        selected: {
            handler: function handler(value) {
                var _this3 = this;

                // create array of selected options that aren't custom
                var toDisable = lodash_default.a.map(this.selected, function (s) {
                    if (s.selected !== null && s.selected !== _this3.customIndex) {
                        return s.selected;
                    }
                });

                // set any [toDisable] option to disabled
                lodash_default.a.each(this.selectOptions, function (o) {
                    if (lodash_default.a.includes(toDisable, o.value) || o.value === null) {
                        o.disabled = true;
                    } else {
                        o.disabled = false;
                    }
                });
            },

            deep: true
        },
        kbaData: { deep: true, handler: lodash_default.a.noop }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328857c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/EditKBA.vue
var EditKBA_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-list-item',{attrs:{"collapsible":true,"panelShown":false}},[_c('div',{staticClass:"d-inline-flex w-100 media",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"media-body align-self-center"},[_c('h6',{staticClass:"my-0"},[_vm._v(_vm._s(_vm.$t('pages.profile.accountSecurity.securityQuestions')))])]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-3 align-self-center"},[_c('div',{ref:"cancel",staticClass:"btn btn-link btn-sm float-right btn-cancel",on:{"click":function($event){_vm.clearComponent()}}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('div',{staticClass:"btn btn-link btn-sm float-right btn-edit"},[_vm._v(_vm._s(_vm.$t('common.form.edit')))])])]),_vm._v(" "),(_vm.selected.length)?_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-collapse-body"},slot:"list-item-collapse-body"},[_c('b-form',{staticClass:"w-100"},[_c('b-row',[_c('b-col',{attrs:{"sm":"8"}},[_vm._l((_vm.selected),function(select,id){return _c('fieldset',{key:id,staticClass:"pb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('common.user.kba.question'))+" "+_vm._s(select.index))]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.selectOptions},model:{value:(select.selected),callback:function ($$v) {_vm.$set(select, "selected", $$v)},expression:"select.selected"}}),_vm._v(" "),(select && select.selected === _vm.customIndex)?_c('div',{staticClass:"pb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('pages.profile.accountSecurity.custom')))]),_vm._v(" "),_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:[{'is-invalid': _vm.errors.has(_vm.$t('pages.profile.accountSecurity.custom') + select.index)}, 'form-control'],attrs:{"type":"text","data-vv-validate-on":"submit","name":_vm.$t('pages.profile.accountSecurity.custom')  + select.index},model:{value:(select.custom),callback:function ($$v) {_vm.$set(select, "custom", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"select.custom"}}),_vm._v(" "),_c('fr-validation-error',{attrs:{"validatorErrors":_vm.errors,"fieldName":_vm.$t('pages.profile.accountSecurity.custom') + select.index}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group mb-0"},[_c('label',[_vm._v(_vm._s(_vm.$t('common.user.kba.answer')))]),_vm._v(" "),_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:[{'is-invalid': _vm.errors.has(_vm.$t('common.user.kba.answer') + select.index)}, 'form-control'],attrs:{"type":"text","data-vv-validate-on":"submit","data-vv-as":_vm.$t('common.user.kba.answer'),"name":_vm.$t('common.user.kba.answer') + select.index},model:{value:(select.answer),callback:function ($$v) {_vm.$set(select, "answer", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"select.answer"}}),_vm._v(" "),_c('fr-validation-error',{attrs:{"validatorErrors":_vm.errors,"fieldName":_vm.$t('common.user.kba.answer') + select.index}})],1),_vm._v(" "),(id !== _vm.selected.length - 1)?_c('hr',{staticClass:"mb-3 mt-4"}):_vm._e()],1)}),_vm._v(" "),_c('fr-loading-button',{staticClass:"ld-ext-right mb-3",attrs:{"type":"button","variant":"primary","label":_vm.$t('common.user.kba.saveQuestions'),"loading":_vm.loading},on:{"click":_vm.onSaveKBA}})],2)],1)],1)],1):_vm._e()])}
var EditKBA_staticRenderFns = []
var EditKBA_esExports = { render: EditKBA_render, staticRenderFns: EditKBA_staticRenderFns }
/* harmony default export */ var profile_EditKBA = (EditKBA_esExports);
// CONCATENATED MODULE: ./src/components/profile/EditKBA.vue
var EditKBA_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var EditKBA___vue_template_functional__ = false
/* styles */
var EditKBA___vue_styles__ = null
/* scopeId */
var EditKBA___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditKBA___vue_module_identifier__ = null
var EditKBA_Component = EditKBA_normalizeComponent(
  EditKBA,
  profile_EditKBA,
  EditKBA___vue_template_functional__,
  EditKBA___vue_styles__,
  EditKBA___vue_scopeId__,
  EditKBA___vue_module_identifier__
)

/* harmony default export */ var components_profile_EditKBA = (EditKBA_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/EditPassword.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Allows a user to change their password, makes use of policy password component, similar to registration it will only allow a user to change password
 * as long as it passes policy requirements (policy.json).
 *
 */
/* harmony default export */ var EditPassword = ({
    $_veeValidate: {
        validator: 'new'
    },
    name: 'Edit-Password',
    components: {
        'fr-list-item': components_utils_ListItem,
        'fr-loading-button': components_utils_LoadingButton,
        'fr-password-policy-input': components_utils_PolicyPasswordInput,
        'fr-validation-error': components_utils_ValidationError
    },
    data: function data() {
        return {
            currentPassword: '',
            newPassword: '',
            loading: false,
            showNew: true,
            showCurrent: true,
            inputCurrent: 'password',
            inputNew: 'password',
            userId: this.$root.userStore.getUserState().userId
        };
    },

    methods: {
        clearComponent: function clearComponent() {
            this.currentPassword = '';
            this.newPassword = '';
            this.errors.clear();
        },
        resetComponent: function resetComponent() {
            this.loading = false;
            this.currentPassword = '';
            this.newPassword = '';
            this.$refs.cancel.click();
        },
        displayError: function displayError(error) {
            if (error.response.status === 403) {
                this.errors.add({
                    field: 'currentPassword',
                    msg: 'Incorrect password provided'
                });
            }
        },
        onSavePassword: function onSavePassword() {
            var _this = this;

            var headers = {
                'X-Requested-With': 'XMLHttpRequest',
                'X-OpenIDM-Reauth-Password': this.currentPassword
            },
                payload = [{ operation: 'add', field: '/password', value: this.newPassword }],
                onSuccess = this.resetComponent.bind(this),
                onError = this.displayError.bind(this);

            this.errors.clear();

            this.$validator.validateAll().then(function (valid) {
                if (valid) {
                    _this.$emit('updateProfile', payload, { headers: headers, onSuccess: onSuccess, onError: onError });
                } else {
                    _this.displayNotification('error', _this.$t('pages.profile.accountSecurity.invalidPassword'));
                }
            });
        },
        validate: function validate() {
            return this.$validator.validateAll();
        },
        revealNew: function revealNew() {
            if (this.inputNew === 'password') {
                this.inputNew = 'text';
                this.showNew = false;
            } else {
                this.inputNew = 'password';
                this.showNew = true;
            }
        },
        revealCurrent: function revealCurrent() {
            if (this.inputCurrent === 'password') {
                this.inputCurrent = 'text';
                this.showCurrent = false;
            } else {
                this.inputCurrent = 'password';
                this.showCurrent = true;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c3bc3f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/EditPassword.vue
var EditPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-list-item',{attrs:{"collapsible":true,"panelShown":false}},[_c('div',{staticClass:"d-inline-flex w-100 media",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"media-body align-self-center"},[_c('h6',[_vm._v(_vm._s(_vm.$t('pages.profile.accountSecurity.password')))])]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-3 align-self-center"},[_c('div',{ref:"cancel",staticClass:"btn btn-sm btn-link float-right btn-cancel",on:{"click":function($event){_vm.clearComponent()}}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-link float-right btn-edit"},[_vm._v(_vm._s(_vm.$t('common.form.edit')))])])]),_vm._v(" "),_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-collapse-body"},slot:"list-item-collapse-body"},[_c('b-form',{staticClass:"w-100"},[_c('b-row',[_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-group',[_c('label',{attrs:{"for":"currentPassword"}},[_vm._v(_vm._s(_vm.$t('pages.profile.accountSecurity.currentPassword')))]),_vm._v(" "),_c('div',{staticClass:"form-label-password form-label-group mb-0"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:[{'is-invalid': _vm.errors.has('currentPassword')}, 'form-control'],attrs:{"id":"currentPassword","name":"currentPassword","data-vv-validate-on":"submit","data-vv-as":_vm.$t('pages.profile.accountSecurity.currentPassword'),"type":_vm.inputCurrent},model:{value:(_vm.currentPassword),callback:function ($$v) {_vm.currentPassword=$$v},expression:"currentPassword"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('b-btn',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.revealCurrent}},[_c('i',{class:[{'fa-eye-slash': !_vm.showCurrent}, {'fa-eye': _vm.showCurrent}, 'fa']})])],1)],1),_vm._v(" "),_c('fr-validation-error',{attrs:{"validatorErrors":_vm.errors,"fieldName":"currentPassword"}})],1),_vm._v(" "),_c('fr-password-policy-input',{attrs:{"policyApi":((this.$root.userStore.state.managedResource) + "/" + _vm.userId)},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"slot":"custom-input"},slot:"custom-input"},[_c('label',{attrs:{"for":"newPassword"}},[_vm._v(_vm._s(_vm.$t('pages.profile.accountSecurity.newPassword')))]),_vm._v(" "),_c('div',{staticClass:"form-label-password form-label-group mb-0"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate.initial",value:('required|policy'),expression:"'required|policy'",modifiers:{"initial":true}}],attrs:{"id":"newPassword","type":_vm.inputNew,"name":"password"},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.revealNew}},[_c('i',{class:[{'fa-eye-slash': !_vm.showNew}, {'fa-eye': _vm.showNew}, 'fa']})])])],1)])],1),_vm._v(" "),_c('fr-loading-button',{staticClass:"ld-ext-right mb-3",attrs:{"type":"button","variant":"primary","label":_vm.$t('pages.profile.accountSecurity.savePassword'),"loading":_vm.loading},on:{"click":_vm.onSavePassword}}),_vm._v(" "),(this.$root.applicationStore.state.passwordReset)?_c('div',{staticClass:"text-nowrap pb-2"},[_vm._v(_vm._s(_vm.$t('pages.profile.accountSecurity.rememberPassword'))+" "),_c('router-link',{attrs:{"to":"PasswordReset"}},[_vm._v(_vm._s(_vm.$t('pages.profile.accountSecurity.resetPassword')))])],1):_vm._e()],1)],1)],1)],1)])}
var EditPassword_staticRenderFns = []
var EditPassword_esExports = { render: EditPassword_render, staticRenderFns: EditPassword_staticRenderFns }
/* harmony default export */ var profile_EditPassword = (EditPassword_esExports);
// CONCATENATED MODULE: ./src/components/profile/EditPassword.vue
var EditPassword_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var EditPassword___vue_template_functional__ = false
/* styles */
var EditPassword___vue_styles__ = null
/* scopeId */
var EditPassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditPassword___vue_module_identifier__ = null
var EditPassword_Component = EditPassword_normalizeComponent(
  EditPassword,
  profile_EditPassword,
  EditPassword___vue_template_functional__,
  EditPassword___vue_styles__,
  EditPassword___vue_scopeId__,
  EditPassword___vue_module_identifier__
)

/* harmony default export */ var components_profile_EditPassword = (EditPassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/AccountSecurity.vue
//
//
//
//
//
//
//
//
//





/**
 * @description Handles displaying account security controls (KBA change and password change)
 *
 */
/* harmony default export */ var AccountSecurity = ({
    name: 'Account-Security',
    data: function data() {
        return {
            isOnKBA: false,
            kbaData: {}
        };
    },

    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-edit-kba': components_profile_EditKBA,
        'fr-edit-password': components_profile_EditPassword
    },
    methods: {
        sendUpdateKBA: function sendUpdateKBA(payload, config) {
            this.$emit('updateKBA', payload, config);
        },
        sendUpdateProfile: function sendUpdateProfile(payload, config) {
            this.$emit('updateProfile', payload, config);
        }
    },
    mounted: function mounted() {
        var _this = this;

        /* istanbul ignore next */
        var selfServiceInstance = this.getRequestService({
            headers: this.getAnonymousHeaders()
        });

        // TODO - replace this with call to 'Liveness Service'
        /* istanbul ignore next */
        selfServiceInstance.get('selfservice/kba').then(function (response) {
            _this.isOnKBA = true;
            _this.kbaData = response.data;
        })
        /* istanbul ignore next */
        .catch(function () {
            _this.isOnKBA = false;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529119aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/AccountSecurity.vue
var AccountSecurity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-list-group',{attrs:{"title":_vm.$t('pages.profile.accountSecurity.title'),"subtitle":_vm.$t('pages.profile.accountSecurity.subtitle')}},[_c('fr-edit-password',{on:{"updateProfile":_vm.sendUpdateProfile}}),_vm._v(" "),(_vm.isOnKBA && _vm.$root.userStore.state.internalUser === false)?_c('fr-edit-kba',{attrs:{"kbaData":_vm.kbaData},on:{"updateKBA":_vm.sendUpdateKBA}}):_vm._e()],1)}
var AccountSecurity_staticRenderFns = []
var AccountSecurity_esExports = { render: AccountSecurity_render, staticRenderFns: AccountSecurity_staticRenderFns }
/* harmony default export */ var profile_AccountSecurity = (AccountSecurity_esExports);
// CONCATENATED MODULE: ./src/components/profile/AccountSecurity.vue
var AccountSecurity_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var AccountSecurity___vue_template_functional__ = false
/* styles */
var AccountSecurity___vue_styles__ = null
/* scopeId */
var AccountSecurity___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccountSecurity___vue_module_identifier__ = null
var AccountSecurity_Component = AccountSecurity_normalizeComponent(
  AccountSecurity,
  profile_AccountSecurity,
  AccountSecurity___vue_template_functional__,
  AccountSecurity___vue_styles__,
  AccountSecurity___vue_scopeId__,
  AccountSecurity___vue_module_identifier__
)

/* harmony default export */ var components_profile_AccountSecurity = (AccountSecurity_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/EditPersonalInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description Displays a users profile, auto generates fields based off of resource schema. Currently only displays strings, numbers and booleans. In the case of a policy
 * save error it will highlight the appropriate field and display a policy error. For custom profile changes (e.g. adding a dropdown) this would be the primary file to add these
 * adjustments.
 *
 */
/* harmony default export */ var EditPersonalInfo = ({
    name: 'Edit-Personal-Info',
    mixins: [mixins_ResourceMixin],
    components: {
        'fr-validation-error': components_utils_ValidationError
    },
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        schema: { type: Object, required: true },
        profile: { type: Object, required: true }
    },
    data: function data() {
        return {
            formFields: [],
            originalFormFields: [],
            title: this.$t('pages.profile.editProfile.userDetailsTitle')
        };
    },

    methods: {
        generateFormFields: function generateFormFields() {
            var _this = this;

            var _schema = this.schema,
                order = _schema.order,
                properties = _schema.properties,
                required = _schema.required,
                filteredOrder = lodash_default.a.filter(order, function (propName) {
                return properties[propName].viewable && properties[propName].userEditable && properties[propName].type !== 'array' && properties[propName].type !== 'object';
            }),
                formFields = lodash_default.a.map(filteredOrder, function (name) {
                return {
                    name: name,
                    key: name,
                    title: properties[name].title,
                    value: _this.profile[name] || null,
                    type: properties[name].type,
                    required: lodash_default.a.includes(required, name)
                };
            });

            return formFields;
        },
        hideModal: function hideModal() {
            this.$refs.fsModal.hide();
        },
        setModal: function setModal() {
            var formFields = this.generateFormFields();

            this.formFields = formFields;
            this.originalFormFields = lodash_default.a.cloneDeep(formFields);
        },
        saveForm: function saveForm() {
            var _this2 = this;

            /* istanbul ignore next */
            this.isValid().then(function (valid) {
                if (valid) {
                    var idmInstance = _this2.getRequestService();
                    var policyFields = {};

                    lodash_default.a.each(_this2.formFields, function (field) {
                        if (field.value !== null) {
                            policyFields[field.name] = field.value;
                        }
                    });

                    idmInstance.post('policy/' + _this2.$root.userStore.state.managedResource + '/' + _this2.$root.userStore.state.userId + '?_action=validateObject', policyFields).then(function (policyResult) {
                        if (policyResult.data.failedPolicyRequirements.length === 0) {
                            _this2.$emit('updateProfile', _this2.generateUpdatePatch(_this2.originalFormFields, _this2.formFields));
                            _this2.errors.clear();
                            _this2.hideModal();
                        } else {
                            var generatedErrors = _this2.findPolicyError({
                                data: {
                                    detail: {
                                        failedPolicyRequirements: policyResult.data.failedPolicyRequirements
                                    }
                                }
                            }, _this2.formFields);

                            _this2.errors.clear();

                            if (generatedErrors.length > 0) {
                                lodash_default.a.each(generatedErrors, function (generatedError) {
                                    if (generatedError.exists) {
                                        _this2.errors.add(generatedError);
                                    }
                                });
                            } else {
                                _this2.displayNotification('error', _this2.$t('pages.profile.editProfile.failedProfileSave'));
                            }
                        }
                    });
                }
            });
        },
        isValid: function isValid() {
            return this.$validator.validateAll();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d7a672a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/EditPersonalInfo.vue
var EditPersonalInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"fsModal",staticClass:"fr-full-screen",attrs:{"id":"userDetailsModal","cancel-variant":"outline-secondary"},on:{"show":_vm.setModal},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.saveForm($event)}}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h5',{staticClass:"modal-title align-self-center text-center"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.hideModal}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"8","offset-sm":"2"}},[(_vm.formFields.length > 0)?_c('b-form',{staticClass:"mb-3 fr-edit-personal-form",staticStyle:{"flex-direction":"column"},attrs:{"name":"edit-personal-form"}},[_vm._l((_vm.formFields),function(field,index){return [(field.type === 'string' || field.type === 'number')?_c('b-form-group',{key:index,staticStyle:{"min-width":"200px"}},[_c('label',{attrs:{"for":field.title}},[_vm._v(_vm._s(field.title))]),_vm._v(" "),(!field.required)?_c('small',{staticClass:"text-muted ml-1"},[_vm._v(_vm._s(_vm.$t('pages.profile.editProfile.optional')))]):_vm._e(),_vm._v(" "),(field.type === 'string')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(field.required ? 'required' : ''),expression:"field.required ? 'required' : ''"},{name:"model",rawName:"v-model.trim",value:(_vm.formFields[index].value),expression:"formFields[index].value",modifiers:{"trim":true}}],class:[{'is-invalid': _vm.errors.has(field.name)}, 'form-control'],attrs:{"data-vv-validate-on":"submit","name":field.name,"type":field.type,"data-vv-as":field.title},domProps:{"value":(_vm.formFields[index].value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formFields[index], "value", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(field.required ? 'required' : ''),expression:"field.required ? 'required' : ''"},{name:"model",rawName:"v-model.number",value:(_vm.formFields[index].value),expression:"formFields[index].value",modifiers:{"number":true}}],class:[{'is-invalid': _vm.errors.has(field.name)}, 'form-control'],attrs:{"data-vv-validate-on":"submit","name":field.name,"type":field.type,"data-vv-as":field.title},domProps:{"value":(_vm.formFields[index].value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formFields[index], "value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('fr-validation-error',{attrs:{"validatorErrors":_vm.errors,"fieldName":field.name}})],1):_vm._e(),_vm._v(" "),(field.type === 'boolean')?_c('b-form-group',{key:index},[_c('div',{staticClass:"d-flex flex-column"},[_c('label',{staticClass:"mr-auto",attrs:{"for":field.title}},[_vm._v(_vm._s(field.title))]),_vm._v(" "),_c('div',{staticClass:"mr-auto"},[_c('toggle-button',{staticClass:"mt-2 p-0 fr-toggle-primary",attrs:{"height":28,"width":56,"sync":true,"cssColors":true,"labels":{checked: _vm.$t('common.form.yes'), unchecked: _vm.$t('common.form.no')},"value":_vm.formFields[index].value},on:{"change":function($event){_vm.formFields[index].value = !_vm.formFields[index].value}}})],1)])]):_vm._e()]})],2):[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('pages.profile.editProfile.noFields')))])]],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":"primary","disabled":_vm.$root.userStore.state.internalUser},on:{"click":_vm.saveForm}},[_vm._v(_vm._s(_vm.$t('common.form.saveChanges')))])],1)])],1)}
var EditPersonalInfo_staticRenderFns = []
var EditPersonalInfo_esExports = { render: EditPersonalInfo_render, staticRenderFns: EditPersonalInfo_staticRenderFns }
/* harmony default export */ var profile_EditPersonalInfo = (EditPersonalInfo_esExports);
// CONCATENATED MODULE: ./src/components/profile/EditPersonalInfo.vue
function EditPersonalInfo_injectStyle (ssrContext) {
  __webpack_require__("Ex+Q")
}
var EditPersonalInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var EditPersonalInfo___vue_template_functional__ = false
/* styles */
var EditPersonalInfo___vue_styles__ = EditPersonalInfo_injectStyle
/* scopeId */
var EditPersonalInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditPersonalInfo___vue_module_identifier__ = null
var EditPersonalInfo_Component = EditPersonalInfo_normalizeComponent(
  EditPersonalInfo,
  profile_EditPersonalInfo,
  EditPersonalInfo___vue_template_functional__,
  EditPersonalInfo___vue_styles__,
  EditPersonalInfo___vue_scopeId__,
  EditPersonalInfo___vue_module_identifier__
)

/* harmony default export */ var components_profile_EditPersonalInfo = (EditPersonalInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/Preferences.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description Displays available user preferences, these are typically true/false values associated with a managed resource (e.g. Do you want to recieve marketing emails?).
 *
 */
/* harmony default export */ var Preferences = ({
    name: 'Preferences',
    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem
    },
    data: function data() {
        return {
            preferences: {}
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            var keys = lodash_default.a.keys(this.$root.userStore.state.profile.preferences),
                preferences = lodash_default.a.cloneDeep(this.$root.userStore.state.schema.properties.preferences.properties);

            lodash_default.a.each(keys, function (key) {
                preferences[key].value = _this.$root.userStore.state.profile.preferences[key];
                delete preferences[key].type;
            });

            this.preferences = preferences;
        },
        generatePatch: function generatePatch(preference, value) {
            return [{ operation: 'replace', field: '/preferences/' + preference, value: value }];
        },
        savePreferences: function savePreferences(preference, value) {
            this.$emit('updateProfile', this.generatePatch(preference, value));
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f30fa5d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Preferences.vue
var Preferences_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-list-group',{attrs:{"title":_vm.$t('pages.profile.preferences.title'),"subtitle":_vm.$t('pages.profile.preferences.subtitle')}},_vm._l((_vm.preferences),function(obj,preference){return _c('fr-list-item',{key:preference,attrs:{"collapsible":false,"panelShown":false}},[_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('h6',{staticClass:"mt-3"},[_vm._v(_vm._s(obj.description))]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('toggle-button',{staticClass:"mt-2 p-0 fr-toggle-primary",attrs:{"id":preference,"height":28,"width":56,"sync":true,"cssColors":true,"value":obj.value},on:{"change":function($event){_vm.savePreferences(preference, $event.value)}}})],1)])])}))}
var Preferences_staticRenderFns = []
var Preferences_esExports = { render: Preferences_render, staticRenderFns: Preferences_staticRenderFns }
/* harmony default export */ var profile_Preferences = (Preferences_esExports);
// CONCATENATED MODULE: ./src/components/profile/Preferences.vue
function Preferences_injectStyle (ssrContext) {
  __webpack_require__("302j")
}
var Preferences_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Preferences___vue_template_functional__ = false
/* styles */
var Preferences___vue_styles__ = Preferences_injectStyle
/* scopeId */
var Preferences___vue_scopeId__ = "data-v-f30fa5d6"
/* moduleIdentifier (server only) */
var Preferences___vue_module_identifier__ = null
var Preferences_Component = Preferences_normalizeComponent(
  Preferences,
  profile_Preferences,
  Preferences___vue_template_functional__,
  Preferences___vue_styles__,
  Preferences___vue_scopeId__,
  Preferences___vue_module_identifier__
)

/* harmony default export */ var components_profile_Preferences = (Preferences_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/FallbackImage.vue
//
//
//
//
//
//
//
//
//



/**
 * @description Component that will load an image and if the image fails to load it will display a fallback image rather then loading nothing
 *
 **/
/* harmony default export */ var FallbackImage = ({
    name: 'Image-Fallback',
    props: ['src', 'width', 'height', 'alt', 'fallback'],
    data: function data() {
        return {
            imageFound: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        /* istanbul ignore next */
        if (!lodash_default.a.isNull(this.src) && !lodash_default.a.isUndefined(this.src) && this.src.length > 0) {
            axios_default.a.get('' + this.src).then(function (_ref) {
                var status = _ref.status;

                _this.imageFound = status === 200;
            }).catch(function (error) {
                if (error) {
                    _this.imageFound = false;
                }
            });
        } else {
            this.imageFound = false;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfc03be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/FallbackImage.vue
var FallbackImage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.imageFound)?_c('b-img',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.width,"alt":_vm.alt}}):_c('span',{staticClass:"icon-holder p-2 d-flex bg-light border rounded"},[_c('i',{class:['fa', _vm.fallback, 'fa-lg text-dark mt-auto']})])],1)}
var FallbackImage_staticRenderFns = []
var FallbackImage_esExports = { render: FallbackImage_render, staticRenderFns: FallbackImage_staticRenderFns }
/* harmony default export */ var utils_FallbackImage = (FallbackImage_esExports);
// CONCATENATED MODULE: ./src/components/utils/FallbackImage.vue
function FallbackImage_injectStyle (ssrContext) {
  __webpack_require__("weCJ")
}
var FallbackImage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var FallbackImage___vue_template_functional__ = false
/* styles */
var FallbackImage___vue_styles__ = FallbackImage_injectStyle
/* scopeId */
var FallbackImage___vue_scopeId__ = "data-v-5cfc03be"
/* moduleIdentifier (server only) */
var FallbackImage___vue_module_identifier__ = null
var FallbackImage_Component = FallbackImage_normalizeComponent(
  FallbackImage,
  utils_FallbackImage,
  FallbackImage___vue_template_functional__,
  FallbackImage___vue_styles__,
  FallbackImage___vue_scopeId__,
  FallbackImage___vue_module_identifier__
)

/* harmony default export */ var components_utils_FallbackImage = (FallbackImage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/TrustedDevices.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description If fullstack (AM/IDM) is configured will work with authorized devices endpoiint (AM) and display a list of currently of authorized devices for the current
 * user. This will also allow a user to remove an authorized device, causing the next login session of that device to trigger the appropriate device authorization flow from AM.
 *
 */
/* harmony default export */ var TrustedDevices = ({
    name: 'Trusted-Devices',
    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem,
        'fr-fallback-image': components_utils_FallbackImage
    },
    data: function data() {
        return {
            devices: {},
            confirmDevice: {
                name: '',
                id: null
            }
        };
    },
    mounted: function mounted() {
        /* istanbul ignore next */
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                query = '?_queryId=*',
                selfServiceInstance = this.getRequestService(),
                url = this.$root.applicationStore.state.amDataEndpoints.baseUrl + userName + this.$root.applicationStore.state.amDataEndpoints.trustedDevices + query;

            /* istanbul ignore next */
            // by default CORS requests don't allow cookies, the 'withCredentials: true' flag allows it
            selfServiceInstance.get(url, { withCredentials: true }).then(function (response) {
                _this.devices = response.data.result;
            }).catch(function (error) {
                /* istanbul ignore next */
                _this.displayNotification('error', error.response.data.message);
            });
        },
        showConfirmationModal: function showConfirmationModal(device) {
            this.confirmDevice.id = device.uuid;
            this.confirmDevice.name = device.name;
            this.$refs.fsModal.show();
        },
        removeDevice: function removeDevice(deviceId) {
            var _this2 = this;

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                selfServiceInstance = this.getRequestService(),
                url = this.$root.applicationStore.state.amDataEndpoints.baseUrl + userName + this.$root.applicationStore.state.amDataEndpoints.trustedDevices + deviceId;

            /* istanbul ignore next */
            // by default CORS requests don't allow cookies, the 'withCredentials: true' flag allows it
            selfServiceInstance.delete(url, { withCredentials: true }).then(function () {
                _this2.displayNotification('success', _this2.$t('pages.profile.trustedDevices.removeSuccess', { deviceName: _this2.confirmDevice.name }));
                _this2.loadData();
                _this2.$refs.fsModal.hide();
            }).catch(function (error) {
                /* istanbul ignore next */
                _this2.displayNotification('error', error.response.data.message);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-497789d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/TrustedDevices.vue
var TrustedDevices_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-list-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.devices),expression:"devices"}],attrs:{"title":_vm.$t('pages.profile.trustedDevices.title'),"subtitle":_vm.$t('pages.profile.trustedDevices.subtitle')}},[(_vm.devices.length > 0)?_vm._l((_vm.devices),function(device,id){return _c('fr-list-item',{key:id,attrs:{"collapsible":false,"panelShown":false}},[_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"d-flex mr-3 align-self-top"},[_c('fr-fallback-image',{attrs:{"src":device.logo_uri,"fallback":"fa-television m-auto pt-1 pb-1"}})],1),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"},[_c('div',[_vm._v("\n                        "+_vm._s(device.name)+"\n                    ")]),_vm._v(" "),_c('small',{staticClass:"text-muted subtext"},[_vm._v(_vm._s(device.lastSelectedDate))])]),_vm._v(" "),_c('a',{staticClass:"align-self-center flex-grow-2 text-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showConfirmationModal(device)}}},[_vm._v(_vm._s(_vm.$t('common.form.remove')))])])])}):[_c('b-list-group-item',{staticClass:"noncollapse text-center"},[_vm._v("\n            "+_vm._s(_vm.$t('pages.profile.trustedDevices.noDevices'))+"\n        ")])],_vm._v(" "),_c('b-modal',{ref:"fsModal",attrs:{"id":"trustedDevicesConfirmationModal","cancel-variant":"outline-secondary"}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h6',{staticClass:"my-0"},[_vm._v(_vm._s(_vm.$t('common.form.confirm')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){_vm.$refs.fsModal.hide()}}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v("\n        "+_vm._s(_vm.$t('pages.profile.trustedDevices.removeConfirmation', {deviceName: _vm.confirmDevice.name }))+"\n        "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":function($event){_vm.$refs.fsModal.hide()}}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":"danger"},on:{"click":function($event){_vm.removeDevice(_vm.confirmDevice.id)}}},[_vm._v(_vm._s(_vm.$t('common.form.remove')))])],1)])])],2)}
var TrustedDevices_staticRenderFns = []
var TrustedDevices_esExports = { render: TrustedDevices_render, staticRenderFns: TrustedDevices_staticRenderFns }
/* harmony default export */ var profile_TrustedDevices = (TrustedDevices_esExports);
// CONCATENATED MODULE: ./src/components/profile/TrustedDevices.vue
function TrustedDevices_injectStyle (ssrContext) {
  __webpack_require__("wntQ")
}
var TrustedDevices_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var TrustedDevices___vue_template_functional__ = false
/* styles */
var TrustedDevices___vue_styles__ = TrustedDevices_injectStyle
/* scopeId */
var TrustedDevices___vue_scopeId__ = "data-v-497789d9"
/* moduleIdentifier (server only) */
var TrustedDevices___vue_module_identifier__ = null
var TrustedDevices_Component = TrustedDevices_normalizeComponent(
  TrustedDevices,
  profile_TrustedDevices,
  TrustedDevices___vue_template_functional__,
  TrustedDevices___vue_styles__,
  TrustedDevices___vue_scopeId__,
  TrustedDevices___vue_module_identifier__
)

/* harmony default export */ var components_profile_TrustedDevices = (TrustedDevices_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/AuthorizedApplications.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description If fullstack (AM/IDM) is configured will work with authorized applications endpoiint (AM) and display a list of currently tied applications.
 * It is possible to also remove these applications though if you attempt to remove openIDM it will always re-add since this is needed to ensure fullstack works.
 *
 */
/* harmony default export */ var AuthorizedApplications = ({
    name: 'Authorized-Applications',
    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem,
        'fr-fallback-image': components_utils_FallbackImage
    },
    data: function data() {
        return {
            oauthApplications: {},
            confirmApplication: {
                name: '',
                id: null
            }
        };
    },
    mounted: function mounted() {
        /* istanbul ignore next */
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                query = '?_queryId=*',
                selfServiceInstance = this.getRequestService(),
                url = this.$root.applicationStore.state.amDataEndpoints.baseUrl + userName + this.$root.applicationStore.state.amDataEndpoints.oauthApplications + query;

            /* istanbul ignore next */
            // by default CORS requests don't allow cookies, the 'withCredentials: true' flag allows it
            selfServiceInstance.get(url, { withCredentials: true }).then(function (response) {
                _this.oauthApplications = response.data.result;
            }).catch(function (error) {
                /* istanbul ignore next */
                _this.displayNotification('error', error.response.data.message);
            });
        },
        showConfirmationModal: function showConfirmationModal(application) {
            this.confirmApplication.id = application._id;
            this.$refs.fsModal.show();
        },
        removeApplication: function removeApplication(applicationId) {
            var _this2 = this;

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                selfServiceInstance = this.getRequestService(),
                url = this.$root.applicationStore.state.amDataEndpoints.baseUrl + userName + this.$root.applicationStore.state.amDataEndpoints.oauthApplications + applicationId;

            /* istanbul ignore next */
            // by default CORS requests don't allow cookies, the 'withCredentials: true' flag allows it
            selfServiceInstance.delete(url, { withCredentials: true }).then(function () {
                _this2.displayNotification('success', _this2.$t('pages.profile.oauthApplications.removeSuccess', { applicationName: _this2.confirmApplication.id }));
                _this2.loadData();
                _this2.$refs.fsModal.hide();
            }).catch(function (error) {
                /* istanbul ignore next */
                _this2.displayNotification('error', error.response.data.message);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6553355e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/AuthorizedApplications.vue
var AuthorizedApplications_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-list-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.oauthApplications),expression:"oauthApplications"}],attrs:{"title":_vm.$t('pages.profile.oauthApplications.title'),"subtitle":_vm.$t('pages.profile.oauthApplications.subtitle')}},[(_vm.oauthApplications.length > 0)?_vm._l((_vm.oauthApplications),function(application,id){return _c('fr-list-item',{key:id,attrs:{"collapsible":false,"panelShown":false}},[_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"d-flex mr-3 align-self-top"},[_c('img',{attrs:{"src":application.logo_uri || 'static/images/authorized-app.svg',"width":"25"}})]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"},[_c('div',[_vm._v("\n                        "+_vm._s(application._id)+"\n                    ")]),_vm._v(" "),_c('small',{staticClass:"text-muted subtext"},[_vm._v(_vm._s(_vm.$t('pages.profile.oauthApplications.expires'))+" "+_vm._s(new Date(application.expiryDateTime).toUTCString()))])]),_vm._v(" "),_c('a',{staticClass:"align-self-center flex-grow-2 text-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showConfirmationModal(application)}}},[_vm._v(_vm._s(_vm.$t('common.form.remove')))])])])}):[_c('b-list-group-item',{staticClass:"noncollapse text-center"},[_vm._v("\n            "+_vm._s(_vm.$t('pages.profile.oauthApplications.noApplications'))+"\n        ")])],_vm._v(" "),_c('b-modal',{ref:"fsModal",attrs:{"id":"authAppConfirmationModal","cancel-variant":"outline-secondary"}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h6',{staticClass:"my-0"},[_vm._v(_vm._s(_vm.$t('common.form.confirm')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){_vm.$refs.fsModal.hide()}}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v("\n        "+_vm._s(_vm.$t('pages.profile.oauthApplications.removeConfirmation', {applicationName: _vm.confirmApplication.name }))+"\n        "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":function($event){_vm.$refs.fsModal.hide()}}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":"danger"},on:{"click":function($event){_vm.removeApplication(_vm.confirmApplication.id)}}},[_vm._v(_vm._s(_vm.$t('common.form.remove')))])],1)])])],2)}
var AuthorizedApplications_staticRenderFns = []
var AuthorizedApplications_esExports = { render: AuthorizedApplications_render, staticRenderFns: AuthorizedApplications_staticRenderFns }
/* harmony default export */ var profile_AuthorizedApplications = (AuthorizedApplications_esExports);
// CONCATENATED MODULE: ./src/components/profile/AuthorizedApplications.vue
function AuthorizedApplications_injectStyle (ssrContext) {
  __webpack_require__("OdVq")
}
var AuthorizedApplications_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var AuthorizedApplications___vue_template_functional__ = false
/* styles */
var AuthorizedApplications___vue_styles__ = AuthorizedApplications_injectStyle
/* scopeId */
var AuthorizedApplications___vue_scopeId__ = "data-v-6553355e"
/* moduleIdentifier (server only) */
var AuthorizedApplications___vue_module_identifier__ = null
var AuthorizedApplications_Component = AuthorizedApplications_normalizeComponent(
  AuthorizedApplications,
  profile_AuthorizedApplications,
  AuthorizedApplications___vue_template_functional__,
  AuthorizedApplications___vue_styles__,
  AuthorizedApplications___vue_scopeId__,
  AuthorizedApplications___vue_module_identifier__
)

/* harmony default export */ var components_profile_AuthorizedApplications = (AuthorizedApplications_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05cbfe9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/AccessLevel.vue
var AccessLevel_render = function (_h,_vm) {var _c=_vm._c;return _c('dl',{staticClass:"row"},[_c('dt',{staticClass:"col-xl-5 mb-3"},[_vm._v(_vm._s(_vm.parent.$t('pages.profile.consent.accountAccess')))]),_vm._v(" "),_c('dd',{staticClass:"col-xl-7 mb-4"},[_c('ul',{staticClass:"list-unstyled text-muted"},_vm._l((_vm.props.fields),function(field){return _c('li',{key:field.name,staticClass:"py-1"},[_c('i',{staticClass:"fa fa-check fa-fw text-success mr-2"}),_vm._v(_vm._s(field.title))])}))])])}
var AccessLevel_staticRenderFns = []
var AccessLevel_esExports = { render: AccessLevel_render, staticRenderFns: AccessLevel_staticRenderFns }
/* harmony default export */ var AccessLevel = (AccessLevel_esExports);
// CONCATENATED MODULE: ./src/components/profile/AccessLevel.vue
var AccessLevel_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var AccessLevel___vue_template_functional__ = true
/* styles */
var AccessLevel___vue_styles__ = null
/* scopeId */
var AccessLevel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AccessLevel___vue_module_identifier__ = null
var AccessLevel_Component = AccessLevel_normalizeComponent(
  __vue_script__,
  AccessLevel,
  AccessLevel___vue_template_functional__,
  AccessLevel___vue_styles__,
  AccessLevel___vue_scopeId__,
  AccessLevel___vue_module_identifier__
)

/* harmony default export */ var profile_AccessLevel = (AccessLevel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/Consent.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/**
 * @description Controls the display of a users currently consented mappings (where their data is sent).
 *
 * @fires POST consent?_action=getConsentMappings - Gets a list of available mappings for consent in conjunction with the consent portion of a users profile this is
 * used to display which mappings are consented to and can be consented out of.
 *
 */
/* harmony default export */ var Consent = ({
    name: 'Consent',
    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem,
        'fr-access-level': profile_AccessLevel,
        'fr-fallback-image': components_utils_FallbackImage
    },
    props: ['consentedMappings'],
    data: function data() {
        return {
            consentableMappings: []
        };
    },

    computed: {
        mappings: function mappings() {
            var _this = this;

            return this.consentableMappings.map(function (mapping) {
                var consentedMapping = lodash_default.a.find(_this.consentedMappings, { mapping: mapping.name }),
                    modalHeaderPath = 'pages.profile.consent.';

                mapping.showDetails = false;

                if (!lodash_default.a.isUndefined(consentedMapping)) {
                    mapping.consented = true;
                    mapping.consentDate = consentedMapping.consentDate;
                    modalHeaderPath += 'denyConsentHeader';
                    mapping.subTitle = _this.$t('pages.profile.consent.authorized') + ' ' + moment_default()(mapping.consentDate).format('MMMM Do YYYY');
                } else {
                    mapping.consented = false;
                    modalHeaderPath += 'allowConsentHeader';
                    mapping.subTitle = _this.$t('pages.profile.consent.notAuthorized');
                }

                mapping.modalHeader = _this.$t(modalHeaderPath);
                return mapping;
            });
        }
    },
    created: function created() {
        var _this2 = this;

        /* istanbul ignore next */
        this.getRequestService().post('consent?_action=getConsentMappings').then(function (_ref) {
            var data = _ref.data;

            _this2.consentableMappings = data;
        });
    },

    methods: {
        showModal: function showModal(name) {
            lodash_default.a.first(this.$refs[name]).show();
        },
        toggleConsentAndHideModal: function toggleConsentAndHideModal(mapping) {
            this.toggleConsent(mapping);
            this.hideModal(mapping.name);
        },
        hideModal: function hideModal(name) {
            lodash_default.a.first(this.$refs[name]).hide();
        },
        generatePatch: function generatePatch(mapping) {
            var consentDate = mapping.consentDate,
                name = mapping.name,
                value = {
                consentDate: consentDate,
                mapping: name
            },
                field = '/consentedMappings',
                operation = void 0;


            if (!mapping.consented) {
                value.consentDate = new Date().toISOString();
                field += '/-';
                operation = 'add';
            } else {
                operation = 'remove';
            }

            return [{ field: field, operation: operation, value: value }];
        },
        toggleConsent: function toggleConsent(mapping, event) {
            this.$emit('updateProfile', this.generatePatch(mapping));
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d537b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Consent.vue
var Consent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-list-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.mappings.length),expression:"mappings.length"}],attrs:{"title":_vm.$t('pages.profile.consent.title'),"subtitle":_vm.$t('pages.profile.consent.subtitle')}},_vm._l((_vm.mappings),function(mapping){return _c('fr-list-item',{key:mapping.name,attrs:{"collapsible":mapping.consented,"panelShown":false}},[_c('template',{staticClass:"overflow:hidden;",slot:"list-item-header"},[_c('fr-fallback-image',{staticClass:"mr-3",attrs:{"src":mapping.icon,"width":"24","height":"24","alt":mapping.name,"fallback":"fa-gear"}}),_vm._v(" "),_c('div',{staticClass:"media-body",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"d-block"},[_c('h6',{staticClass:"my-0"},[_vm._v(_vm._s(mapping.displayName))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(mapping.subTitle))])])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-self-right"},[_c('b-button',{attrs:{"type":"button","variant":"link"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showModal(mapping.name)}}},[_vm._v("\n                        "+_vm._s(_vm.$t(("pages.profile.consent." + (mapping.consented ? 'deny' : 'allow'))))+"\n                    ")]),_vm._v(" "),(mapping.consented)?_c('div',{staticClass:"caret ml-2 my-auto"},[_c('i',{staticClass:"fa fa-angle-down fa-lg pr-0 caret-down align-self-center"}),_vm._v(" "),_c('i',{staticClass:"fa fa-angle-up fa-lg pr-0 pt-1 caret-up align-self-center"})]):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:mapping.name,refInFor:true,attrs:{"id":mapping.name,"size":"md","cancel-variant":"outline-secondary"}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h5',{staticClass:"modal-title align-self-center text-center"},[_vm._v(_vm._s(mapping.modalHeader))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.hideModal(mapping.name)}}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('b-container',[(mapping.consented)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('pages.profile.consent.confirmDeny', {mappingName: mapping.displayName}))}}):_c('fr-access-level',{attrs:{"fields":mapping.fields}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.hideModal(mapping.name)}}},[_vm._v(_vm._s(_vm.$t('common.form.cancel')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":mapping.consented ? 'danger' : 'primary'},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.toggleConsentAndHideModal(mapping)}}},[_vm._v("\n                                "+_vm._s(_vm.$t(("pages.profile.consent." + (mapping.consented ? 'deny' : 'allow'))))+"\n                            ")])],1)])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"list-item-collapse-body"},slot:"list-item-collapse-body"},[_c('fr-access-level',{attrs:{"fields":mapping.fields}})],1)],2)}))}
var Consent_staticRenderFns = []
var Consent_esExports = { render: Consent_render, staticRenderFns: Consent_staticRenderFns }
/* harmony default export */ var profile_Consent = (Consent_esExports);
// CONCATENATED MODULE: ./src/components/profile/Consent.vue
var Consent_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Consent___vue_template_functional__ = false
/* styles */
var Consent___vue_styles__ = null
/* scopeId */
var Consent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Consent___vue_module_identifier__ = null
var Consent_Component = Consent_normalizeComponent(
  Consent,
  profile_Consent,
  Consent___vue_template_functional__,
  Consent___vue_styles__,
  Consent___vue_scopeId__,
  Consent___vue_module_identifier__
)

/* harmony default export */ var components_profile_Consent = (Consent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/SocialIdentityPanel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Display component for each configured social provider
 *
 * @fires POST identityProviders?_action=normalizeProfile - Returns a nromalized set of data for social providers, this is used to provide additional display such as profile picture from Facebook or Google.
 *
 */
/* harmony default export */ var SocialIdentityPanel = ({
    name: 'Social-Identity-Panel',
    props: ['provider'],
    data: function data() {
        return { profile: {} };
    },
    created: function created() {
        var _this = this;

        // istanbul ignore next
        this.getRequestService().post('identityProviders?_action=normalizeProfile', this.getProfileRequestPayload()).then(function (_ref) {
            var data = _ref.data;

            _this.profile = lodash_default.a.first(data);
        });
    },

    methods: {
        getProfileRequestPayload: function getProfileRequestPayload() {
            var _this2 = this;

            var rawProfile = this.provider.propertyMap.reduce(function (result, mapping) {
                return lodash_default.a.set(result, mapping.source, _this2.provider[mapping.source]);
            }, {});

            rawProfile._refResourceCollection = this.provider._refResourceCollection;

            return { rawProfile: rawProfile };
        },

        capitalize: lodash_default.a.capitalize
    },
    computed: {
        showAccountDetails: function showAccountDetails() {
            var profileNotEmtpy = !lodash_default.a.isEmpty(this.profile),
                profileHasDisplayName = lodash_default.a.has(this.profile, 'displayName'),
                profileHasEmailOrUsername = lodash_default.a.has(this.profile, 'email') || lodash_default.a.has(this.profile, 'username');

            return profileNotEmtpy && (profileHasDisplayName || profileHasEmailOrUsername);
        },
        photoUrl: function photoUrl() {
            return this.profile.photoUrl || 'static/images/profile-default.png';
        },
        accountDisplayName: function accountDisplayName() {
            return this.profile.email || this.profile.username;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5768dbd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/SocialIdentityPanel.vue
var SocialIdentityPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showAccountDetails)?_c('div',{staticClass:"row mb-4"},[_c('strong',{staticClass:"col fr-social-details-title"},[_vm._v("\n            "+_vm._s(_vm.$t('pages.profile.socialSignIn.linkedAccount'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"media"},[_c('b-img',{staticClass:"my-auto mr-3",attrs:{"src":_vm.photoUrl,"rounded":"circle","width":"40","height":"40","alt":"img"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('strong',{staticClass:"fr-social-details-title d-block mb-0"},[_vm._v(_vm._s(_vm.profile.displayName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.accountDisplayName),expression:"accountDisplayName"}],staticClass:"text-muted"},[_vm._v(_vm._s(_vm.accountDisplayName))])])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('strong',{staticClass:"col fr-social-details-title"},[_vm._v("\n            "+_vm._s(_vm.$t('pages.profile.socialSignIn.sharing'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-8 text-muted"},_vm._l((_vm.provider.scope),function(scope,index){return _c('span',{staticClass:"d-block py-1"},[_c('i',{staticClass:"fa fa-check text-success mr-2"}),_vm._v("\n                "+_vm._s(_vm.capitalize(scope))+"\n            ")])}))])])}
var SocialIdentityPanel_staticRenderFns = []
var SocialIdentityPanel_esExports = { render: SocialIdentityPanel_render, staticRenderFns: SocialIdentityPanel_staticRenderFns }
/* harmony default export */ var profile_SocialIdentityPanel = (SocialIdentityPanel_esExports);
// CONCATENATED MODULE: ./src/components/profile/SocialIdentityPanel.vue
var SocialIdentityPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var SocialIdentityPanel___vue_template_functional__ = false
/* styles */
var SocialIdentityPanel___vue_styles__ = null
/* scopeId */
var SocialIdentityPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SocialIdentityPanel___vue_module_identifier__ = null
var SocialIdentityPanel_Component = SocialIdentityPanel_normalizeComponent(
  SocialIdentityPanel,
  profile_SocialIdentityPanel,
  SocialIdentityPanel___vue_template_functional__,
  SocialIdentityPanel___vue_styles__,
  SocialIdentityPanel___vue_scopeId__,
  SocialIdentityPanel___vue_module_identifier__
)

/* harmony default export */ var components_profile_SocialIdentityPanel = (SocialIdentityPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/SocialIdentities.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Handles displaying a users social providers, will also allow a user to configure a new social provider based on available providers
 *
 * @fires POST resource/name/ID?_action=bind&provider=provider (e.g. managed/user/fakeID?_action=bind&provider=google) - Binds a provider based on a return client token from the provider
 * @fires GET /identityProviders - List of available social providers
 * @fires POST managed/user/ID?_fields=idps/* (e.g. managed/user/fakeId?_fields=idps/*) - List of social providers already configured for the current logged in resource.
 * @fires POST /identityProviders?_action=getAuthRedirect - Generated the redirect information for a selected social provider
 * @fires POST resource/name/ID?_action=unbind&provider=provider (e.g. managed/user/fakeID?_action=unbind&provider=google) - Unbinds a social provider from the current sessions user
 *
 */
/* harmony default export */ var SocialIdentities = ({
    name: 'Social-Identities',
    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem,
        'fr-social-identity-panel': components_profile_SocialIdentityPanel
    },
    props: {
        'clientToken': String,
        'linkedProvider': String
    },
    data: function data() {
        return {
            'allAvailableProviders': [],
            'connectedProviders': [],
            'providers': [],
            'toDisconnect': {}
        };
    },
    created: function created() {
        var _this = this;

        if (!lodash_default.a.isUndefined(this.clientToken)) {
            var socialInstance = this.getRequestService();
            /* istanbul ignore next */
            socialInstance.post(this.$root.userStore.state.managedResource + '/' + this.$root.userStore.state.userId + '?_action=bind&provider=' + this.linkedProvider, stringify_default()(this.clientToken)).then(function () {
                _this.getAllConnectedProviders(_this.getRequestService({
                    headers: _this.getAnonymousHeaders()
                }));
                _this.displayNotification('success', lodash_default.a.find(_this.providers, { provider: _this.linkedProvider }).uiConfig.buttonDisplayName + ' has been linked');
                delete _this.clientToken;
            }).catch(function (error) {
                /* istanbul ignore next */
                _this.displayNotification('error', error.response.data.message);
            });
        }
    },
    mounted: function mounted() {
        /* istanbul ignore next */
        this.loadData();
    },

    computed: {
        disconnectedProvider: function disconnectedProvider() {
            var providerName = lodash_default.a.get(this.toDisconnect, 'uiConfig.buttonDisplayName');
            return providerName || '';
        }
    },
    methods: {
        loadData: function loadData() {
            var _this2 = this;

            this.providers = [];
            /* istanbul ignore next */
            var socialInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });

            /* istanbul ignore next */
            socialInstance.get('/identityProviders').then(function (response) {
                _this2.allAvailableProviders = response.data.providers;
                _this2.getAllConnectedProviders(socialInstance);
            }).catch(function (error) {
                _this2.displayNotification('error', error.response.data.message);
            });
        },
        getAllConnectedProviders: function getAllConnectedProviders(socialInstance) {
            var _this3 = this;

            /* istanbul ignore next */
            socialInstance.get(this.$root.userStore.state.managedResource + '/' + this.$root.userStore.state.userId + '?_fields=idps/*').then(function (response) {
                _this3.connectedProviders = response.data.idps;
                _this3.providers = _this3.setProviders();
            }).catch(function (error) {
                _this3.displayNotification('error', error.response.data.message);
            });
        },
        setProviders: function setProviders() {
            var _this4 = this;

            var providers = [];
            lodash_default.a.each(this.allAvailableProviders, function (provider) {
                var matchFound = false;

                lodash_default.a.each(_this4.connectedProviders, function (idp) {
                    if (lodash_default.a.includes(idp._refResourceCollection, provider.provider)) {
                        matchFound = true;
                        providers.push(lodash_default.a.extend(idp, provider));
                    }
                });

                if (!matchFound) {
                    providers.push(provider);
                }
            });

            return providers;
        },
        showModal: function showModal(provider) {
            this.toDisconnect = lodash_default.a.find(this.providers, { 'provider': provider });
            this.$refs.disconnectModal.show();
        },
        hideModal: function hideModal() {
            this.toDisconnect = {};
            this.$refs.disconnectModal.hide();
        },
        connectProvider: function connectProvider(provider) {
            var _this5 = this;

            var socialInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });

            /* istanbul ignore next */
            socialInstance.post('/identityProviders?_action=getAuthRedirect', {
                'provider': provider,
                'landingPage': window.location.protocol + '/#/' + window.location.host + '/login?_oauthReturn=true&provider=' + provider + '&gotoURL=profile'
            }).then(function (response) {
                localStorage.setItem('linkedProvider', provider);
                localStorage.setItem('dataStoreToken', response.data.token);
                window.location.href = response.data.redirect;
            }).catch(function (error) {
                /* istanbul ignore next */
                _this5.displayNotification('error', error.response.data.message);
            });
        },
        disconnectProvider: function disconnectProvider() {
            var _this6 = this;

            /* istanbul ignore next */
            var socialInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });

            /* istanbul ignore next */
            socialInstance.post(this.$root.userStore.state.managedResource + '/' + this.$root.userStore.state.userId + '?_action=unbind&provider=' + this.toDisconnect.provider).then(function () {
                _this6.connectedProviders.splice(lodash_default.a.findIndex(_this6.connectedProviders, { 'provider': _this6.toDisconnect.provider }), 1);
                _this6.providers = _this6.setProviders();
                _this6.displayNotification('success', lodash_default.a.find(_this6.providers, { provider: _this6.toDisconnect.provider }).uiConfig.buttonDisplayName + ' has been unlinked');
                _this6.hideModal();
            }).catch(function (error) {
                _this6.displayNotification('error', _this6.$t(error.response.data.message));
                _this6.hideModal();
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7f3a48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/SocialIdentities.vue
var SocialIdentities_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.providers.length > 0)?_c('div',[_c('fr-list-group',{attrs:{"title":_vm.$t('pages.profile.socialSignIn.title'),"subtitle":_vm.$t('pages.profile.socialSignIn.subtitle')}},_vm._l((_vm.providers),function(provider,index){return _c('fr-list-item',{key:index,attrs:{"collapsible":provider._id !== undefined,"panelShown":false,"hoverItem":true}},[_c('div',{staticClass:"d-inline-flex w-100",attrs:{"slot":"list-item-header"},slot:"list-item-header"},[_c('div',{staticClass:"flex-grow-1"},[(provider.uiConfig.buttonImage)?_c('b-img',{staticClass:"mr-3",attrs:{"src":'static/' + provider.uiConfig.buttonImage,"width":"24","height":"24"}}):_c('span',{staticClass:"fr-social-icon mr-3 text-center",style:(("background: " + (provider.uiConfig.iconBackground) + "; color:" + (provider.uiConfig.iconFontColor) + ";"))},[_c('i',{class:['fa', provider.uiConfig.iconClass]})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(provider.uiConfig.buttonDisplayName))])],1),_vm._v(" "),_c('div',{staticClass:"float-right d-flex"},[_c('a',{staticClass:"align-self-center flex-grow-2 text-right",attrs:{"href":"#"}},[(provider._refResourceId)?_c('span',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.showModal(provider.provider)}}},[_vm._v(_vm._s(_vm.$t('pages.profile.socialSignIn.disconnect')))]):_c('span',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.connectProvider(provider.provider)}}},[_vm._v(_vm._s(_vm.$t('pages.profile.socialSignIn.connect')))])]),_vm._v(" "),(provider._id)?_c('div',{staticClass:"caret d-flex ml-3"},[_c('i',{staticClass:"fa fa-angle-down fa-lg pr-0 caret-down align-self-center"}),_vm._v(" "),_c('i',{staticClass:"fa fa-angle-up fa-lg pr-0 pt-1 caret-up align-self-center"})]):_vm._e()])]),_vm._v(" "),(provider._id)?_c('div',{attrs:{"slot":"list-item-collapse-body"},slot:"list-item-collapse-body"},[_c('fr-social-identity-panel',{attrs:{"provider":provider}})],1):_vm._e()])})),_vm._v(" "),_c('b-modal',{ref:"disconnectModal",attrs:{"id":"showModal","cancel-variant":"outline-secondary"}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h5',{staticClass:"modal-title align-self-center text-center"},[_vm._v(_vm._s(_vm.$t('pages.profile.socialSignIn.disconnect'))+" "+_vm._s(_vm.disconnectedProvider))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.hideModal}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('b-container',[_vm._v("\n            "+_vm._s(_vm.$t('pages.profile.socialSignIn.disconnectConfirmMsg', {provider: _vm.disconnectedProvider}))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.$t('common.form.close')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":"danger"},on:{"click":_vm.disconnectProvider}},[_vm._v(_vm._s(_vm.$t('pages.profile.socialSignIn.disconnect')))])],1)])],1)],1):_vm._e()}
var SocialIdentities_staticRenderFns = []
var SocialIdentities_esExports = { render: SocialIdentities_render, staticRenderFns: SocialIdentities_staticRenderFns }
/* harmony default export */ var profile_SocialIdentities = (SocialIdentities_esExports);
// CONCATENATED MODULE: ./src/components/profile/SocialIdentities.vue
function SocialIdentities_injectStyle (ssrContext) {
  __webpack_require__("HIiL")
}
var SocialIdentities_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var SocialIdentities___vue_template_functional__ = false
/* styles */
var SocialIdentities___vue_styles__ = SocialIdentities_injectStyle
/* scopeId */
var SocialIdentities___vue_scopeId__ = "data-v-2c7f3a48"
/* moduleIdentifier (server only) */
var SocialIdentities___vue_module_identifier__ = null
var SocialIdentities_Component = SocialIdentities_normalizeComponent(
  SocialIdentities,
  profile_SocialIdentities,
  SocialIdentities___vue_template_functional__,
  SocialIdentities___vue_styles__,
  SocialIdentities___vue_scopeId__,
  SocialIdentities___vue_module_identifier__
)

/* harmony default export */ var components_profile_SocialIdentities = (SocialIdentities_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/**
 * @description Controlling component for profile management (changing password, KBA, edit profile, social management etc.)
 *
 * @fires PATCH type/name/id (e.g. managed/user/_id) - Submits a patch object of changes for the provided resource record
 */
/* harmony default export */ var components_profile = ({
    name: 'Profile',
    props: {
        'clientToken': String,
        'linkedProvider': String,
        'openProfile': {
            required: false,
            default: false
        }
    },
    components: {
        'fr-account-controls': components_profile_AccountControls,
        'fr-account-security': components_profile_AccountSecurity,
        'fr-edit-personal-info': components_profile_EditPersonalInfo,
        'fr-preferences': components_profile_Preferences,
        'fr-trusted-devices': components_profile_TrustedDevices,
        'fr-authorized-applications': components_profile_AuthorizedApplications,
        'fr-consent': components_profile_Consent,
        'fr-social-identities': components_profile_SocialIdentities
    },
    mounted: function mounted() {
        if (this.openProfile) {
            this.$refs.editProfileButton.click();
        }
    },

    computed: {
        fullName: function fullName() {
            var fullName = '';

            if (this.$root.userStore.state.givenName.length > 0 || this.$root.userStore.state.sn.length > 0) {
                fullName = lodash_default.a.startCase(this.$root.userStore.state.givenName + ' ' + this.$root.userStore.state.sn);
            } else {
                fullName = this.$root.userStore.state.userId;
            }

            return fullName;
        },
        email: function email() {
            return this.$root.userStore.state.email;
        },
        profile: function profile() {
            return this.$root.userStore.state.profile;
        },
        schema: function schema() {
            return this.$root.userStore.state.schema;
        }
    },
    methods: {
        updateProfile: function updateProfile(payload) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.makeUpdateRequest(this.$root.userStore.state.managedResource, payload, config);
        },
        updateKBA: function updateKBA(payload, config) {
            this.makeUpdateRequest('selfservice/user', payload, config);
        },
        makeUpdateRequest: function makeUpdateRequest(endpoint, payload) {
            var _this = this;

            var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            /* istanbul ignore next */
            var successMsg = config.successMsg || this.$t('common.user.profile.updateSuccess'),
                userId = this.$root.userStore.state.userId,
                selfServiceInstance = this.getRequestService({
                headers: config.headers
            });

            /* istanbul ignore next */
            selfServiceInstance.patch(endpoint + '/' + userId, payload).then(function (response) {
                _this.$root.userStore.setProfileAction(response.data);
                _this.displayNotification('success', successMsg);

                if (config.onSuccess) {
                    config.onSuccess();
                }
            }).catch(function (error) {
                /* istanbul ignore next */
                var errorMsg = config.errorMsg || error.response.data.message;
                _this.displayNotification('error', errorMsg);

                if (config.onError) {
                    config.onError(error);
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6241bc62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/index.vue
var profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"my-5"},[_c('b-col',{staticClass:"profileCol mb-4",attrs:{"lg":"4"}},[_c('b-card',{staticClass:"text-center mb-4"},[_c('b-img',{staticClass:"m-1 mb-3",attrs:{"src":"static/images/profile-default.png","rounded":"circle","width":"112","height":"112","alt":"img"}}),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.fullName))]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),(_vm.$root.userStore.state.internalUser === false)?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.userDetailsModal",modifiers:{"userDetailsModal":true}}],ref:"editProfileButton",staticClass:"mt-4",attrs:{"variant":"primary","block":""}},[_vm._v("\n                    "+_vm._s(_vm.$t('pages.profile.editPersonalInfo'))+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('fr-edit-personal-info',{attrs:{"schema":_vm.schema,"profile":_vm.profile},on:{"updateProfile":_vm.updateProfile}})],1),_vm._v(" "),_c('b-col',{staticClass:"detailsCol",attrs:{"lg":"8"}},[_c('b-tabs',[_c('b-tab',{attrs:{"title":_vm.$t('pages.profile.settings'),"active":""}},[_c('fr-account-security',{on:{"updateProfile":_vm.updateProfile,"updateKBA":_vm.updateKBA}}),_vm._v(" "),(_vm.$root.userStore.state.internalUser === false)?_c('fr-social-identities',{attrs:{"clientToken":_vm.clientToken,"linkedProvider":_vm.linkedProvider}}):_vm._e(),_vm._v(" "),(_vm.$root.applicationStore.state.amDataEndpoints && _vm.$root.userStore.state.internalUser === false)?_c('fr-authorized-applications'):_vm._e(),_vm._v(" "),(_vm.$root.applicationStore.state.amDataEndpoints && _vm.$root.userStore.state.internalUser === false)?_c('fr-trusted-devices'):_vm._e(),_vm._v(" "),(_vm.$root.userStore.state.internalUser === false)?_c('fr-preferences',{on:{"updateProfile":_vm.updateProfile}}):_vm._e(),_vm._v(" "),(_vm.$root.userStore.state.internalUser === false)?_c('fr-consent',{attrs:{"consentedMappings":_vm.profile.consentedMappings},on:{"updateProfile":_vm.updateProfile}}):_vm._e(),_vm._v(" "),_c('fr-account-controls')],1)],1)],1)],1)],1)}
var profile_staticRenderFns = []
var profile_esExports = { render: profile_render, staticRenderFns: profile_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_profile = (profile_esExports);
// CONCATENATED MODULE: ./src/components/profile/index.vue
var profile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var profile___vue_template_functional__ = false
/* styles */
var profile___vue_styles__ = null
/* scopeId */
var profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var profile___vue_module_identifier__ = null
var profile_Component = profile_normalizeComponent(
  components_profile,
  selectortype_template_index_0_src_components_profile,
  profile___vue_template_functional__,
  profile___vue_styles__,
  profile___vue_scopeId__,
  profile___vue_module_identifier__
)

/* harmony default export */ var src_components_profile = (profile_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/concat.js
var concat = __webpack_require__("dXij");
var concat_default = /*#__PURE__*/__webpack_require__.n(concat);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/common/KBADefinitionFormGroup.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @description Common selfservice component for defining security questions
 *
 **/
/* harmony default export */ var KBADefinitionFormGroup = ({
    name: 'KBA-Definition-Form-Group',
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        'fr-floating-label-input': components_utils_FloatingLabelInput
    },
    inject: ['$validator'],
    data: function data() {
        var kba = this.selfServiceDetails.requirements.properties.kba,
            answers = lodash_default.a.times(kba.minItems, function () {
            return { answer: null, questionId: null, customQuestion: null };
        }),
            customIndex = 'custom';

        return { kba: kba, answers: answers, customIndex: customIndex };
    },

    computed: {
        predefinedQuestionOptions: function predefinedQuestionOptions() {
            var _this = this;

            return lodash_default.a.map(this.kba.questions, function (question) {
                var value = question.id,
                    text = question.question[_this.$i18n.locale] || question.question[_this.$i18n.fallbackLocale],
                    disabled = !lodash_default.a.isUndefined(lodash_default.a.find(_this.answers, { questionId: question.id }));

                return { value: value, text: text, disabled: disabled };
            });
        },
        predefinedQuestionText: function predefinedQuestionText() {
            return this.predefinedQuestionOptions.map(function (question) {
                return question.text;
            });
        },
        options: function options() {
            var placeholder = { value: null, text: this.$t('common.user.kba.selectQuestion'), disabled: true },
                customQuestionOption = { value: 'custom', text: this.$t('common.user.kba.custom'), disabled: false };

            return concat_default()(placeholder, this.predefinedQuestionOptions, customQuestionOption);
        }
    },
    methods: {
        getData: function getData() {
            var _this2 = this;

            return {
                kba: this.answers.map(function (answer) {
                    return lodash_default.a.omit(answer, answer.questionId === _this2.customIndex ? 'questionId' : 'customQuestion');
                })
            };
        },
        getDuplicates: function getDuplicates(key) {
            return lodash_default.a.clone(this.answers).map(function (answer) {
                return answer.customQuestion;
            }).filter(function (question, index) {
                return index !== key && question;
            }).concat(this.predefinedQuestionText);
        },
        isValid: function isValid() {
            /* istanbul ignore next */
            return this.$validator.validateAll();
        }
    },
    created: function created() {
        var _this3 = this;

        /* istanbul ignore next */
        this.$validator.extend('unique_question', {
            getMessage: function getMessage(field, exclusions) {
                return _this3.$t('common.user.kba.notUnique');
            },
            validate: function validate(value, exclusions) {
                var trimToLower = function trimToLower(string) {
                    return lodash_default.a.trim(lodash_default.a.toLower(string));
                };

                return !lodash_default.a.includes(lodash_default.a.map(exclusions, trimToLower), trimToLower(value));
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-342bef3f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/common/KBADefinitionFormGroup.vue
var KBADefinitionFormGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.answers),function(answer,key){return _c('b-form-group',{key:key,staticClass:"mb-0",attrs:{"label-text-align":"left"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.options},model:{value:(answer.questionId),callback:function ($$v) {_vm.$set(answer, "questionId", $$v)},expression:"answer.questionId"}}),_vm._v(" "),(answer.questionId === _vm.customIndex)?_c('fr-floating-label-input',{staticClass:"mb-3",attrs:{"type":"text","fieldName":_vm.$t('common.user.kba.question').toLowerCase() + key,"label":_vm.$t('common.user.kba.question'),"validateRules":{required: true, unique_question: _vm.getDuplicates(key)}},model:{value:(answer.customQuestion),callback:function ($$v) {_vm.$set(answer, "customQuestion", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"answer.customQuestion"}}):_vm._e(),_vm._v(" "),_c('fr-floating-label-input',{staticClass:"mb-3",attrs:{"type":"text","fieldName":_vm.$t('common.user.kba.answer').toLowerCase() + key,"label":_vm.$t('common.user.kba.answer'),"validateRules":'required'},model:{value:(answer.answer),callback:function ($$v) {_vm.$set(answer, "answer", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"answer.answer"}}),_vm._v(" "),(key !== _vm.answers.length - 1)?_c('hr'):_vm._e()],1)}))}
var KBADefinitionFormGroup_staticRenderFns = []
var KBADefinitionFormGroup_esExports = { render: KBADefinitionFormGroup_render, staticRenderFns: KBADefinitionFormGroup_staticRenderFns }
/* harmony default export */ var common_KBADefinitionFormGroup = (KBADefinitionFormGroup_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/common/KBADefinitionFormGroup.vue
var KBADefinitionFormGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var KBADefinitionFormGroup___vue_template_functional__ = false
/* styles */
var KBADefinitionFormGroup___vue_styles__ = null
/* scopeId */
var KBADefinitionFormGroup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var KBADefinitionFormGroup___vue_module_identifier__ = null
var KBADefinitionFormGroup_Component = KBADefinitionFormGroup_normalizeComponent(
  KBADefinitionFormGroup,
  common_KBADefinitionFormGroup,
  KBADefinitionFormGroup___vue_template_functional__,
  KBADefinitionFormGroup___vue_styles__,
  KBADefinitionFormGroup___vue_scopeId__,
  KBADefinitionFormGroup___vue_module_identifier__
)

/* harmony default export */ var selfservice_common_KBADefinitionFormGroup = (KBADefinitionFormGroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/progressiveprofile/KBAUpdate.vue
//
//
//
//



/**
 * @description Selfservice stage for progressive profile, handles the case where a resource is requested to change their KBA questions
 *
 **/
/* harmony default export */ var KBAUpdate = ({
    name: 'KBA-Update-Stage',
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    components: {
        'fr-kba-form-group': selfservice_common_KBADefinitionFormGroup
    },
    data: function data() {
        return {};
    },

    methods: {
        getData: function getData() {
            return this.$refs.kbaFormGroup.getData();
        },
        save: function save() {
            var _this = this;

            /* istanbul ignore next */
            this.isValid().then(function (valid) {
                if (valid) {
                    _this.$emit('advanceStage', _this.getData());
                }
            });
        },
        isValid: function isValid() {
            /* istanbul ignore next */
            return this.$refs.kbaFormGroup.isValid();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d1d9016","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/progressiveprofile/KBAUpdate.vue
var KBAUpdate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fr-kba-form-group',{ref:"kbaFormGroup",attrs:{"selfServiceDetails":_vm.selfServiceDetails}})}
var KBAUpdate_staticRenderFns = []
var KBAUpdate_esExports = { render: KBAUpdate_render, staticRenderFns: KBAUpdate_staticRenderFns }
/* harmony default export */ var progressiveprofile_KBAUpdate = (KBAUpdate_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/progressiveprofile/KBAUpdate.vue
var KBAUpdate_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var KBAUpdate___vue_template_functional__ = false
/* styles */
var KBAUpdate___vue_styles__ = null
/* scopeId */
var KBAUpdate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var KBAUpdate___vue_module_identifier__ = null
var KBAUpdate_Component = KBAUpdate_normalizeComponent(
  KBAUpdate,
  progressiveprofile_KBAUpdate,
  KBAUpdate___vue_template_functional__,
  KBAUpdate___vue_styles__,
  KBAUpdate___vue_scopeId__,
  KBAUpdate___vue_module_identifier__
)

/* harmony default export */ var selfservice_progressiveprofile_KBAUpdate = (KBAUpdate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/progressiveprofile/ConditionalUser.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * @description Selfservice stage for progressive profile, will auto generate fields based on the configuring for progressive profiling
 *
 **/
/* harmony default export */ var ConditionalUser = ({
    name: 'Conditional-User',
    components: {
        'fr-floating-label-input': components_utils_FloatingLabelInput,
        'fr-kba-update': selfservice_progressiveprofile_KBAUpdate
    },
    props: {
        selfServiceDetails: { required: true }
    },
    data: function data() {
        return {
            saveDetails: {},
            isSingleBooleanForm: false
        };
    },
    mounted: function mounted() {
        this.handleBooleanValues();
    },

    methods: {
        getData: function getData() {
            var details = lodash_default.a.clone(this.saveDetails);
            // loop over the form attributes and set empty strings to null
            lodash_default.a.each(details, function (val, key) {
                if (val === '') {
                    details[key] = null;
                }
            });

            return { attributes: details };
        },
        save: function save(advanceEmpty) {
            var _this = this;

            if (advanceEmpty === true) {
                this.$emit('advanceStage', {}, true);
            } else if (lodash_default.a.has(this.selfServiceDetails, 'requirements.terms')) {
                this.$emit('advanceStage', { accept: 'true' }, true);
            } else if (lodash_default.a.has(this.selfServiceDetails, 'requirements.properties.kba')) {
                // If this is kbaUpdate we need to validate the inputs.
                /* istanbul ignore next */
                this.$refs.kbaUpdate.isValid().then(function (valid) {
                    if (valid) {
                        _this.$emit('advanceStage', _this.$refs.kbaUpdate.getData(), true);
                    }
                });
            } else {
                this.$emit('advanceStage', this.getData(), true);
            }
        },
        handleBooleanValues: function handleBooleanValues() {
            var _this2 = this;

            /* If there is only one attribute being collected and that attribute is boolean
                we will hide the single checkbox in the checked state so when the submit button
                is clicked the attribute will be saved as true. */
            if (lodash_default.a.has(this.selfServiceDetails, 'requirements.attributes') && this.selfServiceDetails.requirements.attributes.length === 1 && lodash_default.a.filter(this.selfServiceDetails.requirements.attributes, function (prop) {
                return prop.schema.type === 'boolean';
            }).length === 1) {
                this.isSingleBooleanForm = true;
            } else {
                this.isSingleBooleanForm = false;
            }
            // Special handling here for existing boolean values
            lodash_default.a.each(this.selfServiceDetails.requirements.attributes, function (property) {
                if (_this2.isSingleBooleanForm) {
                    _this2.saveDetails[property.name] = true;
                } else if (property.schema.type === 'boolean') {
                    _this2.saveDetails[property.name] = property.value;
                }
            });
        }
    },
    watch: {
        selfServiceDetails: {
            handler: function handler(val) {
                /* When selfServiceDetails changes we know this is either
                   the first time this component is loaded or in the case
                   of multiple progressive profile forms it means we have
                   a new form and it needs to 're-initialize' itself */
                if (lodash_default.a.isEmpty(this.selfServiceDetails.requirements)) {
                    /* Empty requirements means we need to advance the stage with empty input.
                     to get back an actual set of requirements. This is needed to support multiple
                     progressiveProfile forms  */
                    this.save(true);
                } else {
                    this.saveDetails = {};
                    this.handleBooleanValues();
                }
            },

            deep: true
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7320cd93","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/progressiveprofile/ConditionalUser.vue
var ConditionalUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selfServiceDetails.requirements.uiConfig)?_c('b-form',{on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save($event)},"submit":function($event){$event.preventDefault();}}},[_vm._l((_vm.selfServiceDetails.requirements.attributes),function(property){return _c('b-form-group',{key:property.name,staticClass:"mb-0"},[(property.schema.type !== 'boolean')?_c('fr-floating-label-input',{attrs:{"fieldName":property.name,"label":property.schema.title,"validateRules":property.isRequired ? 'required' : '',"type":"text","defaultValue":property.value},model:{value:(_vm.saveDetails[property.name]),callback:function ($$v) {_vm.$set(_vm.saveDetails, property.name, (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"saveDetails[property.name]"}}):[(_vm.isSingleBooleanForm)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveDetails[property.name]),expression:"saveDetails[property.name]"}],staticClass:"d-none",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.saveDetails[property.name])?_vm._i(_vm.saveDetails[property.name],null)>-1:(_vm.saveDetails[property.name])},on:{"change":function($event){var $$a=_vm.saveDetails[property.name],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.saveDetails, property.name, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.saveDetails, property.name, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.saveDetails, property.name, $$c)}}}})]):_c('div',{staticClass:"custom-control custom-checkbox mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveDetails[property.name]),expression:"saveDetails[property.name]"}],ref:property.name,refInFor:true,staticClass:"custom-control-input",attrs:{"type":"checkbox","id":property.name},domProps:{"checked":Array.isArray(_vm.saveDetails[property.name])?_vm._i(_vm.saveDetails[property.name],null)>-1:(_vm.saveDetails[property.name])},on:{"change":function($event){var $$a=_vm.saveDetails[property.name],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.saveDetails, property.name, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.saveDetails, property.name, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.saveDetails, property.name, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":property.name}},[_vm._v(_vm._s(property.schema.title || property.schema.description))])])]],2)}),_vm._v(" "),(_vm.selfServiceDetails.requirements.terms)?_c('div',{staticClass:"mb-4 bg-light p-3 border border-light rounded text-left tc-scrolling-display",domProps:{"innerHTML":_vm._s(_vm.selfServiceDetails.requirements.terms)}}):_vm._e(),_vm._v(" "),(_vm.selfServiceDetails.requirements.definitions)?_c('fr-kba-update',{ref:"kbaUpdate",attrs:{"selfServiceDetails":_vm.selfServiceDetails}}):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"mt-1",attrs:{"block":true,"variant":"primary"},on:{"click":_vm.save}},[_vm._v("\n        "+_vm._s(_vm.selfServiceDetails.requirements.uiConfig.buttonText)+"\n    ")])],2):_vm._e()}
var ConditionalUser_staticRenderFns = []
var ConditionalUser_esExports = { render: ConditionalUser_render, staticRenderFns: ConditionalUser_staticRenderFns }
/* harmony default export */ var progressiveprofile_ConditionalUser = (ConditionalUser_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/progressiveprofile/ConditionalUser.vue
function ConditionalUser_injectStyle (ssrContext) {
  __webpack_require__("rBbn")
}
var ConditionalUser_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ConditionalUser___vue_template_functional__ = false
/* styles */
var ConditionalUser___vue_styles__ = ConditionalUser_injectStyle
/* scopeId */
var ConditionalUser___vue_scopeId__ = "data-v-7320cd93"
/* moduleIdentifier (server only) */
var ConditionalUser___vue_module_identifier__ = null
var ConditionalUser_Component = ConditionalUser_normalizeComponent(
  ConditionalUser,
  progressiveprofile_ConditionalUser,
  ConditionalUser___vue_template_functional__,
  ConditionalUser___vue_styles__,
  ConditionalUser___vue_scopeId__,
  ConditionalUser___vue_module_identifier__
)

/* harmony default export */ var selfservice_progressiveprofile_ConditionalUser = (ConditionalUser_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/progressiveprofile/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/**
 * @description Selfservice controlling component for resource progressive profiling. Makes use of selfservice-profile.json config file.
 *
 * @mixin - selfservice/mixins/SelfserviceAPIMixin.vue
 *
 * @fires POST authentication?_action=login - Since progressive profiling creates a partial session, once it is complete we call login again with the
 * original JWT to continue the authentication session
 */
/* harmony default export */ var progressiveprofile = ({
    name: 'Progressive-Profile',
    components: {
        'bounce-loader': vue_spinner_min["BounceLoader"],
        'fr-center-card': components_utils_CenterCard,
        conditionaluser: selfservice_progressiveprofile_ConditionalUser
    },
    mixins: [mixins_SelfserviceAPIMixin],
    data: function data() {
        return {
            selfServiceType: null,
            selfServiceDetails: null,
            loadingColor: main_default.a.baseColor,
            apiType: null,
            purpose: null,
            displayName: null,
            showForm: false
        };
    },
    mounted: function mounted() {
        /* istanbul ignore next */
        this.apiType = this.$route.params.profileProcess;
        /* istanbul ignore next */
        this.loadData();
    },

    methods: {
        setChildComponent: function setChildComponent(type, details) {
            this.selfServiceDetails = details;
            this.selfServiceType = type;

            if (lodash_default.a.isEmpty(details.requirements) && details.tag === 'initial') {
                this.advanceStage({
                    'input': {}
                });
            } else if (lodash_default.a.has(details, 'requirements.uiConfig')) {
                this.showForm = true;
                this.displayName = details.requirements.uiConfig.displayName;
                this.purpose = details.requirements.uiConfig.purpose;
                // Can skip the stage by default
                this.selfServiceDetails.canSkip = true;
                /* If there are any kba questions, terms and conditions,
                   or required attributes the stage cannot be skipped */
                if (lodash_default.a.has(details, 'requirements.properties.kba') || lodash_default.a.has(details, 'requirements.terms') || lodash_default.a.has(details.requirements, 'attributes') && lodash_default.a.filter(details.requirements.attributes, { isRequired: true }).length >= 1) {
                    this.selfServiceDetails.canSkip = false;
                }
            } else if (details.tag === 'end' && details.status.success) {
                this.showForm = false;
                /* istanbul ignore next */
                this.setUser();
            }
        },
        apiErrorCallback: function apiErrorCallback(error) {
            /* istanbul ignore next */
            this.displayNotification('error', error.response.data.message);
            /* istanbul ignore next */
            this.loadData();
        },
        setUser: function setUser() {
            var _this = this;

            /* istanbul ignore next */
            var loginServiceInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });
            /* istanbul ignore next */
            loginServiceInstance.post('/authentication?_action=login').then(function (userDetails) {
                // Check for progressive profiling.
                _this.progressiveProfileCheck(userDetails, function () {
                    /* istanbul ignore next */
                    axios_default.a.all([loginServiceInstance.get(userDetails.data.authorization.component + '/' + userDetails.data.authorization.id), loginServiceInstance.post('privilege?_action=listPrivileges'), loginServiceInstance.get('schema/' + userDetails.data.authorization.component)]).then(axios_default.a.spread(function (profile, privilege, schema) {
                        _this.$root.userStore.setProfileAction(profile.data);
                        _this.$root.userStore.setSchemaAction(schema.data);
                        _this.$root.userStore.setAccess(privilege.data);

                        _this.completeLogin();
                    })).catch(function (error) {
                        /* istanbul ignore next */
                        _this.displayNotification('error', error.response.data.message);
                    });
                }, true);
            }).catch(function (error) {
                /* istanbul ignore next */
                _this.displayNotification('error', error.response.data.message);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7342d1d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/progressiveprofile/index.vue
var progressiveprofile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showForm)?_c('fr-center-card',{attrs:{"showLogo":true}},[_c('div',{attrs:{"slot":"center-card-header"},slot:"center-card-header"},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.displayName))])]),_vm._v(" "),_c('b-card-body',{attrs:{"slot":"center-card-body"},slot:"center-card-body"},[_c('p',{staticClass:"text-center mb-4"},[_vm._v("\n            "+_vm._s(_vm.purpose)+"\n        ")]),_vm._v(" "),_c(_vm.selfServiceType,{ref:"selfServiceStage",tag:"component",attrs:{"selfServiceDetails":_vm.selfServiceDetails,"apiType":_vm.apiType},on:{"advanceStage":_vm.advanceStage}})],1),_vm._v(" "),(_vm.selfServiceDetails !== null && _vm.selfServiceDetails.canSkip)?_c('b-card-footer',{attrs:{"slot":"center-card-footer"},slot:"center-card-footer"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.advanceStage({}, true)}}},[_vm._v("\n            "+_vm._s(_vm.$t('pages.selfservice.progressiveProfile.skipThis'))+"\n        ")])]):_vm._e()],1):_c('b-container',{staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"m-auto fr-center-card"},[_c('bounce-loader',{attrs:{"color":_vm.loadingColor}})],1)])])}
var progressiveprofile_staticRenderFns = []
var progressiveprofile_esExports = { render: progressiveprofile_render, staticRenderFns: progressiveprofile_staticRenderFns }
/* harmony default export */ var selfservice_progressiveprofile = (progressiveprofile_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/progressiveprofile/index.vue
var progressiveprofile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var progressiveprofile___vue_template_functional__ = false
/* styles */
var progressiveprofile___vue_styles__ = null
/* scopeId */
var progressiveprofile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var progressiveprofile___vue_module_identifier__ = null
var progressiveprofile_Component = progressiveprofile_normalizeComponent(
  progressiveprofile,
  selfservice_progressiveprofile,
  progressiveprofile___vue_template_functional__,
  progressiveprofile___vue_styles__,
  progressiveprofile___vue_scopeId__,
  progressiveprofile___vue_module_identifier__
)

/* harmony default export */ var components_selfservice_progressiveprofile = (progressiveprofile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/registration/UserDetails.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 * @description Selfservice stage for generating user details and displaying social buttons available. Works the same alone and in allinone
 *
 **/
/* harmony default export */ var UserDetails = ({
    name: 'User-Details',
    components: {
        'fr-floating-label-input': components_utils_FloatingLabelInput,
        'fr-policy-password-input': components_utils_PolicyPasswordInput,
        'fr-social-buttons': components_utils_SocialButtons
    },
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    data: function data() {
        var data = {
            userDetails: {},
            saveDetails: {},
            userPreferences: {},
            isSocialReg: lodash_default.a.get(this.selfServiceDetails, 'tag') !== 'initial'
        };

        if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.registrationProperties) {
            data.userDetails = this.selfServiceDetails.requirements.registrationProperties.properties;

            if (lodash_default.a.has(this.selfServiceDetails, 'requirements.properties.user.default') && !lodash_default.a.isUndefined(this.selfServiceDetails, 'requirements.properties.user.default')) {
                lodash_default.a.each(this.selfServiceDetails.requirements.properties.user.default, function (value, key) {
                    data.userDetails[key].socialValue = value;
                });
            }

            lodash_default.a.each(this.selfServiceDetails.requirements.registrationProperties.required, function (prop) {
                data.userDetails[prop].required = true;
            });

            lodash_default.a.each(this.selfServiceDetails.requirements.registrationProperties.properties, function (value, key) {
                data.saveDetails[key] = '';
            });
        }

        if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.registrationPreferences) {
            data.saveDetails.preferences = {};
            data.userPreferences = this.selfServiceDetails.requirements.registrationPreferences;

            lodash_default.a.each(data.userPreferences, function (value, key) {
                data.saveDetails.preferences[key] = false;
            });
        }

        data.saveDetails.password = '';

        return data;
    },

    methods: {
        getData: function getData() {
            var details = lodash_default.a.clone(this.saveDetails);

            delete details.confirmPassword;

            if (this.isSocialReg) {
                delete details.password;
            }

            return {
                user: details
            };
        },


        // Add additional frontend checks for field validation here
        calculateValidation: function calculateValidation(property) {
            var validators = [];

            if (property.required) {
                validators.push('required');
            }

            if (property.policies) {
                // Add policy vee validators correlations here
                lodash_default.a.each(property.policies, function (policy) {
                    if (policy.policyId === 'valid-email-address-format') {
                        validators.push('email');
                    }
                });
            }

            return validators.join('|');
        },
        save: function save() {
            var _this = this;

            // Need to ignore this validation because it does not preform in testing due to vue validate
            /* istanbul ignore next */
            this.isValid().then(function (valid) {
                if (valid) {
                    _this.$emit('advanceStage', _this.getData());
                } else {
                    _this.displayNotification('error', _this.$t('pages.selfservice.registration.pleaseComplete'));
                }
            });
        },
        isValid: function isValid() {
            /* istanbul ignore next */
            return this.$validator.validateAll();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7861c754","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/registration/UserDetails.vue
var UserDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',[(!_vm.isSocialReg)?_c('fr-social-buttons',{attrs:{"signin":false}}):_vm._e(),_vm._v(" "),_vm._l((_vm.userDetails),function(property,key){return _c('b-form-group',{key:key,staticClass:"mb-0"},[_c('fr-floating-label-input',{attrs:{"defaultValue":property.socialValue,"fieldName":key,"label":property.description,"validateRules":_vm.calculateValidation(property),"type":"text"},model:{value:(_vm.saveDetails[key]),callback:function ($$v) {_vm.$set(_vm.saveDetails, key, $$v)},expression:"saveDetails[key]"}})],1)}),_vm._v(" "),(!_vm.isSocialReg)?_c('fr-policy-password-input',{attrs:{"policyApi":"selfservice/registration","name":"password"},model:{value:(_vm.saveDetails.password),callback:function ($$v) {_vm.$set(_vm.saveDetails, "password", $$v)},expression:"saveDetails.password"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group mb-4"},_vm._l((_vm.userPreferences),function(preference,key){return _c('div',{key:key,staticClass:"custom-control custom-checkbox mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveDetails.preferences[key]),expression:"saveDetails.preferences[key]"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":key},domProps:{"checked":Array.isArray(_vm.saveDetails.preferences[key])?_vm._i(_vm.saveDetails.preferences[key],null)>-1:(_vm.saveDetails.preferences[key])},on:{"change":function($event){var $$a=_vm.saveDetails.preferences[key],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.saveDetails.preferences, key, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.saveDetails.preferences, key, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.saveDetails.preferences, key, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":key}},[_vm._v(_vm._s(preference.description))])])})),_vm._v(" "),(_vm.inline === false)?_c('b-button',{attrs:{"block":true,"size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("\n        "+_vm._s(_vm.$t("common.form.signUp"))+"\n    ")]):_vm._e()],2)}
var UserDetails_staticRenderFns = []
var UserDetails_esExports = { render: UserDetails_render, staticRenderFns: UserDetails_staticRenderFns }
/* harmony default export */ var registration_UserDetails = (UserDetails_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/registration/UserDetails.vue
function UserDetails_injectStyle (ssrContext) {
  __webpack_require__("Jm7l")
}
var UserDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var UserDetails___vue_template_functional__ = false
/* styles */
var UserDetails___vue_styles__ = UserDetails_injectStyle
/* scopeId */
var UserDetails___vue_scopeId__ = "data-v-7861c754"
/* moduleIdentifier (server only) */
var UserDetails___vue_module_identifier__ = null
var UserDetails_Component = UserDetails_normalizeComponent(
  UserDetails,
  registration_UserDetails,
  UserDetails___vue_template_functional__,
  UserDetails___vue_styles__,
  UserDetails___vue_scopeId__,
  UserDetails___vue_module_identifier__
)

/* harmony default export */ var selfservice_registration_UserDetails = (UserDetails_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/utils/HorizontalRule.vue
//
//
//
//
//
//
//
//

/**
 * @description Component for making a horizontal rule line with text in the middle
 *
 **/
/* harmony default export */ var HorizontalRule = ({
  name: 'Horizontal-Rule',
  props: ['insert']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6949036b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/HorizontalRule.vue
var HorizontalRule_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-auto pt-1",domProps:{"innerHTML":_vm._s(_vm.insert)}},[_vm._v(_vm._s(_vm.insert))]),_vm._v(" "),_vm._m(1)])}
var HorizontalRule_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col pr-0"},[_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col pl-0"},[_c('hr')])}]
var HorizontalRule_esExports = { render: HorizontalRule_render, staticRenderFns: HorizontalRule_staticRenderFns }
/* harmony default export */ var utils_HorizontalRule = (HorizontalRule_esExports);
// CONCATENATED MODULE: ./src/components/utils/HorizontalRule.vue
function HorizontalRule_injectStyle (ssrContext) {
  __webpack_require__("Ka38")
}
var HorizontalRule_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var HorizontalRule___vue_template_functional__ = false
/* styles */
var HorizontalRule___vue_styles__ = HorizontalRule_injectStyle
/* scopeId */
var HorizontalRule___vue_scopeId__ = "data-v-6949036b"
/* moduleIdentifier (server only) */
var HorizontalRule___vue_module_identifier__ = null
var HorizontalRule_Component = HorizontalRule_normalizeComponent(
  HorizontalRule,
  utils_HorizontalRule,
  HorizontalRule___vue_template_functional__,
  HorizontalRule___vue_styles__,
  HorizontalRule___vue_scopeId__,
  HorizontalRule___vue_module_identifier__
)

/* harmony default export */ var components_utils_HorizontalRule = (HorizontalRule_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/registration/KBASecurityAnswerDefinitionStage.vue
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @description Selfservice stage that handles the initial KBA during registration functions the same in allinone
 *
 **/
/* harmony default export */ var KBASecurityAnswerDefinitionStage = ({
    name: 'KBA-Security-Answer-Definition-Stage',
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    components: {
        'fr-horizontal-rule': components_utils_HorizontalRule,
        'fr-kba-form-group': selfservice_common_KBADefinitionFormGroup
    },
    data: function data() {
        return {};
    },

    methods: {
        getData: function getData() {
            return this.$refs.kbaFormGroup.getData();
        },
        save: function save() {
            var _this = this;

            /* istanbul ignore next */
            this.isValid().then(function (valid) {
                if (valid) {
                    _this.$emit('advanceStage', _this.getData());
                }
            });
        },
        isValid: function isValid() {
            /* istanbul ignore next */
            return this.$refs.kbaFormGroup.isValid();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25fa52d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/registration/KBASecurityAnswerDefinitionStage.vue
var KBASecurityAnswerDefinitionStage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{staticClass:"mb-4",attrs:{"id":"kbaDefinition"},on:{"submit":function($event){$event.preventDefault();}}},[(_vm.inline)?_c('fr-horizontal-rule',{attrs:{"insert":"<i class='fa fa-lock'></i>"}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('common.user.kba.description')))]),_vm._v(" "),_c('fr-kba-form-group',{ref:"kbaFormGroup",attrs:{"selfServiceDetails":_vm.selfServiceDetails}}),_vm._v(" "),(!_vm.inline)?_c('b-button',{attrs:{"block":true,"size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t("pages.selfservice.registration.completeRegistration")))]):_vm._e()],1)}
var KBASecurityAnswerDefinitionStage_staticRenderFns = []
var KBASecurityAnswerDefinitionStage_esExports = { render: KBASecurityAnswerDefinitionStage_render, staticRenderFns: KBASecurityAnswerDefinitionStage_staticRenderFns }
/* harmony default export */ var registration_KBASecurityAnswerDefinitionStage = (KBASecurityAnswerDefinitionStage_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/registration/KBASecurityAnswerDefinitionStage.vue
function KBASecurityAnswerDefinitionStage_injectStyle (ssrContext) {
  __webpack_require__("pw9W")
}
var KBASecurityAnswerDefinitionStage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var KBASecurityAnswerDefinitionStage___vue_template_functional__ = false
/* styles */
var KBASecurityAnswerDefinitionStage___vue_styles__ = KBASecurityAnswerDefinitionStage_injectStyle
/* scopeId */
var KBASecurityAnswerDefinitionStage___vue_scopeId__ = "data-v-25fa52d4"
/* moduleIdentifier (server only) */
var KBASecurityAnswerDefinitionStage___vue_module_identifier__ = null
var KBASecurityAnswerDefinitionStage_Component = KBASecurityAnswerDefinitionStage_normalizeComponent(
  KBASecurityAnswerDefinitionStage,
  registration_KBASecurityAnswerDefinitionStage,
  KBASecurityAnswerDefinitionStage___vue_template_functional__,
  KBASecurityAnswerDefinitionStage___vue_styles__,
  KBASecurityAnswerDefinitionStage___vue_scopeId__,
  KBASecurityAnswerDefinitionStage___vue_module_identifier__
)

/* harmony default export */ var selfservice_registration_KBASecurityAnswerDefinitionStage = (KBASecurityAnswerDefinitionStage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/registration/TermsAndConditions.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Selfservice stage for terms and conditions depending on all in one displays as a dialog or inline text depending at allinone
 *
 **/
/* harmony default export */ var TermsAndConditions = ({
    name: 'Terms-And-Conditions',
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    methods: {
        getData: function getData() {
            return {
                accept: 'true'
            };
        },
        save: function save() {
            this.$emit('advanceStage', this.getData());
        },
        isValid: function isValid() {
            return promise_default.a.resolve(true);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1a72f4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/registration/TermsAndConditions.vue
var TermsAndConditions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inline)?_c('div',[_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n        "+_vm._s(_vm.$t("pages.selfservice.registration.termsAndConditions.singlePage"))+" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('termsModal'),expression:"'termsModal'"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(_vm._s(_vm.$t("pages.selfservice.registration.termsAndConditions.title")))]),_vm._v(".\n    ")]),_vm._v(" "),_c('b-modal',{attrs:{"id":"termsModal","hide-footer":"","title":_vm.$t('pages.selfservice.registration.termsAndConditions.title')}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v(_vm._s(_vm.selfServiceDetails.requirements.terms))])])])],1):_c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("pages.selfservice.registration.termsAndConditions.title")))]),_vm._v(" "),_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v(_vm._s(_vm.selfServiceDetails.requirements.terms))])]),_vm._v(" "),(_vm.inline === false)?_c('b-button',{attrs:{"block":true,"size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("\n        "+_vm._s(_vm.$t("common.form.agree"))+"\n    ")]):_vm._e()],1)}
var TermsAndConditions_staticRenderFns = []
var TermsAndConditions_esExports = { render: TermsAndConditions_render, staticRenderFns: TermsAndConditions_staticRenderFns }
/* harmony default export */ var registration_TermsAndConditions = (TermsAndConditions_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/registration/TermsAndConditions.vue
function TermsAndConditions_injectStyle (ssrContext) {
  __webpack_require__("DX21")
}
var TermsAndConditions_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var TermsAndConditions___vue_template_functional__ = false
/* styles */
var TermsAndConditions___vue_styles__ = TermsAndConditions_injectStyle
/* scopeId */
var TermsAndConditions___vue_scopeId__ = "data-v-e1a72f4a"
/* moduleIdentifier (server only) */
var TermsAndConditions___vue_module_identifier__ = null
var TermsAndConditions_Component = TermsAndConditions_normalizeComponent(
  TermsAndConditions,
  registration_TermsAndConditions,
  TermsAndConditions___vue_template_functional__,
  TermsAndConditions___vue_styles__,
  TermsAndConditions___vue_scopeId__,
  TermsAndConditions___vue_module_identifier__
)

/* harmony default export */ var selfservice_registration_TermsAndConditions = (TermsAndConditions_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/registration/Consent.vue

//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Selfservice stage for consent depending on all in one displays as a dialog or a basic page text display
 *
 **/
/* harmony default export */ var registration_Consent = ({
    name: 'Consent',
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    methods: {
        getData: function getData() {
            return {
                consentGiven: 'true'
            };
        },
        save: function save() {
            this.$emit('advanceStage', this.getData());
        },
        isValid: function isValid() {
            return promise_default.a.resolve(true);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ca85712","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/registration/Consent.vue
var registration_Consent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.inline === false)?_c('h3',[_vm._v(_vm._s(_vm.$t("pages.selfservice.registration.consent.title")))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v(_vm._s(_vm.selfServiceDetails.requirements.consent))])]),_vm._v(" "),(_vm.inline === false)?_c('b-button',{attrs:{"block":true,"size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("\n        "+_vm._s(_vm.$t("common.form.agree"))+"\n    ")]):_vm._e()],1)}
var registration_Consent_staticRenderFns = []
var registration_Consent_esExports = { render: registration_Consent_render, staticRenderFns: registration_Consent_staticRenderFns }
/* harmony default export */ var selfservice_registration_Consent = (registration_Consent_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/registration/Consent.vue
function Consent_injectStyle (ssrContext) {
  __webpack_require__("lC5l")
}
var registration_Consent_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var registration_Consent___vue_template_functional__ = false
/* styles */
var registration_Consent___vue_styles__ = Consent_injectStyle
/* scopeId */
var registration_Consent___vue_scopeId__ = "data-v-0ca85712"
/* moduleIdentifier (server only) */
var registration_Consent___vue_module_identifier__ = null
var registration_Consent_Component = registration_Consent_normalizeComponent(
  registration_Consent,
  selfservice_registration_Consent,
  registration_Consent___vue_template_functional__,
  registration_Consent___vue_styles__,
  registration_Consent___vue_scopeId__,
  registration_Consent___vue_module_identifier__
)

/* harmony default export */ var components_selfservice_registration_Consent = (registration_Consent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/registration/AllInOneRegistration.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/**
 * @description Selfservice stage that is used for combing multiple selfservice stages (User details, Captcha, KBA, Terms and Confitions and Consent)
 *
 **/
/* harmony default export */ var AllInOneRegistration = ({
    name: 'All-In-One-Registration',
    props: {
        selfServiceDetails: { required: true }
    },
    components: {
        idmUserDetails: selfservice_registration_UserDetails,
        kbaSecurityAnswerDefinitionStage: selfservice_registration_KBASecurityAnswerDefinitionStage,
        TermsAndConditions: selfservice_registration_TermsAndConditions,
        Consent: components_selfservice_registration_Consent,
        Captcha: selfservice_common_Captcha,
        'fr-loading-button': components_utils_LoadingButton
    },
    data: function data() {
        var data = {
            stages: {},
            consentCheck: true,
            loading: false
        };

        lodash_default.a.each(this.selfServiceDetails.requirements.stages, function (name) {
            data.stages[name] = true;
        });

        return data;
    },

    methods: {
        getData: function getData() {
            var data = {};

            /* istanbul ignore next */
            lodash_default.a.each(this.$children, function (child) {
                var childData = {};

                if (child.getData) {
                    childData = child.getData();
                }

                data = lodash_default.a.merge(data, childData);
            });

            if (this.selfServiceDetails.requirements.consentEnabled) {
                data.consentGiven = 'true';
            }

            return data;
        },
        saveCheck: function saveCheck() {
            var _this = this;

            this.loading = true;

            if (this.selfServiceDetails.requirements.consentEnabled) {
                this.isValid().then(function () {
                    _this.$refs.consentModal.show();
                });
            } else {
                /* istanbul ignore next */
                this.isValid().then(function () {
                    _this.save();
                });
            }
        },
        save: function save() {
            this.$emit('advanceStage', this.getData());
            this.loading = false;
        },
        isValid: function isValid() {
            var _this2 = this;

            var childChecks = [],
                validPromise = new promise_default.a(function (resolve, reject) {
                if (_this2.$children) {
                    lodash_default.a.each(_this2.$children, function (child, index) {
                        /* istanbul ignore next */
                        if (_this2.$children[index].isValid) {
                            childChecks.push(_this2.$children[index].isValid());
                        }
                    });
                }

                promise_default.a.all(childChecks).then(function (results) {
                    var validCheck = true;

                    lodash_default.a.each(results, function (check) {
                        /* istanbul ignore next */
                        if (check === false) {
                            validCheck = false;
                        }
                    });

                    if (validCheck) {
                        resolve({ 'success': true });
                    } else {
                        _this2.displayNotification('error', _this2.$t('pages.selfservice.registration.pleaseComplete'));
                        _this2.loading = false;
                    }
                });
            });

            return validPromise;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9fd5ba8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/registration/AllInOneRegistration.vue
var AllInOneRegistration_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fr-all-in-one-container"},[(_vm.stages.idmUserDetails)?_c('idmUserDetails',{attrs:{"inline":true,"selfServiceDetails":_vm.selfServiceDetails}}):_vm._e(),_vm._v(" "),(_vm.stages.kbaSecurityAnswerDefinitionStage)?_c('kbaSecurityAnswerDefinitionStage',{attrs:{"inline":true,"selfServiceDetails":_vm.selfServiceDetails}}):_vm._e(),_vm._v(" "),(_vm.stages.captcha)?_c('Captcha',{attrs:{"self-service-details":_vm.selfServiceDetails}}):_vm._e(),_vm._v(" "),(_vm.stages.consent && _vm.selfServiceDetails.requirements && _vm.selfServiceDetails.requirements.consent)?[_c('b-modal',{ref:"consentModal",attrs:{"title":_vm.$t('pages.selfservice.registration.consent.title')},on:{"hide":function($event){_vm.loading = false;}}},[_c('Consent',{attrs:{"inline":true,"selfServiceDetails":_vm.selfServiceDetails}}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"plain":"","value":false,"unchecked-value":true},model:{value:(_vm.consentCheck),callback:function ($$v) {_vm.consentCheck=$$v},expression:"consentCheck"}},[_vm._v("\n                "+_vm._s(_vm.$t("pages.selfservice.registration.consent.agreement"))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"disabled":_vm.consentCheck,"size":"sm","variant":"primary"},on:{"click":_vm.save}},[_vm._v("\n                    "+_vm._s(_vm.$t("common.form.okay"))+"\n                ")])],1)],1)]:_vm._e(),_vm._v(" "),_c('fr-loading-button',{staticClass:"mt-2 mb-3 btn-lg btn-block",attrs:{"type":"button","variant":"primary","label":_vm.$t('common.form.signUp'),"loading":_vm.loading,"large":true},on:{"click":_vm.saveCheck}}),_vm._v(" "),(_vm.stages.termsAndConditions && _vm.selfServiceDetails.requirements && _vm.selfServiceDetails.requirements.terms)?_c('TermsAndConditions',{attrs:{"inline":true,"selfServiceDetails":_vm.selfServiceDetails}}):_vm._e()],2)}
var AllInOneRegistration_staticRenderFns = []
var AllInOneRegistration_esExports = { render: AllInOneRegistration_render, staticRenderFns: AllInOneRegistration_staticRenderFns }
/* harmony default export */ var registration_AllInOneRegistration = (AllInOneRegistration_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/registration/AllInOneRegistration.vue
function AllInOneRegistration_injectStyle (ssrContext) {
  __webpack_require__("xIO3")
}
var AllInOneRegistration_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var AllInOneRegistration___vue_template_functional__ = false
/* styles */
var AllInOneRegistration___vue_styles__ = AllInOneRegistration_injectStyle
/* scopeId */
var AllInOneRegistration___vue_scopeId__ = "data-v-a9fd5ba8"
/* moduleIdentifier (server only) */
var AllInOneRegistration___vue_module_identifier__ = null
var AllInOneRegistration_Component = AllInOneRegistration_normalizeComponent(
  AllInOneRegistration,
  registration_AllInOneRegistration,
  AllInOneRegistration___vue_template_functional__,
  AllInOneRegistration___vue_styles__,
  AllInOneRegistration___vue_scopeId__,
  AllInOneRegistration___vue_module_identifier__
)

/* harmony default export */ var selfservice_registration_AllInOneRegistration = (AllInOneRegistration_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/registration/EmailValidation.vue
//
//
//
//
//
//

/**
 * @description Stage ofr handling email validation
 *
 **/
/* harmony default export */ var registration_EmailValidation = ({
  name: 'Email-Validation'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f85d1dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/registration/EmailValidation.vue
var registration_EmailValidation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":""}},[_vm._v("\n    "+_vm._s(_vm.$t('pages.selfservice.registration.emailValidation'))+"\n")])}
var registration_EmailValidation_staticRenderFns = []
var registration_EmailValidation_esExports = { render: registration_EmailValidation_render, staticRenderFns: registration_EmailValidation_staticRenderFns }
/* harmony default export */ var selfservice_registration_EmailValidation = (registration_EmailValidation_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/registration/EmailValidation.vue
var registration_EmailValidation_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var registration_EmailValidation___vue_template_functional__ = false
/* styles */
var registration_EmailValidation___vue_styles__ = null
/* scopeId */
var registration_EmailValidation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var registration_EmailValidation___vue_module_identifier__ = null
var registration_EmailValidation_Component = registration_EmailValidation_normalizeComponent(
  registration_EmailValidation,
  selfservice_registration_EmailValidation,
  registration_EmailValidation___vue_template_functional__,
  registration_EmailValidation___vue_styles__,
  registration_EmailValidation___vue_scopeId__,
  registration_EmailValidation___vue_module_identifier__
)

/* harmony default export */ var components_selfservice_registration_EmailValidation = (registration_EmailValidation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selfservice/registration/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var customTitleComponents = ['captcha', 'consent', 'emailValidation', 'kbaSecurityAnswerDefinitionStage', 'termsAndConditions'];

/**
 * @description Selfservice controlling component for registering a resource (e.g. a new user). Makes use of selfservice-registration.json config file.
 *
 * @mixin - selfservice/mixins/SelfserviceAPIMixin.vue
 *
 * @fires POST authentication?_action=login - Uses localAutoLogin stage that sets a JWT after a successful registration to start a user session.
 * Alternatively if registration came through social, login will use the data store token to go forward with login after a successful registration.
 * @fires POST authentication?_action=logout - Ends current user session
 */
/* harmony default export */ var registration = ({
    name: 'Registration',
    components: {
        'fr-center-card': components_utils_CenterCard,
        AllInOneRegistration: selfservice_registration_AllInOneRegistration,
        BounceLoader: vue_spinner_min["BounceLoader"],
        Captcha: selfservice_common_Captcha,
        Consent: components_selfservice_registration_Consent,
        emailValidation: components_selfservice_registration_EmailValidation,
        idmUserDetails: selfservice_registration_UserDetails,
        kbaSecurityAnswerDefinitionStage: selfservice_registration_KBASecurityAnswerDefinitionStage,
        TermsAndConditions: selfservice_registration_TermsAndConditions,
        GenericSelfService: selfservice_common_GenericSelfService
    },
    props: ['clientToken'],
    mixins: [mixins_SelfserviceAPIMixin],
    data: function data() {
        return {
            selfServiceType: null,
            selfServiceDetails: null,
            loadingColor: main_default.a.baseColor,
            showSelfService: false,
            apiType: 'registration',
            clientTokenUsed: false
        };
    },

    computed: {
        title: function title() {
            if (lodash_default.a.includes(customTitleComponents, this.selfServiceType)) {
                return this.$t('pages.selfservice.registration.stageTitle.' + this.selfServiceType);
            } else {
                return this.$t('pages.selfservice.registration.signUp');
            }
        },
        subtitle: function subtitle() {
            if (lodash_default.a.includes(customTitleComponents, this.selfServiceType)) {
                return this.$t('pages.selfservice.registration.stageSubtitle.' + this.selfServiceType);
            } else {
                return this.$t('pages.selfservice.registration.signUpMsg');
            }
        }
    },
    mounted: function mounted() {
        if (this.$route.params.queryParams) {
            /* istanbul ignore next */
            // queryParams come from the link emailed to the user for the emailValidation stage
            // This stops the flicker by hiding everything in the center-card
            this.selfServiceType = 'localAutoLogin';
            this.advanceStage(this.parseQueryParams(this.$route.params.queryParams));
        } else {
            this.loadData();
        }
    },

    methods: {
        setChildComponent: function setChildComponent(type, details) {
            var _this = this;

            this.selfServiceDetails = details;

            if (type === 'parameters') {
                this.selfServiceType = null;
                this.showSelfService = false;

                this.advanceStage({
                    'input': {}
                });
            } else if (this.clientToken && !this.clientTokenUsed) {
                this.advanceStage({
                    'clientToken': this.clientToken,
                    'oauthRegister': 'true'
                });
                this.clientTokenUsed = true;
            } else if (details.type === 'localAutoLogin') {
                if (lodash_default.a.has(details, 'additions.oauthLogin') && details.additions.oauthLogin) {
                    /* istanbul ignore next */
                    var socialLoginInstance = this.getRequestService({
                        headers: {
                            'X-OpenIDM-NoSession': 'false',
                            'X-OpenIDM-OAuth-Login': 'true',
                            'X-OpenIDM-DataStoreToken': this.clientToken,
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    });

                    /* istanbul ignore next */
                    socialLoginInstance.post('/authentication?_action=login').then(function (userDetails) {
                        _this.displayNotification('success', _this.$t('pages.selfservice.registration.createdAccount'));

                        if (details.additions.successUrl && details.additions.successUrl.length > 0) {
                            window.location = details.additions.successUrl;
                        } else {
                            _this.progressiveProfileCheck(userDetails, function () {
                                window.history.pushState('', '', window.location.pathname);
                                _this.$router.push('/');
                            });
                        }
                    }).catch(function () {
                        window.history.pushState('', '', window.location.pathname);
                        _this.$router.push('/login');
                    });
                } else {
                    this.autoLogin(details.additions.credentialJwt, details.additions.successUrl);
                }
            } else if (type === 'openAMAutoLogin' && details.status) {
                if (lodash_default.a.has(details, 'additions.successUrl')) {
                    // If there is a provided success url then follow it.
                    /* istanbul ignore next */
                    window.location.href = details.additions.successUrl;
                } else {
                    // Otherwise, redirect to login and send success notification.
                    this.$router.push('/login');
                    /* istanbul ignore next */
                    this.displayNotification('success', this.$t('pages.selfservice.registration.createdAccount'));
                }
            } else {
                var stageCheck = false;

                lodash_default.a.each(this.$options.components, function (value, key) {
                    if (lodash_default.a.toLower(key) === lodash_default.a.toLower(type)) {
                        stageCheck = true;
                    }
                });

                if (stageCheck) {
                    this.selfServiceType = type;
                } else {
                    this.selfServiceType = 'GenericSelfService';
                }

                this.showSelfService = true;
            }
        },
        apiErrorCallback: function apiErrorCallback(error) {
            var errorMessage = this.findPolicyError(error.response);

            this.showSelfService = true;

            /* istanbul ignore next */
            this.displayNotification('error', errorMessage);

            // TODO Readd this if it is problematic not resetting all of registration on failure
            // clean up any queryParams from the url
            // this.$router.push('/registration');

            // reload the form
            // this.loadData();
        },
        findPolicyError: function findPolicyError(errorResponse) {
            var errorMessage = errorResponse.data.message,
                policyError = '';

            if (lodash_default.a.has(errorResponse, 'data.detail.failedPolicyRequirements')) {
                var policy = errorResponse.data.detail.failedPolicyRequirements[0];

                if (policy.policyRequirements.length > 0) {
                    policyError = this.$t('common.policyValidationMessages.' + policy.policyRequirements[0].policyRequirement, { property: policy.property });

                    errorMessage = errorMessage + ': ' + policyError;
                }
            }

            return errorMessage;
        },

        autoLogin: function autoLogin(jwt, successUrl) {
            var _this2 = this;

            /* istanbul ignore next */
            var loginServiceInstance = this.getRequestService({
                headers: {
                    'X-OpenIDM-Jwt': jwt,
                    'X-OpenIDM-NoSession': false,
                    'X-OpenIDM-Password': null,
                    'X-OpenIDM-Username': null
                }
            }),
                idmInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });

            /* istanbul ignore next */
            idmInstance.post('/authentication?_action=logout').then(function () {
                loginServiceInstance.post('/authentication?_action=login').then(function (userDetails) {
                    _this2.displayNotification('success', _this2.$t('pages.selfservice.registration.createdAccount'));

                    if (successUrl && successUrl.length > 0) {
                        window.location = successUrl;
                    } else {
                        // Check for progressive profiling.
                        _this2.progressiveProfileCheck(userDetails, function () {
                            _this2.$router.push('/');
                        });
                    }
                }).catch(function (error) {
                    /* istanbul ignore next */
                    _this2.displayNotification('error', error.response.data.message);
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c35ee8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selfservice/registration/index.vue
var registration_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('b-container',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showSelfService),expression:"!showSelfService"}],staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"m-auto fr-center-card"},[_c('bounce-loader',{attrs:{"color":_vm.loadingColor}})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSelfService),expression:"showSelfService"}]},[(_vm.selfServiceType !== 'localAutoLogin')?_c('fr-center-card',{attrs:{"showLogo":true}},[_c('div',{attrs:{"slot":"center-card-header"},slot:"center-card-header"},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.title.length > 0),expression:"title.length > 0"}],staticClass:"h2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.subtitle.length > 0),expression:"subtitle.length > 0"}],staticClass:"text-center mb-0"},[_vm._v(_vm._s(_vm.subtitle))])]),_vm._v(" "),_c('b-card-body',{attrs:{"slot":"center-card-body"},slot:"center-card-body"},[_c(_vm.selfServiceType,{directives:[{name:"show",rawName:"v-show",value:(_vm.showSelfService),expression:"showSelfService"}],ref:"selfServiceStage",tag:"component",attrs:{"selfServiceDetails":_vm.selfServiceDetails},on:{"advanceStage":_vm.advanceStage}})],1),_vm._v(" "),_c('b-card-footer',{attrs:{"slot":"center-card-footer"},slot:"center-card-footer"},[_vm._v("\n                "+_vm._s(_vm.$t('pages.selfservice.registration.haveAccount'))+"\n                "),_c('router-link',{attrs:{"action":"","to":"login"}},[_vm._v(_vm._s(_vm.$t('pages.selfservice.registration.signIn')))])],1)],1):_vm._e()],1)],1)}
var registration_staticRenderFns = []
var registration_esExports = { render: registration_render, staticRenderFns: registration_staticRenderFns }
/* harmony default export */ var selfservice_registration = (registration_esExports);
// CONCATENATED MODULE: ./src/components/selfservice/registration/index.vue
var registration_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var registration___vue_template_functional__ = false
/* styles */
var registration___vue_styles__ = null
/* scopeId */
var registration___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var registration___vue_module_identifier__ = null
var registration_Component = registration_normalizeComponent(
  registration,
  selfservice_registration,
  registration___vue_template_functional__,
  registration___vue_styles__,
  registration___vue_scopeId__,
  registration___vue_module_identifier__
)

/* harmony default export */ var components_selfservice_registration = (registration_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uma/Activity.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/**
 * @description Main component for UMA (AM/IDM) displays a list of resource activities
 *
 **/
/* harmony default export */ var Activity = ({
    name: 'Uma-Activity',
    components: {
        'fr-list-group': components_utils_ListGroup,
        'fr-list-item': components_utils_ListItem,
        'fr-fallback-image': components_utils_FallbackImage
    },
    props: {
        umaHistory: {
            required: true,
            type: Array
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        activityGroups: function activityGroups() {
            var sortedHistory = this.umaHistory.sort(function (a, b) {
                return a.eventTime - b.eventTime;
            }).reverse(),
                groups = lodash_default.a.groupBy(sortedHistory, function (event) {
                return moment_default()(event.eventTime).format('YYYY-MM-DD');
            }),
                activityGroups = lodash_default.a.keys(groups).map(function (day) {
                return { day: day, activities: groups[day] };
            });

            return lodash_default.a.sortBy(activityGroups, function (_ref) {
                var day = _ref.day;

                return moment_default()(day);
            }).reverse();
        }
    },
    methods: {
        formatDateTitle: function formatDateTitle(dateString) {
            return moment_default()(dateString).format('dddd, MMMM DD, YYYY');
        },
        formatTime: function formatTime(dateString) {
            var eventDate = moment_default()(dateString);

            if (eventDate.isSame(moment_default()(), 'day')) {
                return eventDate.fromNow();
            } else {
                return eventDate.format('LT');
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84371fbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma/Activity.vue
var Activity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.activityGroups),function(activityGroup){return [_c('fr-list-group',[_c('div',{staticClass:"card-body m-0 py-4",attrs:{"slot":"list-group-header"},slot:"list-group-header"},[_c('h6',{staticClass:"card-title mb-0"},[_vm._v(_vm._s(_vm.formatDateTitle(activityGroup.day)))])]),_vm._v(" "),_vm._l((activityGroup.activities),function(activity){return _c('fr-list-item',{key:activity._id,attrs:{"collapsible":false,"panelShown":false,"hoverItem":false}},[_c('template',{staticClass:"d-inline-flex w-100",slot:"list-item-header"},[_c('div',{staticClass:"flex-grow-1 media-body"},[_c('span',{staticClass:"activity-type"},[_vm._v(_vm._s(_vm.$t(("pages.uma.activity." + (activity.type)), {requestingParty: activity.requestingPartyName})))]),_vm._v(" "),_c('button',{staticClass:"m-0 p-0 btn btn-link text-capitalize",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('resourceSetClick', activity._id)}}},[_vm._v(_vm._s(activity.resourceSetName))]),_vm._v(" "),_c('small',{staticClass:"d-block text-muted subtext"},[_vm._v(_vm._s(_vm.formatTime(activity.eventTime)))])]),_vm._v(" "),_c('fr-fallback-image',{attrs:{"src":activity.icon_uri,"height":"30","width":"30","fallback":"fa-file-o"}})],1)],2)})],2)]})],2)}
var Activity_staticRenderFns = []
var Activity_esExports = { render: Activity_render, staticRenderFns: Activity_staticRenderFns }
/* harmony default export */ var uma_Activity = (Activity_esExports);
// CONCATENATED MODULE: ./src/components/uma/Activity.vue
var Activity_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Activity___vue_template_functional__ = false
/* styles */
var Activity___vue_styles__ = null
/* scopeId */
var Activity___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Activity___vue_module_identifier__ = null
var Activity_Component = Activity_normalizeComponent(
  Activity,
  uma_Activity,
  Activity___vue_template_functional__,
  Activity___vue_styles__,
  Activity___vue_scopeId__,
  Activity___vue_module_identifier__
)

/* harmony default export */ var components_uma_Activity = (Activity_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uma/Requests.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @description Allows user to request access to a resource
 *
 **/
/* harmony default export */ var Requests = ({
    name: 'Requests',
    components: {
        'fr-fallback-image': components_utils_FallbackImage
    },
    props: ['requests'],
    filters: {
        formatTime: function formatTime(dateString) {
            var eventDate = moment_default()(dateString);

            if (eventDate.isSame(moment_default()(), 'day')) {
                return eventDate.fromNow();
            } else {
                return eventDate.format('LT');
            }
        }
    },
    methods: {
        finalizeAccess: function finalizeAccess(request, index, action) {
            var _this = this;

            this.requests[index].decision = true;

            this.$emit('finalizeResourceAccess', request._id, action, {
                scopes: request.permissions,
                onSuccess: function onSuccess() {
                    if (action === 'approve') {
                        _this.requests[index].allowed = true;
                    }
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8ef0b52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma/Requests.vue
var Requests_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{attrs:{"id":"listView"}},[_c('b-card',{staticClass:"mt-4",attrs:{"no-body":""}},[_c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.requests),function(request,index){return _c('b-list-group-item',{key:index},[_c('div',{staticClass:"d-sm-flex"},[_c('div',{staticClass:"media-body align-self-center mb-2 mb-sm-0"},[_c('div',{staticClass:"mb-2"},[_c('small',[_c('strong',[_vm._v(_vm._s(request.user))]),_vm._v(" "+_vm._s(_vm.$t('pages.uma.requests.requestedAccess')))])]),_vm._v(" "),_c('div',{staticClass:"media mb-1"},[_c('div',{staticClass:"d-flex mr-2 align-self-center"},[(request.icon_uri)?_c('fr-fallback-image',{attrs:{"src":request.icon_uri,"height":"30","width":"30","fallback":"fa-file-o"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"media-body align-self-center"},[_c('div',{staticClass:"media-body align-self-center"},[_vm._v("\n                                            "+_vm._s(request.resource)+"\n                                        ")])])]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("formatTime")(request.when)))])]),_vm._v(" "),(!request.decision)?_c('div',{staticClass:"d-flex justify-content-start ml-sm-3 align-self-center"},[_c('a',{staticClass:"pr-3",attrs:{"href":"#"},on:{"click":function($event){_vm.finalizeAccess(request, index, 'approve')}}},[_vm._v(_vm._s(_vm.$t('pages.uma.requests.allow')))]),_vm._v(" "),_c('a',{staticClass:"px-2",attrs:{"href":"#"},on:{"click":function($event){_vm.finalizeAccess(request, index, 'deny')}}},[_vm._v(_vm._s(_vm.$t('pages.uma.requests.deny')))])]):_vm._e(),_vm._v(" "),(request.decision)?_c('div',{staticClass:"d-flex justify-content-start ml-sm-3 align-self-center"},[(request.allowed)?_c('div',{staticClass:"allow text-success"},[_c('i',{staticClass:"fa fa-check fa-fw"}),_vm._v(" "+_vm._s(_vm.$t('pages.uma.requests.allowed'))+"\n                                ")]):_vm._e(),_vm._v(" "),(!request.allowed)?_c('div',{staticClass:"deny text-danger"},[_c('i',{staticClass:"fa fa-ban fa-fw"}),_vm._v(" "+_vm._s(_vm.$t('pages.uma.requests.denied'))+"\n                                ")]):_vm._e()]):_vm._e()])])}))],1)],1)]],2)}
var Requests_staticRenderFns = []
var Requests_esExports = { render: Requests_render, staticRenderFns: Requests_staticRenderFns }
/* harmony default export */ var uma_Requests = (Requests_esExports);
// CONCATENATED MODULE: ./src/components/uma/Requests.vue
function Requests_injectStyle (ssrContext) {
  __webpack_require__("4Trk")
}
var Requests_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Requests___vue_template_functional__ = false
/* styles */
var Requests___vue_styles__ = Requests_injectStyle
/* scopeId */
var Requests___vue_scopeId__ = "data-v-a8ef0b52"
/* moduleIdentifier (server only) */
var Requests___vue_module_identifier__ = null
var Requests_Component = Requests_normalizeComponent(
  Requests,
  uma_Requests,
  Requests___vue_template_functional__,
  Requests___vue_styles__,
  Requests___vue_scopeId__,
  Requests___vue_module_identifier__
)

/* harmony default export */ var components_uma_Requests = (Requests_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uma/Resources.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * @description Component for displaying a resource
 *
 **/
/* harmony default export */ var Resources = ({
    name: 'Resources',
    components: {
        'fr-fallback-image': components_utils_FallbackImage
    },
    data: function data() {
        return {
            viewgrid: false,
            showModalActions: false,
            newshare: '',
            resourceFilter: ''
        };
    },

    props: ['resources'],
    methods: {
        renderShareModal: function renderShareModal(resource) {
            this.$emit('renderShareModal', resource);
        },
        renderUnshareModal: function renderUnshareModal(resourceName, resourceId) {
            this.$emit('renderUnshareModal', resourceName, resourceId);
        },
        toggleGrid: function toggleGrid() {
            this.viewgrid = !this.viewgrid;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a7b2ba2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma/Resources.vue
var Resources_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"btn-toolbar row mb-4",attrs:{"role":"toolbar","aria-label":"Toolbar with button groups"}},[_c('div',{staticClass:"input-group col-sm-4"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resourceFilter),expression:"resourceFilter"}],staticClass:"form-control",attrs:{"type":"text","aria-label":"Search","aria-describedby":"btnGroupAddon","placeholder":_vm.$t('pages.uma.resources.search')},domProps:{"value":(_vm.resourceFilter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.resourceFilter=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-dropdown',{staticClass:"float-right text-muted",attrs:{"variant":"link","right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"text-muted"},[(!this.viewgrid)?_c('i',{staticClass:"fa fa-list"}):_vm._e(),_vm._v(" "),(this.viewgrid)?_c('i',{staticClass:"fa fa-th"}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down ml-1"})])]),_vm._v(" "),_c('b-dropdown-header',[_vm._v(_vm._s(_vm.$t('pages.uma.resources.viewAs')))]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":_vm.toggleGrid}},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"d-flex align-self-center text-center",staticStyle:{"min-width":"1.5rem"}},[(!this.viewgrid)?_c('i',{staticClass:"fa fa-check text-success"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.list')))]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-3 align-self-center text-muted"},[_c('i',{staticClass:"fa fa-list"})])])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":_vm.toggleGrid}},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"d-flex align-self-center text-center",staticStyle:{"min-width":"1.5rem"}},[(this.viewgrid)?_c('i',{staticClass:"fa fa-check text-success"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.grid')))]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-3 align-self-center text-muted"},[_c('i',{staticClass:"fa fa-th"})])])])],2)],1)]),_vm._v(" "),(!this.viewgrid)?_c('div',{attrs:{"id":"listView"}},[_c('b-card',{staticClass:"my-4",attrs:{"no-body":""}},[_c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.resources),function(resource,index){return (resource.name.includes(_vm.resourceFilter))?_c('b-list-group-item',{key:index},[_c('div',{staticClass:"d-sm-flex"},[_c('div',{staticClass:"media-body"},[_c('div',{staticClass:"media mb-2 mb-sm-0"},[_c('div',{staticClass:"d-flex mr-3 align-self-top"},[_c('fr-fallback-image',{attrs:{"src":resource.icon_uri,"height":40,"width":40,"fallback":"fa-file-o fa-2x m-auto pt-1 pb-1"}})],1),_vm._v(" "),_c('div',{staticClass:"d-sm-flex media-body align-self-center"},[_c('div',{staticClass:"media-body mb-2 mb-sm-0"},[_c('div',{staticClass:"my-0"},[_vm._v(_vm._s(resource.name))]),_vm._v(" "),(!resource.policy)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.resourceNotShared')))]):(resource.policy.permissions.length > 1)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.sharedWithPeople', {numberOf: resource.policy.permissions.length})))]):_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.sharedWithPerson')))])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start justify-content-sm-start ml-sm-3 align-self-center"},[_c('div',{staticClass:"d-sm-none"},[_c('a',{staticClass:"align-self-center pr-3",attrs:{"href":"#"},on:{"click":function($event){_vm.renderShareModal(resource)}}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.share')))]),_vm._v(" "),_c('a',{staticClass:"align-self-center pr-3",attrs:{"href":"#"},on:{"click":function($event){_vm.renderUnshareModal(resource.name, resource._id)}}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.unshare')))])]),_vm._v(" "),_c('div',{staticClass:"d-none d-sm-flex"},[_c('a',{staticClass:"align-self-center pr-3",attrs:{"href":"#"},on:{"click":function($event){_vm.renderShareModal(resource)}}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.share')))]),_vm._v(" "),(resource.policy && resource.policy.permissions.length > 0)?_c('a',{staticClass:"align-self-center pr-3",attrs:{"href":"#"},on:{"click":function($event){_vm.renderUnshareModal(resource.name, resource._id)}}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.unshare')))]):_vm._e()])])])]):_vm._e()}))],1)],1):_vm._e(),_vm._v(" "),(this.viewgrid)?_c('div',{attrs:{"id":"gridView"}},[_c('div',{staticClass:"row"},_vm._l((_vm.resources),function(resource,index){return (resource.name.includes(_vm.resourceFilter))?_c('div',{key:index,staticClass:"col-sm-6 col-md-3"},[_c('div',{staticClass:"card text-center mb-4"},[_c('div',{staticClass:"card-header py-0 px-1 border-0"},[_c('b-dropdown',{staticClass:"fr-card-menu-link float-right",attrs:{"variant":"link","right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-ellipsis-h"})])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.renderShareModal(resource)}}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.share')))]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.renderUnshareModal(resource.name, resource._id)}}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.unshare')))])],2)],1),_vm._v(" "),_c('div',{staticClass:"card-body pt-0"},[_c('fr-fallback-image',{staticClass:"pl-5 pr-5 pt-3 mb-3",attrs:{"src":resource.icon_uri,"width":86,"height":86,"fallback":"fa-file-o fa-3x m-auto pt-3 pb-3"}}),_vm._v(" "),_c('h5',{staticClass:"card-title text-truncate"},[_vm._v(_vm._s(resource.name))]),_vm._v(" "),_c('div',{staticClass:"card-text"},[(!resource.policy)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.resourceNotShared')))]):(resource.policy.permissions.length > 1)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.sharedWithPeople', {numberOf: resource.policy.permissions.length})))]):_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.sharedWithPerson')))])])],1)])]):_vm._e()}))]):_vm._e()]],2)}
var Resources_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text",attrs:{"id":"btnGroupAddon"}},[_c('i',{staticClass:"fa fa-search"})])])}]
var Resources_esExports = { render: Resources_render, staticRenderFns: Resources_staticRenderFns }
/* harmony default export */ var uma_Resources = (Resources_esExports);
// CONCATENATED MODULE: ./src/components/uma/Resources.vue
function Resources_injectStyle (ssrContext) {
  __webpack_require__("JeZj")
}
var Resources_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Resources___vue_template_functional__ = false
/* styles */
var Resources___vue_styles__ = Resources_injectStyle
/* scopeId */
var Resources___vue_scopeId__ = "data-v-7a7b2ba2"
/* moduleIdentifier (server only) */
var Resources___vue_module_identifier__ = null
var Resources_Component = Resources_normalizeComponent(
  Resources,
  uma_Resources,
  Resources___vue_template_functional__,
  Resources___vue_styles__,
  Resources___vue_scopeId__,
  Resources___vue_module_identifier__
)

/* harmony default export */ var components_uma_Resources = (Resources_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uma/Share.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * @description Dialog for sharing a resource with users
 *
 **/
/* harmony default export */ var Share = ({
    name: 'Share',
    components: {
        'fr-fallback-image': components_utils_FallbackImage
    },
    props: ['resource'],
    data: function data() {
        return {
            newShare: false,
            text: 'Can ' + this.resource.scopes[0],
            newScopes: {}
        };
    },
    created: function created() {
        this.setNewScopes();
    },

    watch: {
        resource: function resource() {
            // istanbul ignore next
            this.setNewScopes();
        }
    },
    methods: {
        setNewScopes: function setNewScopes() {
            var _this = this;

            lodash_default.a.each(this.resource.scopes, function (scope) {
                _this.newScopes[scope] = true;
            });
        },
        hideModal: function hideModal() {
            this.$refs.fsModal.hide();
            this.resetModal();
        },
        resetModal: function resetModal() {
            this.newShare = '';
            this.setNewScopes();
        },
        unshareOne: function unshareOne(subject) {
            var onSuccess = this.resetModal.bind(this);

            // filter subject out of current permissions array
            var permissions = this.resource.policy.permissions.filter(function (obj) {
                return obj.subject !== subject;
            }),
                payload = {
                'policyId': this.resource._id,
                'permissions': permissions
            };

            this.$emit('modifyResource', this.resource._id, payload, { onSuccess: onSuccess, unshare: true });
            this.hideModal();
        },
        unshareAll: function unshareAll() {
            this.$emit('renderUnshareModal', this.resource.name, this.resource._id);
            this.hideModal();
        },
        validateResource: function validateResource() {
            var _this2 = this;

            // resource has already been shared
            if (this.resource.policy && this.resource.policy.permissions) {
                var index = lodash_default.a.findIndex(this.resource.policy.permissions, function (perm) {
                    return perm.subject === _this2.newShare;
                });

                if (index === -1) {
                    if (this.newShare) {
                        this.shareResource();
                    } else {
                        this.displayNotification('error', this.$t('pages.uma.resources.noRequestingParty'));
                    }
                    // attempting to share with user who already has access to resource
                } else {
                    this.displayNotification('error', this.$t('pages.uma.resources.sameShareError', { requestingParty: this.newShare }));
                    this.resetModal();
                }
                // shared for first time
            } else if (!this.resource.policy && this.newShare) {
                this.shareResource();
            }
        },
        shareResource: function shareResource() {
            var onSuccess = this.resetModal.bind(this);

            var subject = this.newShare,
                newScopes = lodash_default.a.keys(lodash_default.a.pickBy(this.newScopes)),
                newPermissions = { 'subject': subject, 'scopes': newScopes },
                payload = {
                'policyId': this.resource._id,
                'permissions': []
            };

            // resource has previously been shared
            if (this.resource.policy) {
                payload.permissions = this.resource.policy.permissions.filter(function (obj) {
                    return obj.subject !== subject;
                });
                payload.permissions.push(newPermissions);

                this.$emit('modifyResource', this.resource._id, payload, { onSuccess: onSuccess });
            } else {
                payload.permissions.push(newPermissions);

                this.$emit('shareResource', payload, { onSuccess: onSuccess });
            }

            this.hideModal();
        },
        modifyResource: function modifyResource(subject, changedScope) {
            var newPermissions = lodash_default.a.map(this.resource.policy.permissions, function (permission) {
                if (permission.subject === subject) {
                    var scopesLength = permission.scopes.length;

                    permission.scopes = lodash_default.a.filter(permission.scopes, function (scope) {
                        return scope !== changedScope;
                    });

                    if (scopesLength === permission.scopes.length) {
                        permission.scopes.push(changedScope);
                    }
                }

                return permission;
            }),
                payload = {
                'policyId': this.resource._id,
                'permissions': newPermissions
            };

            this.$emit('modifyResource', this.resource._id, payload);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57a4cadc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma/Share.vue
var Share_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"fsModal",attrs:{"id":"shareModal","cancel-variant":"outline-secondary"},on:{"hide":_vm.resetModal},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.validateResource($event)}}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"d-flex mr-3 align-self-center"},[_c('fr-fallback-image',{attrs:{"src":_vm.resource.icon_uri,"height":40,"width":40,"fallback":"fa-file-o"}})],1),_vm._v(" "),_c('div',{staticClass:"media-body align-self-center"},[_c('h6',{staticClass:"my-0"},[_vm._v(_vm._s(_vm.resource.name))]),_vm._v(" "),(!_vm.resource.policy)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.resourceNotShared')))]):(_vm.resource.policy.permissions.length > 1)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.sharedWithPeople', {numberOf: _vm.resource.policy.permissions.length})))]):_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.sharedWithPerson')))])])]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.hideModal}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":_vm.$t('pages.uma.resources.shareWith')},model:{value:(_vm.newShare),callback:function ($$v) {_vm.newShare=$$v},expression:"newShare"}}),_vm._v(" "),_c('b-dropdown',{attrs:{"slot":"append","text":_vm.text,"variant":"outline-secondary","size":"sm"},slot:"append"},[_c('form',{staticClass:"px-4 py-2",on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.resource.scopes),function(scope,index){return (_vm.resource.scopes)?_c('div',{key:index,staticClass:"form-check mb-1"},[_c('input',{staticClass:"form-check-input mr-1",attrs:{"type":"checkbox","id":"viewCheck"},domProps:{"checked":_vm.newScopes[scope]},on:{"click":function($event){_vm.newScopes[scope] = !_vm.newScopes[scope]}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"viewCheck"}},[_vm._v(_vm._s(scope))])]):_vm._e()}))])],1)],1),_vm._v(" "),_c('div',{class:[{'d-none': this.newShare}]},[(_vm.resource.policy && _vm.resource.policy.permissions)?_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.resource.policy.permissions),function(permission,index){return _c('li',{key:index,staticClass:"media py-2"},[_c('b-img',{staticClass:"mr-3",attrs:{"src":"static/images/profile-default.png","rounded":"circle","width":"34","height":"34","alt":"avatar"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h6',{staticClass:"mt-2"},[_vm._v(_vm._s(permission.subject))])]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-3 align-self-center"},[_c('b-dropdown',{attrs:{"id":"ddown1","text":_vm.text,"variant":"link","size":"sm","right":"","toggle-class":"dropdown-toggle"}},[_c('template',{staticClass:"dropdown-toggle",slot:"button-content"},[_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("Can "+_vm._s(permission.scopes.join(", ")))])]),_vm._v(" "),_c('form',{staticClass:"px-4 py-2",on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.newScopes),function(value,scope){return _c('div',{key:scope,staticClass:"form-check mb-1"},[_c('input',{staticClass:"form-check-input mr-1",attrs:{"type":"checkbox","id":"viewCheck"},domProps:{"checked":permission.scopes.includes(scope)},on:{"click":function($event){_vm.modifyResource(permission.subject, scope)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"viewCheck"}},[_vm._v(_vm._s(scope))])])})),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',[_c('span',{staticClass:"text-danger",attrs:{"role":"button"},on:{"click":function($event){_vm.unshareOne(permission.subject)}}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.unshare')))])])],2)],1)],1)})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',[_c('b-button',{attrs:{"type":"button","variant":"link"},on:{"click":_vm.unshareAll}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.unshareAll')))]),_vm._v(" "),(_vm.newShare)?_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"type":"button","variant":"outline-secondary"},on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.cancel')))]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"primary"},on:{"click":_vm.validateResource}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.share')))])],1):_vm._e()],1)])])}
var Share_staticRenderFns = []
var Share_esExports = { render: Share_render, staticRenderFns: Share_staticRenderFns }
/* harmony default export */ var uma_Share = (Share_esExports);
// CONCATENATED MODULE: ./src/components/uma/Share.vue
function Share_injectStyle (ssrContext) {
  __webpack_require__("9Hwp")
}
var Share_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Share___vue_template_functional__ = false
/* styles */
var Share___vue_styles__ = Share_injectStyle
/* scopeId */
var Share___vue_scopeId__ = "data-v-57a4cadc"
/* moduleIdentifier (server only) */
var Share___vue_module_identifier__ = null
var Share_Component = Share_normalizeComponent(
  Share,
  uma_Share,
  Share___vue_template_functional__,
  Share___vue_styles__,
  Share___vue_scopeId__,
  Share___vue_module_identifier__
)

/* harmony default export */ var components_uma_Share = (Share_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uma/Unshare.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Dialog for warning a user and confirming they want to stop sharing a resource
 *
 **/
/* harmony default export */ var Unshare = ({
    name: 'Unshare',
    components: {},
    data: function data() {
        return {};
    },

    props: ['resourceId', 'resourceName'],
    methods: {
        hideModal: function hideModal() {
            this.$refs.fsModal.hide();
        },
        unshare: function unshare() {
            this.$emit('unshareResource', this.resourceId);
            this.hideModal();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af699ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma/Unshare.vue
var Unshare_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"fsModal",attrs:{"id":"unshareModal","cancel-variant":"outline-secondary"},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.unshare($event)}}},[_c('div',{staticClass:"d-flex w-100 h-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h6',{staticClass:"my-0"},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.unshareResource', {resourceName: _vm.resourceName})))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.hideModal}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v("\n    "+_vm._s(_vm.$t('pages.uma.resources.warningMessage'))+"\n    "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"float-right"},[_c('b-btn',{attrs:{"variant":"outline-secondary"},on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.cancel')))]),_vm._v(" "),_c('b-btn',{attrs:{"type":"button","variant":"danger"},on:{"click":_vm.unshare}},[_vm._v(_vm._s(_vm.$t('pages.uma.resources.unshare')))])],1)])])}
var Unshare_staticRenderFns = []
var Unshare_esExports = { render: Unshare_render, staticRenderFns: Unshare_staticRenderFns }
/* harmony default export */ var uma_Unshare = (Unshare_esExports);
// CONCATENATED MODULE: ./src/components/uma/Unshare.vue
function Unshare_injectStyle (ssrContext) {
  __webpack_require__("vYzz")
}
var Unshare_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var Unshare___vue_template_functional__ = false
/* styles */
var Unshare___vue_styles__ = Unshare_injectStyle
/* scopeId */
var Unshare___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Unshare___vue_module_identifier__ = null
var Unshare_Component = Unshare_normalizeComponent(
  Unshare,
  uma_Unshare,
  Unshare___vue_template_functional__,
  Unshare___vue_styles__,
  Unshare___vue_scopeId__,
  Unshare___vue_module_identifier__
)

/* harmony default export */ var components_uma_Unshare = (Unshare_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/uma/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/**
 * @description Controlling component for sharing resources, this UI is primarily focused making use of AM and its UMA features.
 * This UI feature requires full stack (IDM/AM) to be configured and for AM to be properly configured to make use of UMA
 **/
/* harmony default export */ var uma = ({
    name: 'Sharing',
    components: {
        'fr-activity': components_uma_Activity,
        'fr-center-card': components_utils_CenterCard,
        'fr-requests': components_uma_Requests,
        'fr-resources': components_uma_Resources,
        'fr-share': components_uma_Share,
        'fr-unshare': components_uma_Unshare
    },
    data: function data() {
        return {
            requestsLoaded: false,
            resource: null,
            resourceId: '',
            resourceName: '',
            resources: [],
            activity: [],
            requests: [],
            resourcesCount: 0,
            activityCount: 0,
            delayedUpdate: false
        };
    },

    computed: {
        amDataEndpoints: function amDataEndpoints() {
            return this.$root.applicationStore.state.amDataEndpoints;
        },
        umaHistory: function umaHistory() {
            var _this = this;

            return lodash_default.a.map(this.activity, function (res) {
                var resource = lodash_default.a.find(_this.resources, { _id: res.resourceSetId });

                if (lodash_default.a.has(resource, 'icon_uri')) {
                    res.icon_uri = resource.icon_uri;
                }

                return res;
            });
        }
    },
    beforeMount: function beforeMount() {
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            this.getResources();
            this.getActivity();
            this.getRequests();
        },
        getResources: function getResources() {
            var _this2 = this;

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                query = '?_queryId=*',
                selfServiceInstance = this.getRequestService(),
                url = this.amDataEndpoints.baseUrl + userName + this.amDataEndpoints.resourceSet + query;

            /* istanbul ignore next */
            // by default CORS requests don't allow cookies, the 'withCredentials: true' flag allows it
            selfServiceInstance.get(url, { withCredentials: true }).then(function (response) {
                _this2.resources = response.data.result;
                _this2.requestsLoaded = true;
            }).catch(function (error) {
                /* istanbul ignore next */
                _this2.resources = [];
                _this2.requestsLoaded = true;

                if (error.response) {
                    _this2.displayNotification('error', error.response.data.message);
                } else {
                    _this2.displayNotification('error', error.message);
                }
            });
        },
        getActivity: function getActivity() {
            var _this3 = this;

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                query = '?_sortKeys=-eventTime&_queryFilter=true',
                selfServiceInstance = this.getRequestService(),
                url = this.amDataEndpoints.baseUrl + userName + this.amDataEndpoints.auditHistory + query;

            /* istanbul ignore next */
            // by default CORS requests don't allow cookies, the 'withCredentials: true' flag allows it
            selfServiceInstance.get(url, { withCredentials: true }).then(function (response) {
                _this3.activity = response.data.result;
            }).catch(function (error) {
                _this3.activity = [];
                /* istanbul ignore next */
                if (error.response) {
                    _this3.displayNotification('error', error.response.data.message);
                } else {
                    _this3.displayNotification('error', error.message);
                }
            });
        },
        getRequests: function getRequests() {
            var _this4 = this;

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                query = '?_sortKeys=user&_queryFilter=true',
                selfServiceInstance = this.getRequestService(),
                url = this.amDataEndpoints.baseUrl + userName + '/uma/pendingrequests' + query;

            /* istanbul ignore next */
            // by default CORS requests don't allow cookies, the 'withCredentials: true' flag allows it
            selfServiceInstance.get(url, { withCredentials: true }).then(function (response) {
                _this4.requests = lodash_default.a.map(response.data.result, function (request) {
                    var resource = lodash_default.a.find(_this4.resources, { name: request.resource });

                    if (lodash_default.a.has(resource, 'icon_uri')) {
                        request.icon_uri = resource.icon_uri;
                    }

                    if (lodash_default.a.has(resource, 'scopes')) {
                        request.scopes = resource.scopes;
                    }

                    request.allowed = false;
                    request.decision = false;

                    return request;
                });
            }).catch(function (error) {
                /* istanbul ignore next */
                _this4.requests = {};

                if (error.response) {
                    _this4.displayNotification('error', error.response.data.message);
                } else {
                    _this4.displayNotification('error', error.message);
                }
            });
        },
        renderShareModal: function renderShareModal(resource) {
            var _this5 = this;

            this.resource = resource;
            this.$nextTick(function () {
                _this5.$root.$emit('bv::show::modal', 'shareModal');
            });
        },
        renderUnshareModal: function renderUnshareModal(resourceName, resourceId) {
            var _this6 = this;

            this.resourceName = resourceName;
            this.resourceId = resourceId;
            this.$nextTick(function () {
                _this6.$root.$emit('bv::show::modal', 'unshareModal');
            });
        },
        shareResource: function shareResource(payload) {
            var _this7 = this;

            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                successMsg = this.$t('common.user.sharing.shareSuccess'),
                selfServiceInstance = this.getRequestService(),
                url = this.amDataEndpoints.baseUrl + userName + '/uma/policies/' + payload.policyId;

            /* istanbul ignore next */
            selfServiceInstance.put(url, payload, { withCredentials: true }).then(function (response) {
                if (config.onSuccess) {
                    config.onSuccess();
                }
                _this7.displayNotification('success', successMsg);
                _this7.loadData();
            }).catch(function (error) {
                /* istanbul ignore next */
                _this7.displayNotification('error', error.response.data.message);
            });
        },
        unshareResource: function unshareResource(resourceId) {
            var _this8 = this;

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                successMsg = this.$t('common.user.sharing.unshareSuccess'),
                selfServiceInstance = this.getRequestService(),
                url = this.amDataEndpoints.baseUrl + userName + '/uma/policies/' + resourceId;

            /* istanbul ignore next */
            selfServiceInstance.delete(url, { withCredentials: true }).then(function (response) {
                _this8.displayNotification('success', successMsg);
                _this8.loadData();
            }).catch(function (error) {
                /* istanbul ignore next */
                _this8.displayNotification('error', error.response.data.message);
            });
        },
        modifyResource: function modifyResource(resourceId, payload) {
            var _this9 = this;

            var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var successMsg = config.unshare ? this.$t('common.user.sharing.unshareSuccess') : this.$t('common.user.sharing.modifySuccess'),
                userName = this.$root.userStore.state.userName,
                url = this.amDataEndpoints.baseUrl + userName + '/uma/policies/' + resourceId,
                selfServiceInstance = this.getRequestService(),
                headers = { 'Accept-API-Version': 'protocol=1.0,resource=1.0' };

            selfServiceInstance.put(url, payload, { withCredentials: true, headers: headers }).then(function (res) {
                if (config.onSuccess) {
                    config.onSuccess();
                }

                _this9.displayNotification('success', successMsg);
                _this9.loadData();
            }).catch(function (error) {
                /* istanbul ignore next */
                _this9.displayNotification('error', error.response.data.message);
            });
        },
        finalizeResourceAccess: function finalizeResourceAccess(id, action) {
            var _this10 = this;

            var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            /* istanbul ignore next */
            var userName = this.$root.userStore.state.userName,
                successMsg = action === 'approve' ? this.$t('common.user.sharing.requestAllowedSuccess') : this.$t('common.user.sharing.requestDeniedSuccess'),
                selfServiceInstance = this.getRequestService(),
                payload = { scopes: config.scopes || {} },
                url = '' + this.amDataEndpoints.baseUrl + userName + '/uma/pendingrequests/' + id + '?_action=' + action;

            /* istanbul ignore next */
            selfServiceInstance.post(url, payload, { withCredentials: true }).then(function (response) {
                if (config.onSuccess) {
                    config.onSuccess();
                }

                _this10.delayedUpdate = true;
                _this10.displayNotification('success', successMsg);
            }).catch(function (error) {
                /* istanbul ignore next */
                _this10.displayNotification('error', error.response.data.message);
            });
        },
        testForReload: function testForReload() {
            if (this.delayedUpdate === true) {
                this.delayedUpdate = false;

                this.loadData();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e5cd26f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma/index.vue
var uma_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[(_vm.requestsLoaded)?[(_vm.resources.length > 0)?_c('b-tabs',{staticClass:"mt-4",on:{"click":_vm.testForReload}},[_c('b-tab',{attrs:{"title":"Resources","active":""}},[_c('fr-resources',{attrs:{"resources":_vm.resources},on:{"renderShareModal":_vm.renderShareModal,"renderUnshareModal":_vm.renderUnshareModal}})],1),_vm._v(" "),(_vm.activity.length > 0)?_c('b-tab',{attrs:{"title":"Activity"},on:{"click":_vm.testForReload}},[_c('fr-activity',{attrs:{"umaHistory":_vm.umaHistory}})],1):_vm._e(),_vm._v(" "),(_vm.requests.length > 0)?_c('b-tab',{attrs:{"title":"Requests"}},[_c('template',{slot:"title"},[_vm._v("\n                    "+_vm._s(_vm.$t('pages.uma.notifications.requests'))+" "),_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(_vm.requests.length))])],1),_vm._v(" "),_c('fr-requests',{attrs:{"requests":_vm.requests},on:{"finalizeResourceAccess":_vm.finalizeResourceAccess}})],2):_vm._e()],1):_c('div',[_c('fr-center-card',{staticClass:"mt-5",attrs:{"showLogo":false}},[_c('b-card-body',{attrs:{"slot":"center-card-body"},slot:"center-card-body"},[_c('img',{staticClass:"mb-4",staticStyle:{"width":"150px"},attrs:{"src":"static/images/empty-box.svg","alt":_vm.$t('common.form.logo')}}),_vm._v(" "),_c('h5',{staticClass:"h5"},[_vm._v(_vm._s(_vm.$t("pages.uma.resources.noDataState")))])])],1)],1),_vm._v(" "),(_vm.resource)?_c('fr-share',{attrs:{"resource":_vm.resource},on:{"shareResource":_vm.shareResource,"renderUnshareModal":_vm.renderUnshareModal,"modifyResource":_vm.modifyResource}}):_vm._e(),_vm._v(" "),_c('fr-unshare',{attrs:{"resourceId":_vm.resourceId,"resourceName":_vm.resourceName},on:{"unshareResource":_vm.unshareResource}})]:_vm._e()],2)}
var uma_staticRenderFns = []
var uma_esExports = { render: uma_render, staticRenderFns: uma_staticRenderFns }
/* harmony default export */ var components_uma = (uma_esExports);
// CONCATENATED MODULE: ./src/components/uma/index.vue
function uma_injectStyle (ssrContext) {
  __webpack_require__("OMEJ")
}
var uma_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var uma___vue_template_functional__ = false
/* styles */
var uma___vue_styles__ = uma_injectStyle
/* scopeId */
var uma___vue_scopeId__ = "data-v-0e5cd26f"
/* moduleIdentifier (server only) */
var uma___vue_module_identifier__ = null
var uma_Component = uma_normalizeComponent(
  uma,
  components_uma,
  uma___vue_template_functional__,
  uma___vue_styles__,
  uma___vue_scopeId__,
  uma___vue_module_identifier__
)

/* harmony default export */ var src_components_uma = (uma_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js















// import Styleguide from '../../styleguide/Styleguide';
/**
 * Available toolbar configuration
 * hideToolbar - Will hide main toolbar when route accessed
 */
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    routes: [{
        path: '/',
        redirect: '/dashboard'
    }, {
        path: '/handleOAuth/:amData',
        component: src_components_OAuthReturn,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }, {
        path: '/oauthReturn',
        component: src_components_OAuthReturn,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }, {
        path: '/login',
        name: 'Login',
        alias: ['/_=_'], // Need alias for catching Facebook odd oAuth return
        component: src_components_Login,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' },
        beforeEnter: function beforeEnter(to, from, next) {
            /* istanbul ignore next */
            if (window.location.search && window.location.search.match(/state|oauth_token/)) {
                next('/oauthReturn');
            } else {
                next();
            }
        }
    }, {
        path: '/profile',
        name: 'Profile',
        props: true,
        component: src_components_profile,
        meta: { authenticate: true }
    }, {
        path: '/list/:resourceType/:resourceName',
        name: 'ListResource',
        component: src_components_access,
        meta: { authenticate: true }
    }, {
        path: '/edit/:resourceType/:resourceName/:resourceId',
        name: 'EditResource',
        component: components_access_EditResource,
        meta: { authenticate: true }
    }, {
        path: '/dashboard',
        name: 'Dashboard',
        component: src_components_dashboard,
        meta: { authenticate: true },
        beforeEnter: function beforeEnter(to, from, next) {
            /* istanbul ignore next */
            if (window.location.search && window.location.search.match(/state|oauth_token/)) {
                next({
                    path: '/oauthReturn'
                });
            } else {
                next();
            }
        }
    }, {
        path: '/registration',
        name: 'Registration',
        component: components_selfservice_registration,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' },
        props: true
    }, {
        path: '/accountClaiming',
        name: 'AccountClaiming',
        component: selfservice_registration_AccountClaiming,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' },
        props: true
    }, {
        path: '/registration/:queryParams',
        name: 'RegistrationEmailValidation',
        component: components_selfservice_registration,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }, {
        path: '/forgotusername',
        name: 'ForgotUsername',
        component: components_selfservice_forgotusername,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }, {
        path: '/passwordreset',
        name: 'PasswordReset',
        component: components_selfservice_passwordreset,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }, {
        path: '/passwordreset/:queryParams',
        name: 'PasswordResetForm',
        component: components_selfservice_passwordreset,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }, {
        path: '/profilecompletion',
        name: 'ProgressiveProfileForm',
        component: components_selfservice_progressiveprofile,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }, {
        path: '/profilecompletion/:profileProcess',
        name: 'ProgressiveProfileInitiate',
        component: components_selfservice_progressiveprofile,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }, {
        path: '/sharing',
        name: 'Sharing',
        component: src_components_uma,
        meta: {
            authenticate: true
        }
    },
    /*
    {
        path: '/styleguide',
        name: 'Styleguide',
        component: Styleguide,
        meta: { hideToolbar: true }
    },
    */
    {
        path: '*',
        component: src_components_NotFound,
        meta: { hideToolbar: true, bodyClass: 'fr-body-image' }
    }]
}));
// CONCATENATED MODULE: ./src/translations/index.js
/* harmony default export */ var translations = ({
    en: {
        config: {
            messages: {
                socialProviders: {
                    cannotUnbind: 'Before disabling provider create a local password'
                }
            }
        },
        common: {
            form: {
                submit: 'Submit',
                agree: 'I Agree',
                logo: 'logo',
                signUp: 'Sign Up',
                cancel: 'Cancel',
                saveChanges: 'Save changes',
                edit: 'Edit',
                save: 'Save',
                remove: 'Remove',
                confirm: 'Confirm',
                close: 'Close',
                okay: 'Okay',
                new: 'New',
                yes: 'Yes',
                no: 'No',
                delete: 'Delete'
            },
            placeholders: {
                password: 'Password',
                retypePassword: 'Retype Password',
                emailAddress: 'Email address'
            },
            user: {
                profile: {
                    updateSuccess: 'Updated your profile.'
                },
                sharing: {
                    shareSuccess: 'Shared your resource.',
                    unshareSuccess: 'Unshared your resource.',
                    modifySuccess: 'Modified resource permissions',
                    requestAllowedSuccess: 'Access granted',
                    requestDeniedSuccess: 'Access denied'
                },
                kba: {
                    description: 'Select security question(s) below. These questions will help us verify your identity if you forget your password.',
                    selectQuestion: 'Select a security question...',
                    custom: 'Provide your own:',
                    question: 'Question',
                    answer: 'Answer',
                    saveQuestions: 'Save questions',
                    submitAnswers: 'Verify Answer | Verify Answers',
                    notUnique: 'Custom questions cannot be duplicates'
                }
            },
            policyValidationMessages: {
                'VALID_PHONE_FORMAT': 'Must be a valid phone number',
                'VALID_NAME_FORMAT': 'Must have valid name characters',
                'CANNOT_CONTAIN_CHARACTERS': 'Cannot contain characters: %{forbiddenChars}',
                'IS_NUMBER': 'Must be a number greater than or equal to zero.',
                'IS_NUMBER_GREATER_ZERO': 'Must be a number greater than or equal to 1.',
                'REQUIRED': 'Cannot be blank',
                'VALID_DATE': 'Must be a valid date',
                'VALID_TYPE': 'Must be one of the following types: %{validTypes}. Cannot be %{invalidType}',
                'MATCH_REGEXP': 'Has to match pattern: %{regexp}',
                'PRIVILEGE_AT_LEAST_ONE_ATTRIBUTE_READONLY_FALSE': 'Must set at least one attribute permission to Read/Write',
                'PRIVILEGE_MUST_CONTAIN_CREATE_OR_UPDATE_PERMISSION': 'Must have at least Create or Update Permission',
                'MIN_LENGTH': 'Must be %{minLength} characters long',
                'AT_LEAST_X_CAPITAL_LETTERS': 'Must have at least %{numCaps} capital letter(s)',
                'AT_LEAST_X_NUMBERS': 'Must have at least %{numNums} number(s)',
                'CANNOT_CONTAIN_OTHERS': 'Must not share characters with %{disallowedFields}',
                'VALID_EMAIL_ADDRESS_FORMAT': 'Invalid email format (example@example.com)',
                'UNIQUE': '%{property} must be unique',
                'test': 'succeed',
                policyServiceError: {
                    registration: 'Unable to register. Please try again later.',
                    reset: 'Unable to reset your password. Please try again later.'
                },
                successMessages: {
                    password: 'Your password is secure!'
                }
            }
        },
        pages: {
            app: {
                profile: 'Profile',
                dashboard: 'Dashboard',
                sharing: 'Sharing',
                user: 'User',
                admin: 'Admin',
                signOut: 'Sign Out',
                notifications: {
                    noNotifications: 'No notifications available',
                    title: 'Notifications',
                    clearAll: 'Clear All',
                    removedAll: 'Removed all notifications',
                    removed: 'Removed notification',
                    failedToRemove: 'Failed to remove notification',
                    failedToClear: 'Failed to clear all notifications'
                }
            },
            notFound: {
                couldNotFind: 'We couldn\'t find the page you were looking for.',
                returnToDashboard: 'Return to dashboard'
            },
            dashboard: {
                noWidget: 'No Widgets Available',
                noWidgetSubText: 'Don\'t worry, you still have a <a href="/#/profile">profile</a>.',
                widgets: {
                    welcome: {
                        greeting: 'Hello',
                        welcomeMessage: 'The ForgeRock End User UI helps users manage their account data, consent, workflows, and shared resources.',
                        editProfile: 'Edit Your Profile'
                    }
                }
            },
            login: {
                username: 'Username',
                password: 'Password',
                signIn: 'Sign In',
                newHere: 'New here?',
                createAccount: 'Create an account',
                badPassword: "Sorry, that password isn't right.",
                weCanHelp: 'We can help you',
                recoverPassword: 'recover your password.',
                forgotUsername: 'Forgot username?',
                forgotPassword: 'Forgot password?'
            },
            selfservice: {
                signIn: 'Sign in',
                captchaError: 'ReCaptcha configured improperly - contact your administrator.',
                headers: {
                    username: {
                        title: 'Recover Your Username',
                        description: 'You can recover your username with the email address associated with your account.'
                    },
                    reset: {
                        title: 'Reset Password',
                        description: 'Verify You\'re Human',
                        emailSent: 'An email has been sent to your inbox with instructions on how to reset your password.'
                    }
                },
                registration: {
                    signUp: 'Sign Up',
                    haveAccount: 'Already have an account?',
                    signIn: 'Sign in',
                    signUpMsg: 'Signing up is fast and easy.',
                    createdAccount: 'User account has been created.',
                    pleaseComplete: 'Please complete the registration form',
                    termsAndConditions: {
                        title: 'Terms & Conditions',
                        singlePage: 'By clicking "Sign Up" you agree to our '
                    },
                    consent: {
                        title: 'Privacy & Consent',
                        agreement: 'I agree'
                    },
                    emailValidation: 'An email has been sent to the address you entered. Click the link in that email to proceed.',
                    completeRegistration: 'Complete Registration',
                    stageTitle: {
                        captcha: 'Verify You\'re Human',
                        consent: '',
                        emailValidation: '',
                        kbaSecurityAnswerDefinitionStage: 'Create Security Questions',
                        termsAndConditions: ''
                    },
                    stageSubtitle: {
                        captcha: 'No robots allowed',
                        consent: '',
                        emailValidation: '',
                        kbaSecurityAnswerDefinitionStage: '',
                        termsAndConditions: ''
                    }
                },
                accountClaiming: {
                    title: 'You have an existing account',
                    passwordDesc: 'To continue, please sign in with you email <strong>{account}</strong> to link accounts.',
                    socialDesc: 'To continue, please sign in to your {providers} account to link accounts.',
                    link: 'Link Accounts',
                    return: 'Back to sign in',
                    linked: 'Accounts linked',
                    error: 'Unable to link accounts'
                },
                forgotUsername: {
                    advanceStageButtonText: 'Recover Username',
                    yourUsername: 'Your username is',
                    unableToRetrieve: 'Unable to retrieve your username',
                    tryAgain: 'Try finding your username again',
                    emailSent: 'An email containing your username has been sent to your account.'
                },
                passwordReset: {
                    userQuery: 'Enter email to retrieve account details',
                    advanceStageButtonText: 'Retrieve Account',
                    tryAgain: 'Try resetting your password again',
                    errorMessage: 'Error resetting your password',
                    successMessage: 'Your password has been reset.',
                    newPassword: 'New password',
                    changePassword: 'Change Password',
                    kbaVerificationStageDescription: 'Verify your identity by answering security questions'
                },
                progressiveProfile: {
                    skipThis: 'Skip this'
                },
                social: {
                    signIn: 'Sign in with',
                    signUp: 'Sign up with',
                    or: 'or'
                }
            },
            profile: {
                editPersonalInfo: 'Edit personal info',
                settings: 'Settings',
                activity: 'Activity',
                accountControls: {
                    title: 'Account Controls',
                    subtitle: 'Download your account data or delete your account.',
                    deleteTitle: 'Delete your account',
                    deleteSubtitle: 'Permanently delete your account.',
                    deleteAccount: 'Delete Account',
                    deleteModalTitle: 'Delete your account',
                    deleteModalHeader: 'Please read this carefully.',
                    deleteModalDetails: 'You\'re trying to delete your account, which provides access to various services. You\'ll\n no longer be able to use any of those services, and your account and data will be lost.',
                    deleteModalDownload1: 'You can',
                    deleteModalDownload2: 'download your data',
                    deleteModalDownload3: 'before deleting your account.',
                    deleteModalContentList: 'The following content will be deleted.',
                    deleteModalContentListItem: 'Access to your profile',
                    deleteModalAcceptMessage: 'Yes, I want to permanently delete my account',
                    deleteModalButton: 'Delete Account',
                    deleteAccountSuccessful: 'Successfully deleted your account.',
                    downloadTitle: 'Download your data',
                    downloadSubtitle: 'Download your account data.',
                    downloadLink: 'Download'
                },
                preferences: {
                    title: 'Preferences',
                    subtitle: 'Set your communications preferences.'
                },
                oauthApplications: {
                    title: 'Authorized Applications',
                    subtitle: 'These apps can access your account.',
                    removeConfirmation: 'Are you sure you want to remove "{applicationName}" from your list of authorized applications?',
                    removeSuccess: '"{applicationName}" successfully removed.',
                    expires: 'Expires: ',
                    noApplications: 'No Authorized Applications'
                },
                trustedDevices: {
                    title: 'Trusted Devices',
                    subtitle: 'Devices you have signed in with.',
                    removeConfirmation: 'Are you sure you want to remove "{deviceName}" from your list of trusted devices?',
                    removeSuccess: '"{deviceName}" successfully removed.',
                    noDevices: 'No Trusted Devices'
                },
                editProfile: {
                    userDetailsTitle: 'Edit your personal info',
                    failedProfileSave: 'Failed to save profile changes',
                    optional: '(optional)',
                    noFields: 'No profile fields available'
                },
                accountSecurity: {
                    title: 'Account Security',
                    invalidPassword: 'Invalid password form',
                    subtitle: 'Update your username, password or security questions to secure your account.',
                    'password': 'Password',
                    'securityQuestions': 'Security Questions',
                    'rememberPassword': 'Can\'t remember your current password?',
                    'resetPassword': 'Reset your password',
                    'savePassword': 'Save password',
                    'custom': 'Custom',
                    'currentPassword': 'Current password',
                    'newPassword': 'New password'
                },
                consent: {
                    allow: 'Allow',
                    allowConsentHeader: 'Allow Access',
                    accessType: 'Access Type',
                    accountAccess: 'Account Access',
                    authorized: 'Authorized',
                    confirmDeny: '<strong>{mappingName}</strong> will no longer have access to your data.',
                    deny: 'Deny',
                    denyConsentHeader: 'Deny Access',
                    notAuthorized: 'Not Authorized',
                    subtitle: 'Control how your data is shared with third parties.',
                    title: 'Personal Data Sharing'
                },
                socialSignIn: {
                    title: 'Social Sign-in',
                    subtitle: 'Sign into your account using social identity providers.',
                    disconnect: 'Disconnect',
                    disconnectConfirmMsg: 'If you disconnect, you will not be able to log in with {provider}.',
                    connect: 'Connect',
                    sharing: 'You are sharing',
                    linkedAccount: 'Linked account'
                }
            },
            uma: {
                activity: {
                    'Authorisation_Granted': 'You created',
                    'Authorisation_Requested': '{requestingParty} requested access to',
                    'Authorisation_Request_Denied': 'You denied the request from {requestingParty} to access',
                    'Authorisation_Request_Approved': 'You approved the request from {requestingParty} to access',
                    'Policy_Created': 'You shared',
                    'Policy_Updated': 'You updated sharing setting for'
                },
                resources: {
                    noDataState: 'You haven\'t shared anything yet.',
                    search: 'Search...',
                    viewAs: 'View as',
                    list: 'List',
                    grid: 'Grid',
                    cancel: 'Cancel',
                    share: 'Share',
                    unshare: 'Unshare',
                    unshareAll: 'Unshare all',
                    shareWith: 'Share with...',
                    resourceNotShared: 'Resource not shared',
                    sharedWithPeople: 'Shared with {numberOf} people',
                    sharedWithPerson: 'Shared with 1 person',
                    warningMessage: 'Sharing disabled. You\'ll still keep a copy.',
                    unshareResource: 'Unshare "{resourceName}" ?',
                    sameShareError: 'Cannot reshare resource with {requestingParty}.  Unshare with requesting party before changing permissions',
                    noRequestingParty: 'No requesting party defined.'
                },
                requests: {
                    allow: 'Allow',
                    deny: 'Deny',
                    allowed: 'Allowed',
                    denied: 'Denied',
                    requestedAccess: 'requested access to:'
                },
                notifications: {
                    requests: 'Requests'
                }
            },
            access: {
                password: 'Password',
                noFields: 'No Fields Available',
                successCreate: '{resource} successfully created',
                typeSearch: 'Type to Search',
                invalidCreate: 'Invalid create form',
                deleteResource: 'Successfully deleted user',
                deleteConfirm: 'Are you sure you want to delete this',
                deleteModalTitle: 'Confirm Deletion',
                noAvailableProperties: 'No available properties for editing',
                unableToEditResource: 'Unable to edit {resource}',
                invalidEdit: 'Invalid edit form',
                successEdited: '{resource} successfully edited',
                details: 'Details',
                resetPassword: 'Reset password',
                failedSavePassword: 'Failed to save password',
                successSavePassword: 'Successfully saved password'
            },
            workflow: {
                assign: 'Assign',
                assignTo: 'Assign to',
                assignmentSuccess: '{taskName} successfully assigned to {assignee}',
                details: 'Details',
                myTasks: 'My Tasks',
                noProcess: 'No processes at this time',
                noAssignedTasks: 'No assigned tasks at this time',
                noGroupTasks: 'Your group has no tasks at this time',
                notAssigned: 'Not assigned',
                processStartSuccessMessage: 'Process started',
                me: 'Me',
                requeue: 'Requeue',
                start: 'Start',
                startProcess: 'Start a Process',
                taskSuccessfullyCompleted: 'Task successfully completed',
                taskSuccessfullyRequeued: '{taskName} successfully requeued',
                taskNoLongerAvailable: '{taskName} task deleted by admin',
                unassignedTasks: 'Unassigned Tasks'
            }
        }
    }
});
// CONCATENATED MODULE: ./src/store/User.js


/**
 * State - Enduser data store information
 *      @param {string} userId - Unique system identifier for a user used to get their specific profile information
 *      @param {string} managedResource - Managed object where profile information lives
 *      @param {array} roles - Available roles for a user
 *      @param {object} profile - JSON blob of the managed resource profile details
 *      @param {object} schema - JSON blob of the managed resource schema
 *      @param {string} firstName - Users first name pulled from profile details
 *      @param {string} sn - Users last name pulled from profile details
 *      @param {string} email - Users email pulled from profile details,
 *      @param {string} userName - Users username from profile details
 *      @param {array} access - Available resources user has access to
 */
/* harmony default export */ var User = ({
    state: {
        userId: null,
        managedResource: null,
        roles: null,
        internalUser: false,
        profile: null,
        schema: null,
        access: [],
        givenName: '',
        sn: '',
        email: '',
        userName: ''
    },
    getUserState: function getUserState() {
        return lodash_default.a.clone(this.state);
    },
    setProfileAction: function setProfileAction(profile) {
        if (profile.givenName) {
            this.state.givenName = profile.givenName;
        } else {
            this.state.givenName = '';
        }

        if (profile.sn) {
            this.state.sn = profile.sn;
        } else {
            this.state.sn = '';
        }

        if (profile.mail) {
            this.state.email = profile.mail;
        } else {
            this.state.email = '';
        }

        if (profile.userName) {
            this.state.userName = profile.userName;
        } else {
            this.state.userName = '';
        }

        this.state.profile = profile;
    },
    clearProfileAction: function clearProfileAction() {
        this.state.profile = null;
        this.state.givenName = '';
        this.state.sn = '';
        this.state.email = '';
        this.state.userName = '';
    },
    setSchemaAction: function setSchemaAction(schema) {
        this.state.schema = schema;
    },
    clearSchemaAction: function clearSchemaAction() {
        this.state.schema = null;
    },
    setUserIdAction: function setUserIdAction(userId) {
        this.state.userId = lodash_default.a.clone(userId);
    },
    clearUserIdAction: function clearUserIdAction() {
        this.state.userId = null;
    },
    setManagedResourceAction: function setManagedResourceAction(managedResource) {
        this.state.managedResource = lodash_default.a.clone(managedResource);

        if (managedResource === 'internal/user') {
            this.state.internalUser = true;
        }
    },
    clearManagedResourceAction: function clearManagedResourceAction() {
        this.state.managedResource = null;
    },
    setRolesAction: function setRolesAction(roles) {
        this.state.roles = lodash_default.a.clone(roles);
    },
    clearRolesAction: function clearRolesAction() {
        this.state.roles = null;
    },
    setAccess: function setAccess(access) {
        this.state.access = lodash_default.a.clone(access);
    },
    clearAccess: function clearAccess() {
        this.state.access = [];
    },
    clearStoreAction: function clearStoreAction() {
        this.state.userId = null;
        this.state.managedResource = null;
        this.state.roles = null;
        this.state.profile = null;
        this.state.schema = null;
        this.state.givenName = '';
        this.state.sn = '';
        this.state.email = '';
        this.state.userName = '';
        this.state.internalUser = false;
        this.state.access = [];
    }
});
// CONCATENATED MODULE: ./src/store/Application.js


/**
 * State - Enduser data store information
 *      @param {boolean} workflow - Flag to allow the UI to know the workflow feature is available
 *      @param {boolean} passwordReset - Flag to allow the UI to know the password reset feature is available
 *      @param {boolean} usernameRecovery - Flag to allow the UI to know the username recovery feature is available
 *      @param {boolean} registration - Flag to allow the UI to know the registration feature is available
 *      @param {object} authHeaders - Request headers needed for authenticated requests in fullStack mode
 *      @param {object} amDataEndpoints - AM endpoints required for fullStack
 */
/* harmony default export */ var Application = ({
    state: {
        workflow: false,
        passwordReset: false,
        usernameRecovery: false,
        registration: false,
        authHeaders: null,
        amDataEndpoints: null,
        loginRedirect: null
    },

    setAmDataEndpointsAction: function setAmDataEndpointsAction(amDataEndpoints) {
        this.state.amDataEndpoints = amDataEndpoints;
    },
    clearAmDataEndpointsAction: function clearAmDataEndpointsAction() {
        this.state.amDataEndpoints = null;
    },
    setWorkflowAction: function setWorkflowAction(available) {
        this.state.workflow = available;
    },
    clearWorkflowAction: function clearWorkflowAction() {
        this.state.workflow = false;
    },
    setPasswordResetAction: function setPasswordResetAction(available) {
        this.state.passwordReset = available;
    },
    clearPasswordResetAction: function clearPasswordResetAction() {
        this.state.passwordReset = false;
    },
    setUsernameRecoveryAction: function setUsernameRecoveryAction(available) {
        this.state.usernameRecovery = available;
    },
    clearUsernameRecoveryAction: function clearUsernameRecoveryAction() {
        this.state.usernameRecovery = false;
    },
    setRegistrationAction: function setRegistrationAction(available) {
        this.state.registration = available;
    },
    clearRegistrationAction: function clearRegistrationAction() {
        this.state.registration = false;
    },
    setEnduserSelfservice: function setEnduserSelfservice(availability) {
        var _this = this;

        lodash_default.a.each(availability, function (feature) {
            if (feature.name === 'retrieveUsername' && lodash_default.a.find(feature.endpoints, function (el) {
                return el === 'selfservice/username';
            })) {
                _this.setUsernameRecoveryAction(feature.enabled);
            } else if (feature.name === 'passwordReset' && lodash_default.a.find(feature.endpoints, function (el) {
                return el === 'selfservice/reset';
            })) {
                _this.setPasswordResetAction(feature.enabled);
            } else if (feature.name === 'registration' && lodash_default.a.find(feature.endpoints, function (el) {
                return el === 'selfservice/registration';
            })) {
                _this.setRegistrationAction(feature.enabled);
            } else if (feature.name === 'workflow') {
                _this.setWorkflowAction(feature.enabled);
            }
        });
    },
    setAuthHeadersAction: function setAuthHeadersAction(headers) {
        this.state.authHeaders = headers;
    },
    clearAuthHeadersAction: function clearAuthHeadersAction() {
        this.state.authHeaders = null;
    },
    setLoginRedirect: function setLoginRedirect(redirect) {
        this.state.loginRedirect = redirect;
    },
    clearLoginRedirect: function clearLoginRedirect() {
        this.state.loginRedirect = null;
    },
    clearEnduserSelfservice: function clearEnduserSelfservice() {
        this.state.workflow = false;
        this.state.passwordReset = false;
        this.state.usernameRecovery = false;
        this.state.registration = false;
        this.state.authHeaders = null;
        this.state.amDataEndpoints = null;
        this.state.loginRedirect = null;
    }
});
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/vue-js-toggle-button/dist/index.js
var vue_js_toggle_button_dist = __webpack_require__("nkUn");
var vue_js_toggle_button_dist_default = /*#__PURE__*/__webpack_require__.n(vue_js_toggle_button_dist);

// EXTERNAL MODULE: ./node_modules/es6-promise/dist/es6-promise.js
var es6_promise = __webpack_require__("hKoQ");
var es6_promise_default = /*#__PURE__*/__webpack_require__.n(es6_promise);

// CONCATENATED MODULE: ./src/main.js

















// Turn off production warning messages
vue_esm["default"].config.productionTip = false;

es6_promise_default.a.polyfill();

// Add translation capability
/*
  Basic Translation Example:

  HTML: {{ $t("pages.resources.externalResources") }}
  JS: this.$t("pages.resources.externalResources")
 */
vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

// Setup router
vue_esm["default"].use(vue_router_esm["a" /* default */]);

// Router guard to check authenticated routes
router.beforeEach(function (to, from, next) {
    document.body.className = '';

    if (lodash_default.a.has(to, 'meta.bodyClass')) {
        document.body.className = (document.body.className + to.meta.bodyClass).trim();
    }

    if (lodash_default.a.has(to, 'meta.authenticate')) {
        if (lodash_default.a.isNull(User.state.userId)) {
            var tempHeaders = lodash_default.a.extend({
                'content-type': 'application/json',
                'cache-control': 'no-cache',
                'x-requested-with': 'XMLHttpRequest'
            }, Application.state.authHeaders || {}),
                amLogin = false,
                authInstance = void 0;

            /*
                If we are in working with OpenAM to prevent extra redirects and timeouts we have to catch
                the session right here and configure the appropriate headers
             */
            if (sessionStorage.getItem('resubmitDataStoreToken') && sessionStorage.getItem('amToken')) {
                tempHeaders = {
                    'X-OpenIDM-NoSession': 'false',
                    'X-OpenIDM-OAuth-Login': 'true',
                    'X-OpenIDM-DataStoreToken': sessionStorage.getItem('amToken'),
                    'X-Requested-With': 'XMLHttpRequest'
                };

                amLogin = true;
            }

            authInstance = axios_default.a.create({
                baseURL: idmContext,
                timeout: 5000,
                headers: tempHeaders
            });

            authInstance.post('/authentication?_action=login').then(function (userDetails) {
                /*
                    Similar to oauthReturn we need to manipulate the correct headers for open AM here as well (if not the UI gets into an odd state where it will
                    randomly go back to openAM to restore its session since the existing JWT returned from IDM has timed out.
                     This is not ideal, but to create the least painful UI experience this is what we have to do for now.
                 */
                if (amLogin) {
                    Application.setAuthHeadersAction({
                        'X-OpenIDM-OAuth-Login': 'true',
                        'X-OpenIDM-DataStoreToken': sessionStorage.getItem('amToken'),
                        'X-Requested-With': 'XMLHttpRequest'
                    });
                }

                User.setUserIdAction(userDetails.data.authorization.id);
                User.setManagedResourceAction(userDetails.data.authorization.component);
                User.setRolesAction(userDetails.data.authorization.roles);

                // Check for progressive profiling.
                if (lodash_default.a.has(userDetails, 'data.authorization.requiredProfileProcesses') && !lodash_default.a.isNull(userDetails.data.authorization.requiredProfileProcesses) && userDetails.data.authorization.requiredProfileProcesses.length > 0) {
                    var profileProcess = userDetails.data.authorization.requiredProfileProcesses[0].split('/')[1];

                    next('/profileCompletion/' + profileProcess);
                } else {
                    axios_default.a.all([authInstance.get(userDetails.data.authorization.component + '/' + userDetails.data.authorization.id), authInstance.post('privilege?_action=listPrivileges'), authInstance.get('schema/' + userDetails.data.authorization.component)]).then(axios_default.a.spread(function (profile, privilege, schema) {
                        User.setProfileAction(profile.data);
                        User.setSchemaAction(schema.data);
                        User.setAccess(privilege.data);

                        next();
                    }));
                }
            }, function () {
                // Recheck class in case of double login load using from location
                document.body.className = '';

                if (lodash_default.a.has(from, 'meta.bodyClass')) {
                    document.body.className = (document.body.className + from.meta.bodyClass).trim();
                }

                if (to.name !== 'Login') {
                    Application.setLoginRedirect({
                        name: to.name,
                        params: to.params
                    });
                }

                next({ name: 'Login' });
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

// Ready translated locale messages
// IDM Context default
var i18n = new vue_i18n_esm["a" /* default */]({
    locale: 'en',
    fallbackLocale: 'en',
    messages: translations
}),
    idmContext = window.context || '/openidm';

// Globally load bootstrap vue components for use
vue_esm["default"].use(es["a" /* default */]);

/*
    Basic Validation Example:
    <p :class="{ 'control': true }">
        <input v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }" name="email" type="text" placeholder="Email">
        <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
    </p>

    To use VeeValidate in a component include:

    $_veeValidate: {
        validator: 'new'
    }
 */
vue_esm["default"].use(vee_validate_esm["a" /* default */], { inject: false, fastExit: false });

/*
    Basic Notification Example:
    this.$notify({
        group: 'IDMMessages', // Currently the only group
        type: 'success', // Available types success, failure, info, warning
        title: this.$t('common.messages.saveSuccess'), //Translated string
        text: this.$t('pages.resources.mappingSave') // Translated string (can also be html)
    });
 */
vue_esm["default"].use(dist_default.a);

vue_esm["default"].use(vue_js_toggle_button_dist_default.a);

// Global mixin for making openIDM REST calls
vue_esm["default"].mixin({
    methods: {
        // Generated an axios ajax request service for consistent use of calls to IDM
        getRequestService: function getRequestService(config) {
            var _this = this;

            var baseURL = idmContext,
                timeout = 5000,
                headers = {
                'content-type': 'application/json',
                'cache-control': 'no-cache',
                'x-requested-with': 'XMLHttpRequest'
            },
                instance = void 0;

            if (config) {
                if (config.baseURL) {
                    baseURL = config.baseURL;
                }

                if (config.timeout) {
                    timeout = config.timeout;
                }

                if (config.headers && !lodash_default.a.isEmpty(config.headers)) {
                    headers = config.headers;
                }
            }

            headers = lodash_default.a.extend(headers, this.$root.applicationStore.state.authHeaders || {});

            instance = axios_default.a.create({
                baseURL: baseURL,
                timeout: timeout,
                headers: headers
            });

            instance.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                if (error.response && error.response.data && error.response.data.code === 401) {
                    if (_this.$route.name !== 'Login') {
                        Application.setLoginRedirect({
                            name: _this.$route.name,
                            params: _this.$route.params
                        });
                    }
                    _this.$router.push({ name: 'Login' });

                    return promise_default.a.reject(error);
                } else if (lodash_default.a.isUndefined(error.response)) {
                    // In the case of critical error
                    return promise_default.a.reject(new Error(error.message));
                } else {
                    return promise_default.a.reject(error);
                }
            });

            return instance;
        },
        // Headers used for oauth requests and selfservice
        getAnonymousHeaders: function getAnonymousHeaders() {
            var headers = this.$root.applicationStore.state.authHeaders || {
                'X-OpenIDM-NoSession': true,
                'X-OpenIDM-Password': 'anonymous',
                'X-OpenIDM-Username': 'anonymous'
            };

            return headers;
        },
        // Display a application notification
        displayNotification: function displayNotification(notificationType, message) {
            /* istanbul ignore next */
            this.$notify({
                group: 'IDMMessages',
                type: notificationType,
                text: message
            });
        },
        // Log a user out of their existing session (both normal and fullstack)
        logoutUser: function logoutUser() {
            var _this2 = this;

            /* istanbul ignore next */
            var idmInstance = this.getRequestService({
                headers: this.getAnonymousHeaders()
            });

            /* istanbul ignore next */
            idmInstance.post('/authentication?_action=logout').then(function (response) {
                _this2.$root.userStore.clearStoreAction();

                /*
                    In case of oauth + openAM we should always make sure these session variables are cleared on logout
                 */
                sessionStorage.removeItem('amToken');
                sessionStorage.removeItem('resubmitDataStoreToken');
                _this2.$root.applicationStore.clearAuthHeadersAction();
                _this2.$root.applicationStore.clearLoginRedirect();

                _this2.$router.push({ name: 'Login' });
            });
        },
        // Check if progressive profile is needed
        progressiveProfileCheck: function progressiveProfileCheck(userDetails, continueLogin, updateApiType) {
            if (lodash_default.a.has(userDetails, 'data.authorization.requiredProfileProcesses') && !lodash_default.a.isNull(userDetails.data.authorization.requiredProfileProcesses) && userDetails.data.authorization.requiredProfileProcesses.length > 0) {
                var profileProcess = userDetails.data.authorization.requiredProfileProcesses[0].split('/')[1];

                if (updateApiType) {
                    this.apiType = profileProcess;
                }

                this.$router.push('/profileCompletion/' + profileProcess);
                // If we update the apiType we need to reload the selfServiceDetails with the fresh info.
                if (updateApiType) {
                    this.loadData();
                }
            } else {
                continueLogin();
            }
        },

        // One location for checking and redirecting a completed login for s user
        completeLogin: function completeLogin() {
            if (!lodash_default.a.isNull(this.$root.applicationStore.state.loginRedirect)) {
                this.$router.push(this.$root.applicationStore.state.loginRedirect);
                this.$root.applicationStore.clearLoginRedirect();
            } else {
                this.$router.push('/');
            }
        }
    }
});

/*
    We will load the application regardless
 */
var main_startApp = function startApp() {
    var idmInstance = axios_default.a.create({
        baseURL: idmContext,
        timeout: 5000,
        headers: {
            'X-OpenIDM-NoSession': true,
            'X-OpenIDM-Password': 'anonymous',
            'X-OpenIDM-Username': 'anonymous'
        }
    });

    axios_default.a.all([idmInstance.get('/info/uiconfig'), idmInstance.get('info/features?_queryFilter=true')]).then(axios_default.a.spread(function (uiConfig, availability) {
        if (uiConfig.data.configuration.lang) {
            i18n.locale = uiConfig.data.configuration.lang;
        }

        if (uiConfig.data.configuration.amDataEndpoints) {
            Application.setAmDataEndpointsAction(uiConfig.data.configuration.amDataEndpoints);
        }

        Application.setEnduserSelfservice(availability.data.result);

        return main_loadApp();
    })).catch(function () {
        return main_loadApp();
    });
},
    main_loadApp = function loadApp() {
    /* eslint-disable no-new */
    return new vue_esm["default"]({
        el: '#app',
        router: router,
        i18n: i18n,
        template: '<App/>',
        components: { App: src_App },
        data: {
            userStore: User,
            applicationStore: Application
        }
    });
};

main_startApp();

/***/ }),

/***/ "OMEJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OdVq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OstF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "STVR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"baseColor":"#007bff"};

/***/ }),

/***/ "WVcr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bXap":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c2jU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMW2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gU86":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hvFc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"baseColor":"#007bff"};

/***/ }),

/***/ "iIcj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lC5l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pw9W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rBbn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vYzz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wGgA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "weCJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wntQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xIO3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xYWi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yI8e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z1vY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a7e5d5c0734c30eb5095.js